import React from 'react';
import { cx, css } from 'emotion';
import { ThemeContext } from '@hig/theme-context';

function stylesheet(props, themeData) {
  var color = props.color,
      customStylesheet = props.stylesheet;

  var fillColor = color || themeData["colorScheme.icon.default"];

  var styles = {
    fill: fillColor,
    "> *": {
      fill: fillColor
    }
  };

  return customStylesheet ? customStylesheet(styles, props, themeData) : styles;
}

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var Error12SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({ width: "12", height: "12", viewBox: "0 0 12 12", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6 0L0 6l6 6 6-6-6-6zm-.5 6.773c0 .124.11.227.25.227h.5c.14 0 .25-.103.25-.227L7 3.46C7 3.33 6.47 3 6.33 3h-.66c-.14 0-.67.33-.67.46l.5 3.313zM6 8c-.552 0-1 .224-1 .5s.448.5 1 .5 1-.224 1-.5S6.552 8 6 8z", fill: "#000" }));
});

var _extends$1 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$1(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var Complete12SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$1(_ref, ["styles"]);

  return React.createElement("svg", _extends$1({ width: "12", height: "12", viewBox: "0 0 12 12", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M.75 6a5.25 5.25 0 1 1 10.5 0A5.25 5.25 0 0 1 .75 6zm2.145.862l2.453 2.063 3.75-4.853-.848-.652-3.067 3.968-1.598-1.35-.69.824z", fill: "#000" }));
});

var _extends$2 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$2(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var Alert12SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$2(_ref, ["styles"]);

  return React.createElement("svg", _extends$2({ width: "12", height: "12", viewBox: "0 0 12 12", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M.035 10.77L5.815.115A.241.241 0 0 1 6.018 0c.08 0 .156.043.202.115l5.75 10.655c.09.156-.037.23-.209.23H.244c-.21 0-.3-.074-.21-.23zM5.75 8h.5c.14 0 .25-.103.25-.227L7 4.46C7 4.33 6.47 4 6.33 4h-.66c-.14 0-.67.33-.67.46l.5 3.313c0 .124.11.227.25.227zM6 9c-.552 0-1 .224-1 .5s.448.5 1 .5 1-.224 1-.5S6.552 9 6 9z", fill: "#000" }));
});

var _extends$3 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$3(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var OperatorPlusXsUISVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$3(_ref, ["styles"]);

  return React.createElement("svg", _extends$3({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props), React.createElement("path", { d: "M7 7V4h2v3h3v2H9v3H7V9H4V7h3z" }));
});

var _extends$4 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$4(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var OperatorPlusSUISVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$4(_ref, ["styles"]);

  return React.createElement("svg", _extends$4({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props), React.createElement("path", { d: "M7 7V2h2v5h5v2H9v5H7V9H2V7h5z" }));
});

var _extends$5 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$5(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var OperatorMinusXsUISVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$5(_ref, ["styles"]);

  return React.createElement("svg", _extends$5({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props), React.createElement("path", { d: "M4 7h8v2H4z" }));
});

var _extends$6 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$6(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var OperatorMinusSUISVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$6(_ref, ["styles"]);

  return React.createElement("svg", _extends$6({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props), React.createElement("path", { d: "M2 7h12v2H2V7z" }));
});

var _extends$7 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$7(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var HamburgerDefaultUISVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$7(_ref, ["styles"]);

  return React.createElement("svg", _extends$7({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props), React.createElement("path", { d: "M0 2h16v2H0zm0 5h16v2H0zm0 5h16v2H0z" }));
});

var _extends$8 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$8(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var HamburgerCloseUISVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$8(_ref, ["styles"]);

  return React.createElement("svg", _extends$8({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props), React.createElement("path", { d: "M7.8 6.4L14.2 0l1.4 1.4-6.4 6.4 6.5 6.5-1.4 1.4-6.5-6.5-6.4 6.4L0 14.2l6.4-6.4L0 1.4 1.4 0z" }));
});

var _extends$9 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$9(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var CloseXsUISVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$9(_ref, ["styles"]);

  return React.createElement("svg", _extends$9({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props), React.createElement("path", { d: "M11.4 5.4l-.8-.8L8 7.3 5.4 4.6l-.8.8L7.3 8l-2.7 2.6.8.8L8 8.7l2.6 2.7.8-.8L8.7 8l2.7-2.6z" }));
});

var _extends$10 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$10(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var CloseSUISVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$10(_ref, ["styles"]);

  return React.createElement("svg", _extends$10({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props), React.createElement("path", { d: "M13.4 3.4l-.8-.8L8 7.3 3.4 2.6l-.8.8L7.3 8l-4.7 4.6.8.8L8 8.7l4.6 4.7.8-.8L8.7 8l4.7-4.6z" }));
});

var _extends$11 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$11(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var CloseMUISVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$11(_ref, ["styles"]);

  return React.createElement("svg", _extends$11({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props), React.createElement("path", { d: "M14.4 2.4l-.8-.8L8 7.3 2.4 1.6l-.8.8L7.3 8l-5.7 5.6.8.8L8 8.7l5.6 5.7.8-.8L8.7 8l5.7-5.6z" }));
});

var _extends$12 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$12(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var CloseLUISVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$12(_ref, ["styles"]);

  return React.createElement("svg", _extends$12({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props), React.createElement("path", { d: "M15.4 1.4l-.8-.8L8 7.3 1.4.6l-.8.8L7.3 8 .6 14.6l.8.8L8 8.7l6.6 6.7.8-.8L8.7 8l6.7-6.6z" }));
});

var _extends$13 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$13(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var CheckmarkXsUISVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$13(_ref, ["styles"]);

  return React.createElement("svg", _extends$13({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props), React.createElement("path", { d: "M4.2 8.6l1.4-1.5 1.7 1.5 3.6-4 1.5 1.3-5 5.5-3.2-2.8z" }));
});

var _extends$14 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$14(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var CheckmarkSUISVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$14(_ref, ["styles"]);

  return React.createElement("svg", _extends$14({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props), React.createElement("path", { d: "M6.2 12L2 8.1l1.3-1.3 2.9 2.7L12.7 3 14 4.3 6.2 12z" }));
});

var _extends$15 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$15(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var CaretUpXsUISVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$15(_ref, ["styles"]);

  return React.createElement("svg", _extends$15({ xmlns: "http://www.w3.org/2000/svg", width: "5", height: "3", viewBox: "0 0 5 3" }, props), React.createElement("path", { d: "M2.5 0L5 3H0l2.5-3z" }));
});

var _extends$16 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$16(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var CaretUpSUISVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$16(_ref, ["styles"]);

  return React.createElement("svg", _extends$16({ xmlns: "http://www.w3.org/2000/svg", width: "7", height: "4", viewBox: "0 0 7 4" }, props), React.createElement("path", { d: "M3.5 0L7 4H0l3.5-4z" }));
});

var _extends$17 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$17(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var CaretUpMUISVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$17(_ref, ["styles"]);

  return React.createElement("svg", _extends$17({ xmlns: "http://www.w3.org/2000/svg", width: "10", height: "10", viewBox: "0 0 10 10" }, props), React.createElement("path", { d: "M8.71 6.78a.75.75 0 0 1-1.06 0L5 4.13 2.35 6.78a.75.75 0 0 1-1.06 0 .74.74 0 0 1 0-1.06l3.36-3.36a.5.5 0 0 1 .7 0l3.36 3.36a.74.74 0 0 1 0 1.06z" }));
});

var _extends$18 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$18(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var CaretRightXsUISVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$18(_ref, ["styles"]);

  return React.createElement("svg", _extends$18({ xmlns: "http://www.w3.org/2000/svg", width: "3", height: "5", viewBox: "0 0 3 5" }, props), React.createElement("path", { d: "M3 2.5L0 5V0l3 2.5z" }));
});

var _extends$19 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$19(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var CaretRightSUISVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$19(_ref, ["styles"]);

  return React.createElement("svg", _extends$19({ xmlns: "http://www.w3.org/2000/svg", width: "4", height: "7", viewBox: "0 0 4 7" }, props), React.createElement("path", { d: "M0 7V0l4 3.5L0 7z" }));
});

var _extends$20 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$20(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var CaretRightMUISVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$20(_ref, ["styles"]);

  return React.createElement("svg", _extends$20({ xmlns: "http://www.w3.org/2000/svg", width: "10", height: "10", viewBox: "0 0 10 10" }, props), React.createElement("path", { d: "M3.22 1.29a.75.75 0 0 0 0 1.06L5.87 5 3.22 7.65a.75.75 0 0 0 0 1.06.74.74 0 0 0 1.06 0l3.36-3.36a.5.5 0 0 0 0-.7L4.28 1.29a.74.74 0 0 0-1.06 0z" }));
});

var _extends$21 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$21(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var CaretLeftXsUISVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$21(_ref, ["styles"]);

  return React.createElement("svg", _extends$21({ xmlns: "http://www.w3.org/2000/svg", width: "3", height: "5", viewBox: "0 0 3 5" }, props), React.createElement("path", { d: "M3 0v5L0 2.5 3 0z" }));
});

var _extends$22 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$22(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var CaretLeftSUISVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$22(_ref, ["styles"]);

  return React.createElement("svg", _extends$22({ xmlns: "http://www.w3.org/2000/svg", width: "4", height: "7", viewBox: "0 0 4 7" }, props), React.createElement("path", { d: "M0 3.5L4 0v7L0 3.5z" }));
});

var _extends$23 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$23(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var CaretLeftMUISVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$23(_ref, ["styles"]);

  return React.createElement("svg", _extends$23({ xmlns: "http://www.w3.org/2000/svg", width: "10", height: "10", viewBox: "0 0 10 10" }, props), React.createElement("path", { d: "M6.78 8.71a.75.75 0 0 0 0-1.06L4.13 5l2.65-2.65a.75.75 0 0 0 0-1.06.74.74 0 0 0-1.06 0L2.36 4.65a.5.5 0 0 0 0 .7l3.36 3.36a.74.74 0 0 0 1.06 0z" }));
});

var _extends$24 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$24(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var CaretDownXsUISVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$24(_ref, ["styles"]);

  return React.createElement("svg", _extends$24({ xmlns: "http://www.w3.org/2000/svg", width: "5", height: "3", viewBox: "0 0 5 3" }, props), React.createElement("path", { d: "M0 0h5L2.5 3 0 0z" }));
});

var _extends$25 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$25(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var CaretDownSUISVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$25(_ref, ["styles"]);

  return React.createElement("svg", _extends$25({ xmlns: "http://www.w3.org/2000/svg", width: "7", height: "4", viewBox: "0 0 7 4" }, props), React.createElement("path", { d: "M0 0h7L3.5 4 0 0z" }));
});

var _extends$26 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$26(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var CaretDownMUISVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$26(_ref, ["styles"]);

  return React.createElement("svg", _extends$26({ xmlns: "http://www.w3.org/2000/svg", width: "10", height: "10", viewBox: "0 0 10 10" }, props), React.createElement("path", { d: "M8.71 3.22a.75.75 0 0 0-1.06 0L5 5.87 2.35 3.22a.75.75 0 0 0-1.06 0 .74.74 0 0 0 0 1.06l3.36 3.36a.5.5 0 0 0 .7 0l3.36-3.36a.74.74 0 0 0 0-1.06z" }));
});

var _extends$27 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$27(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var ZoomOut16SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$27(_ref, ["styles"]);

  return React.createElement("svg", _extends$27({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props), React.createElement("path", { d: "M10.297 11.706l1.414-1.414 4.002 4.002-1.414 1.414zM6 0a6 6 0 1 0 6 6 6 6 0 0 0-6-6zm0 10.5A4.5 4.5 0 1 1 10.5 6 4.51 4.51 0 0 1 6 10.5z" }), React.createElement("path", { d: "M3 5h6v2H3z" }));
});

var _extends$28 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$28(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var ZoomIn16SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$28(_ref, ["styles"]);

  return React.createElement("svg", _extends$28({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props), React.createElement("path", { d: "M10.297 11.706l1.414-1.414 4.002 4.002-1.414 1.414zM6 0a6 6 0 1 0 6 6 6 6 0 0 0-6-6zm0 10.5A4.5 4.5 0 1 1 10.5 6 4.51 4.51 0 0 1 6 10.5z" }), React.createElement("path", { d: "M7 3H5v2H3v2h2v2h2V7h2V5H7V3z" }));
});

var _extends$29 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$29(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var Volume16SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$29(_ref, ["styles"]);

  return React.createElement("svg", _extends$29({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props), React.createElement("path", { d: "M4 12l5 4V-.08l-5 4V12zM0 4h3v8H0zm13.08-1.83l-.29.41a.3.3 0 0 0 0 .38 6.94 6.94 0 0 1 0 10.08.3.3 0 0 0 0 .38l.29.41a.21.21 0 0 0 .33 0 7.95 7.95 0 0 0 0-11.74.21.21 0 0 0-.33.08z" }), React.createElement("path", { d: "M11.07 10.53a.33.33 0 0 0 0 .39l.3.43a.19.19 0 0 0 .31 0 4.93 4.93 0 0 0 0-6.76.19.19 0 0 0-.31 0l-.3.43a.33.33 0 0 0 0 .39 3.91 3.91 0 0 1 0 5.06z" }));
});

var _extends$30 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$30(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var Visible16SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$30(_ref, ["styles"]);

  return React.createElement("svg", _extends$30({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props), React.createElement("path", { d: "M5 8a3 3 0 1 1 3 3 3 3 0 0 1-3-3zM0 8a9.36 9.36 0 0 0 8 5 9.37 9.37 0 0 0 8-5 9.42 9.42 0 0 0-8-5 9.46 9.46 0 0 0-8 5zm6 0a2 2 0 1 0 2-2 2 2 0 0 0-2 2z" }));
});

var _extends$31 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$31(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var UserInactive16SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$31(_ref, ["styles"]);

  return React.createElement("svg", _extends$31({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props), React.createElement("path", { d: "M7 7c1.62 0 2.86-1.79 2.86-3.41A3.08 3.08 0 0 0 7 .44a2.93 2.93 0 0 0-2.87 3v.18C4.14 5.58 5.38 7 7 7zm-.25 5.5a4.76 4.76 0 0 1 3-4.41 5.58 5.58 0 0 0-2.38-.59h-.65C4.39 7.6 2.07 8.84 2 12.19V16h6.32a4.71 4.71 0 0 1-1.57-3.5z" }), React.createElement("path", { d: "M11.5 9a3.5 3.5 0 1 0 3.5 3.5A3.5 3.5 0 0 0 11.5 9zM9 13v-1h5v1z" }));
});

var _extends$32 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$32(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var Upload16SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$32(_ref, ["styles"]);

  return React.createElement("svg", _extends$32({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props), React.createElement("path", { d: "M6.14 12h3.69V6.75h2.96L7.99 0l-4.8 6.75h2.95V12z" }), React.createElement("path", { d: "M14 11v3H2v-3H0v5h16v-5h-2z" }));
});

var _extends$33 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$33(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var Up16SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$33(_ref, ["styles"]);

  return React.createElement("svg", _extends$33({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props), React.createElement("path", { d: "M14 8L8 0 2 8h3.5v8h5V8z", fillRule: "evenodd" }));
});

var _extends$34 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$34(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var Unpin16SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$34(_ref, ["styles"]);

  return React.createElement("svg", _extends$34({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props), React.createElement("path", { d: "M3.75 10.49L.32 15.54l5.04-3.45-1.61-1.6zm-.29-4.61h-.55L1.74 7.06l7.07 7.07 1.17-1.18v-.51L3.46 5.88zm3.93-1.12l3.69 3.74 1.71-1.7.97.97 2.12-2.13-5.66-5.65L8.1 2.11l.97.97-1.68 1.68zM2.4 1.13L1.26 2.25l12.28 12.36 1.12-1.05L2.4 1.13z" }));
});

var _extends$35 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$35(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var Unlock16SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$35(_ref, ["styles"]);

  return React.createElement("svg", _extends$35({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props), React.createElement("path", { d: "M12.5 0A3.5 3.5 0 0 0 9 3.5V6H2v9h11V6h-2V3.5a1.5 1.5 0 0 1 3 0V6h2V3.5A3.5 3.5 0 0 0 12.5 0zM8 12H7V9h1z" }));
});

var _extends$36 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$36(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var Unlink16SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$36(_ref, ["styles"]);

  return React.createElement("svg", _extends$36({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props), React.createElement("path", { d: "M11.12 2.76a1.51 1.51 0 0 1 2.12 0 1.49 1.49 0 0 1 0 2.12l-2.85 2.86 1.41 1.42 2.86-2.86a3.5 3.5 0 0 0-4.95-4.95L6.88 4.18l1.4 1.42zM4.77 13.37a1.5 1.5 0 0 1-2.12-2.12L5.5 8.39 4.09 7 1.24 9.84a3.5 3.5 0 0 0 5 4.95L9 12l-1.4-1.43zM1.26 2.53l12.28 12.36 1.12-1.05L2.4 1.41 1.26 2.53z" }));
});

var _extends$37 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$37(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var Undo16SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$37(_ref, ["styles"]);

  return React.createElement("svg", _extends$37({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props), React.createElement("path", { d: "M8 3L0 8l8 5v-3h4a4.11 4.11 0 0 1 4 2.19v-.92C16 8.5 14.25 6 11.49 6H8V3z" }));
});

var _extends$38 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$38(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var Unavailable16SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$38(_ref, ["styles"]);

  return React.createElement("svg", _extends$38({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props), React.createElement("path", { d: "M8 1a7 7 0 1 0 7 7 7 7 0 0 0-7-7zM3 9V7h10v2z" }));
});

var _extends$39 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$39(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var TreeView16SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$39(_ref, ["styles"]);

  return React.createElement("svg", _extends$39({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props), React.createElement("path", { d: "M16 10V5H9v2H4V4h3V0H0v4h3v10h6v2h7v-5H9v2H4V8h5v2h7z" }));
});

var _extends$40 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$40(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var Trash16SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$40(_ref, ["styles"]);

  return React.createElement("svg", _extends$40({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props), React.createElement("path", { d: "M10 2H6v-.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5zM5 2H2v2h12V2h-3V0H5zM3 5h10v11H3z" }));
});

var _extends$41 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$41(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var Tag16SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$41(_ref, ["styles"]);

  return React.createElement("svg", _extends$41({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props), React.createElement("path", { d: "M7.69 1H1v6.92L8.29 15 15 8.25zM4.5 6A1.5 1.5 0 1 1 6 4.5 1.5 1.5 0 0 1 4.5 6z" }));
});

var _extends$42 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$42(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var Sync16SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$42(_ref, ["styles"]);

  return React.createElement("svg", _extends$42({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props), React.createElement("path", { d: "M8 13a5.62 5.62 0 0 1-4.11-1.82L6 9.62l-6-2 .16 6.28 2.1-1.55A7.56 7.56 0 0 0 15 10.25l-1.9-.64A5.57 5.57 0 0 1 8 13zM8 .94a7.58 7.58 0 0 0-7 4.84l1.94.64a5.53 5.53 0 0 1 9.22-1.63L10 6.32l6 2L15.84 2l-2.1 1.55A7.62 7.62 0 0 0 8 .94z" }));
});

var _extends$43 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$43(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var SurveyEquipment16SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$43(_ref, ["styles"]);

  return React.createElement("svg", _extends$43({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props), React.createElement("path", { d: "M13 2h-1v9h1v3h1a1 1 0 0 0 1-1V9zM4 14a1 1 0 0 0 1 1v1h6v-1a1 1 0 0 0 1-1v-2H4zm2-4h4a1 1 0 0 0 1-1V1a1 1 0 0 0-1-1H6a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1zm2-7a2 2 0 1 1-2 2 2 2 0 0 1 2-2zM4 2H3L1 9v4a1 1 0 0 0 1 1h1v-3h1z" }));
});

var _extends$44 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$44(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var Support16SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$44(_ref, ["styles"]);

  return React.createElement("svg", _extends$44({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props), React.createElement("path", { d: "M8 0a8 8 0 1 0 8 8 8 8 0 0 0-8-8zm4.28 12.11c-.3.38-1.18 1.38-2.11 1.14-3.48-.93-6.51-6.06-5.57-9.6.25-.93 1.55-1.2 2-1.26a.24.24 0 0 1 .25.14L7.86 5a.21.21 0 0 1-.09.26 4.14 4.14 0 0 1-1.88.64c-.46 1.73 1.32 4.72 3 5.16.11-.5 1.11-1.14 1.47-1.38a.23.23 0 0 1 .27.05l1.64 2.09a.26.26 0 0 1 .01.29z" }));
});

var _extends$45 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$45(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var Subscription16SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$45(_ref, ["styles"]);

  return React.createElement("svg", _extends$45({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props), React.createElement("path", { d: "M3 3h2v2H3zm3 0h4v2H6zM3 6h2v2H3zm0 3h2v2H3zm5 0H6v2h1.1A4.84 4.84 0 0 1 8 9z" }), React.createElement("path", { d: "M15.94 11.44l-1.24.11a2.3 2.3 0 0 1 .05.45 2.79 2.79 0 1 1-1.68-2.52l-.74 1.29 3.55-.33-1.47-3.25-.7 1.21A3.94 3.94 0 0 0 12 8a4 4 0 1 0 4 4 3.43 3.43 0 0 0-.06-.56z", fillRule: "evenodd" }), React.createElement("path", { d: "M10 7.42V6H6v2h3a5.53 5.53 0 0 1 1-.58z" }), React.createElement("path", { d: "M7 12H2V2h9v5.1a5.05 5.05 0 0 1 2 0V0H0v15h8a4.92 4.92 0 0 1-1-3z" }));
});

var _extends$46 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$46(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var Sort16SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$46(_ref, ["styles"]);

  return React.createElement("svg", _extends$46({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props), React.createElement("path", { fillRule: "evenodd", d: "M13.54 9.38V3h-3.08v6.38H8L12 15l4-5.62h-2.46zM4 1L0 6.63h2.46V13h3.08V6.63H8L4 1z" }));
});

var _extends$47 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$47(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var SocialYoutube16SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$47(_ref, ["styles"]);

  return React.createElement("svg", _extends$47({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props), React.createElement("path", { d: "M15.67 3.87a2.11 2.11 0 0 0-1.42-1.51A44.44 44.44 0 0 0 8 2a44.44 44.44 0 0 0-6.25.36A2.11 2.11 0 0 0 .33 3.87 24.23 24.23 0 0 0 0 8a24.23 24.23 0 0 0 .33 4.13 2.11 2.11 0 0 0 1.42 1.51A44.44 44.44 0 0 0 8 14a44.44 44.44 0 0 0 6.25-.36 2.11 2.11 0 0 0 1.42-1.51A24.23 24.23 0 0 0 16 8a24.23 24.23 0 0 0-.33-4.13zM6 11V5l5 3z" }));
});

var _extends$48 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$48(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var SocialTwitter16SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$48(_ref, ["styles"]);

  return React.createElement("svg", _extends$48({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props), React.createElement("path", { d: "M16 3.54a6.61 6.61 0 0 1-1.89.52 3.32 3.32 0 0 0 1.45-1.82 6.62 6.62 0 0 1-2.09.8 3.28 3.28 0 0 0-5.68 2.24 3.08 3.08 0 0 0 .09.72 9.32 9.32 0 0 1-6.77-3.4A3.29 3.29 0 0 0 2.13 7a3.29 3.29 0 0 1-1.49-.43 3.28 3.28 0 0 0 2.64 3.26 3.22 3.22 0 0 1-1.49.06 3.3 3.3 0 0 0 3.07 2.28 6.58 6.58 0 0 1-4.08 1.4 5.11 5.11 0 0 1-.78-.05A9.22 9.22 0 0 0 5 15a9.27 9.27 0 0 0 9.34-9.34v-.42A6.79 6.79 0 0 0 16 3.54z" }));
});

var _extends$49 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$49(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var SocialLinkedin16SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$49(_ref, ["styles"]);

  return React.createElement("svg", _extends$49({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props), React.createElement("path", { d: "M2.34 6h2.29v7H2.34zM2 3.5A1.5 1.5 0 1 1 3.5 5 1.5 1.5 0 0 1 2 3.5zM6 6h2v1c1.81-2 5-.9 5 1.12V13h-2.13V8.79c0-1.19-1.73-1.51-2.74-.19V13H6zM0 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2a2 2 0 0 0-2 2z" }));
});

var _extends$50 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$50(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var SocialInstagram16SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$50(_ref, ["styles"]);

  return React.createElement("svg", _extends$50({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props), React.createElement("path", { d: "M8 1.44c2.14 0 2.39 0 3.23.05a4.33 4.33 0 0 1 1.49.27 2.67 2.67 0 0 1 1.52 1.52 4.33 4.33 0 0 1 .27 1.49c0 .84.05 1.09.05 3.23s0 2.39-.05 3.23a4.33 4.33 0 0 1-.27 1.49 2.67 2.67 0 0 1-1.52 1.52 4.33 4.33 0 0 1-1.49.27c-.84 0-1.09.05-3.23.05s-2.39 0-3.23-.05a4.33 4.33 0 0 1-1.49-.27 2.67 2.67 0 0 1-1.52-1.52 4.33 4.33 0 0 1-.27-1.49c0-.84-.05-1.09-.05-3.23s0-2.39.05-3.23a4.33 4.33 0 0 1 .27-1.49 2.67 2.67 0 0 1 1.52-1.52 4.33 4.33 0 0 1 1.49-.27c.84 0 1.09-.05 3.23-.05M8 0C5.83 0 5.55 0 4.7.05a5.85 5.85 0 0 0-1.94.37A4 4 0 0 0 .42 2.76 5.85 5.85 0 0 0 .05 4.7C0 5.55 0 5.83 0 8s0 2.45.05 3.3a5.85 5.85 0 0 0 .37 1.94 4 4 0 0 0 2.34 2.34A5.85 5.85 0 0 0 4.7 16H8c2.17 0 2.44 0 3.3-.05a5.85 5.85 0 0 0 1.94-.37 4 4 0 0 0 2.34-2.34A5.85 5.85 0 0 0 16 11.3c0-.85.05-1.13.05-3.3S16 5.55 16 4.7a5.85 5.85 0 0 0-.37-1.94A4 4 0 0 0 13.24.42 5.85 5.85 0 0 0 11.3.05C10.44 0 10.17 0 8 0z" }), React.createElement("path", { d: "M8 3.89A4.11 4.11 0 1 0 12.11 8 4.11 4.11 0 0 0 8 3.89zm0 6.78A2.67 2.67 0 1 1 10.67 8 2.68 2.68 0 0 1 8 10.67z" }), React.createElement("circle", { cx: "12.27", cy: "3.73", r: ".96" }));
});

var _extends$51 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$51(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var SocialFacebook16SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$51(_ref, ["styles"]);

  return React.createElement("svg", _extends$51({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props), React.createElement("path", { d: "M15 0H1a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h8.07V9.61H7V7.13h2.07V5.29A3 3 0 0 1 11.76 2h.39a16.26 16.26 0 0 1 1.85.1v2.22h-1.27c-1 0-1.19.49-1.19 1.21v1.6h2.37l-.31 2.49h-2.06V16H15a1 1 0 0 0 1-1V1a1 1 0 0 0-1-1z" }));
});

var _extends$52 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$52(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var SocialBlog16SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$52(_ref, ["styles"]);

  return React.createElement("svg", _extends$52({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props), React.createElement("circle", { cx: "3", cy: "13", r: "2" }), React.createElement("path", { d: "M1.5 1H1v2h.5A11.5 11.5 0 0 1 13 14.5v.5h2v-.5A13.49 13.49 0 0 0 1.5 1z" }), React.createElement("path", { d: "M1.5 6H1v2a4.19 4.19 0 0 1 .5 0A6.5 6.5 0 0 1 8 14.5a4.19 4.19 0 0 1 0 .5h2v-.5A8.51 8.51 0 0 0 1.5 6z" }));
});

var _extends$53 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$53(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var Share16SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$53(_ref, ["styles"]);

  return React.createElement("svg", _extends$53({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props), React.createElement("path", { d: "M10 2.5a2.37 2.37 0 0 0 .18.93L5 6.53A2.47 2.47 0 0 0 3.5 6a2.5 2.5 0 1 0 1.86 4.18l4.7 2.8a2.24 2.24 0 0 0-.06.52 2.5 2.5 0 1 0 2.5-2.5 2.45 2.45 0 0 0-1.86.84L6 9a2.87 2.87 0 0 0 0-.5 2.72 2.72 0 0 0-.18-1L11 4.47a2.5 2.5 0 1 0-1-2z" }));
});

var _extends$54 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$54(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var Settings16SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$54(_ref, ["styles"]);

  return React.createElement("svg", _extends$54({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props), React.createElement("path", { d: "M15 9V6h-2.21a5.34 5.34 0 0 0-.49-1.18l1.56-1.56-2.12-2.12-1.56 1.56A5.34 5.34 0 0 0 9 2.21V0H6v2.21a5.34 5.34 0 0 0-1.18.49L3.26 1.14 1.14 3.26 2.7 4.82A5.34 5.34 0 0 0 2.21 6H0v3h2.21a5.34 5.34 0 0 0 .49 1.18l-1.56 1.56 2.12 2.12 1.56-1.56a5.34 5.34 0 0 0 1.18.49V15h3v-2.21a5.34 5.34 0 0 0 1.18-.49l1.56 1.56 2.12-2.12-1.56-1.56A5.34 5.34 0 0 0 12.79 9zm-5-1.5A2.48 2.48 0 1 1 7.52 5 2.5 2.5 0 0 1 10 7.5z" }));
});

var _extends$55 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$55(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var Service16SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$55(_ref, ["styles"]);

  return React.createElement("svg", _extends$55({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props), React.createElement("path", { d: "M8 0a8 8 0 0 0-6.63 12.48L4.81 9a4 4 0 0 1 5.55-5l-2.8 2.79.1 1.55 1.55.1L12 5.64a4 4 0 0 1-5 5.55l-3.48 3.44A8 8 0 1 0 8 0z" }));
});

var _extends$56 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$56(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var SelectNone16SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$56(_ref, ["styles"]);

  return React.createElement("svg", _extends$56({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props), React.createElement("path", { d: "M13 4v2h1v8H6v-1H4v3h12V4h-3z" }), React.createElement("path", { d: "M12 0H0v12h12zm-2 10H2V2h8z" }));
});

var _extends$57 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$57(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var SelectAll16SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$57(_ref, ["styles"]);

  return React.createElement("svg", _extends$57({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props), React.createElement("path", { d: "M13 4v9H4v3h12V4h-3z" }), React.createElement("path", { d: "M12 0H0v12h12zM5 9.37L1.65 6 3 4.65l2 2 4-5L10.34 3z" }));
});

var _extends$58 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$58(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var Security16SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$58(_ref, ["styles"]);

  return React.createElement("svg", _extends$58({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props), React.createElement("path", { d: "M14.15 2.65A8.54 8.54 0 0 1 8 0a8.54 8.54 0 0 1-6.15 2.65H1C1 12.79 7.25 16 8 16s7-3.21 7-13.39c-.18.02-.56.04-.85.04z" }));
});

var _extends$59 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$59(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var Search16SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$59(_ref, ["styles"]);

  return React.createElement("svg", _extends$59({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props), React.createElement("path", { d: "M10.297 11.706l1.414-1.414 4.002 4.002-1.414 1.414zM6 0a6 6 0 1 0 6 6 6 6 0 0 0-6-6zm0 10.5A4.5 4.5 0 1 1 10.5 6 4.51 4.51 0 0 1 6 10.5z" }));
});

var _extends$60 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$60(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var Save16SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$60(_ref, ["styles"]);

  return React.createElement("svg", _extends$60({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props), React.createElement("path", { d: "M15 1H1v11l3 3h11zm-4 13h-1v-3H6v3H5v-4h6zm1-7H4V2h1v4h6V2h1z" }));
});

var _extends$61 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$61(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var SaveAs16SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$61(_ref, ["styles"]);

  return React.createElement("svg", _extends$61({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props), React.createElement("path", { d: "M6.86 12.93L6 16l3.07-.86h.01l-2.22-2.22v.01zm.713-.71l4.1-4.102 2.214 2.213-4.101 4.102zM14.12 6h-.19a.62.62 0 0 0-.32.17l-1.23 1.24 2.21 2.21 1.23-1.23a.62.62 0 0 0 .18-.32v-.15A1.88 1.88 0 0 0 14.12 6zM5 11v2H4v-3h4.37l4.53-4.53a1.67 1.67 0 0 1 .83-.47H14V0H0v11l3 3h2.52L6 12.4 7.37 11zM3 1h1v4h6V1h1v5H3z" }));
});

var _extends$62 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$62(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var Report16SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$62(_ref, ["styles"]);

  return React.createElement("svg", _extends$62({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props), React.createElement("path", { d: "M15 0H1v16h14zM3 4h5v1H3zm10 10H3v-1h1V8h2v5h1v-3h2v3h1V6h2v7h1zm0-11H3V2h10z" }));
});

var _extends$63 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$63(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var Redo16SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$63(_ref, ["styles"]);

  return React.createElement("svg", _extends$63({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props), React.createElement("path", { d: "M8 3v3H4.5C1.74 6 0 8.5 0 11.27v.92A4.11 4.11 0 0 1 4 10h4v3l8-5-8-5z" }));
});

var _extends$64 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$64(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var Recommend16SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$64(_ref, ["styles"]);

  return React.createElement("svg", _extends$64({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props), React.createElement("path", { d: "M12.72 14.11s.07 0 .11-.11A1.26 1.26 0 0 0 14 12.75a1.23 1.23 0 0 0-.25-.75.25.25 0 0 1 0-.5 1.25 1.25 0 0 0 0-2.5.25.25 0 0 1-.25-.25.26.26 0 0 1 .27-.23A1.28 1.28 0 0 0 15 7.25 1.25 1.25 0 0 0 13.75 6h-5c0-1.44 1-2.56 1-4.95a1 1 0 1 0-2 0c0 2.24-4.17 5.24-4.17 6.8a1.08 1.08 0 0 1-.8.63 1 1 0 0 0-.72 1v3.91a1 1 0 0 0 .82 1 1.56 1.56 0 0 1 1 .72 4.52 4.52 0 0 0 2.78 1h4a2.1 2.1 0 0 0 2.06-2z" }));
});

var _extends$65 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$65(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var Quantities16SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$65(_ref, ["styles"]);

  return React.createElement("svg", _extends$65({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props), React.createElement("path", { d: "M0 11h16v3H0zM8 0v6h3v4h2V6h3V0zm7 3H9V1h6zM1 15h14v1H1z" }));
});

var _extends$66 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$66(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var Publish16SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$66(_ref, ["styles"]);

  return React.createElement("svg", _extends$66({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props), React.createElement("path", { d: "M15 12H1v4h14zm-3 3H4v-2h8z" }), React.createElement("path", { fillRule: "evenodd", d: "M6.37 5.91H3.79L7.99 0l4.2 5.91H9.61V10H6.37V5.91z" }));
});

var _extends$67 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$67(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var Properties16SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$67(_ref, ["styles"]);

  return React.createElement("svg", _extends$67({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props), React.createElement("path", { d: "M14 0H2v16h12zm-1 13h-2v1h-1v-1H3v-1h7v-1h1v1h2zm0-3H6v1H5v-1H3V9h2V8h1v1h7zm0-4H3V1h10z" }), React.createElement("path", { d: "M4 2h8v3H4z" }));
});

var _extends$68 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$68(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var ProjectManagement16SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$68(_ref, ["styles"]);

  return React.createElement("svg", _extends$68({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props), React.createElement("path", { d: "M6.61 9a5.51 5.51 0 0 1 1.74-2H2V6h7v.61A5.44 5.44 0 0 1 11 6V0H0v13h6.21a5.46 5.46 0 0 1 0-3H2V9zM2 3h7v1H2z" }), React.createElement("path", { d: "M15.37 9.1a3.59 3.59 0 0 0-1.47-1.47 4.57 4.57 0 0 0-6.27 6.27 3.59 3.59 0 0 0 1.47 1.47 4.57 4.57 0 0 0 6.27-6.27zM15 12h-4V8h1v3h3z" }));
});

var _extends$69 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$69(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var Profile16SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$69(_ref, ["styles"]);

  return React.createElement("svg", _extends$69({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props), React.createElement("path", { d: "M8 0a8 8 0 1 0 8 8 8 8 0 0 0-8-8zm0 3.36a2.46 2.46 0 0 1 2.3 2.53A2.65 2.65 0 0 1 8 8.62a2.48 2.48 0 0 1-2.28-2.73A2.35 2.35 0 0 1 8 3.36zm4 10.38a7 7 0 0 1-8 0v-1A3.62 3.62 0 0 1 7.79 9h.52c1.94.08 3.69 1.09 3.69 4z" }));
});

var _extends$70 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$70(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var ProductsAndServices16SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$70(_ref, ["styles"]);

  return React.createElement("svg", _extends$70({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props), React.createElement("path", { d: "M7.52 0L0 3.35v8.14L7.48 16 15 11.49V3.35zM14 4.44L7.92 8.12v6.47l-.42.25-.42-.25V8.12L1 4.43V4l.5-.23 6 3.65 6-3.64.5.22z" }));
});

var _extends$71 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$71(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var Print16SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$71(_ref, ["styles"]);

  return React.createElement("svg", _extends$71({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props), React.createElement("path", { d: "M14 3v2H2V3H0v10h2v-2h12v2h2V3h-2z" }), React.createElement("path", { d: "M3 0h10v4H3zm9 12v3H4v-3H3v4h10v-4h-1z" }), React.createElement("path", { d: "M5 12h6v2H5z" }));
});

var _extends$72 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$72(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var PlaybackStop16SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$72(_ref, ["styles"]);

  return React.createElement("svg", _extends$72({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props), React.createElement("path", { d: "M2 2h12v12H2z" }));
});

var _extends$73 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$73(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var PlaybackShuffle16SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$73(_ref, ["styles"]);

  return React.createElement("svg", _extends$73({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props), React.createElement("path", { d: "M3.8 5.4l1.33 1.77L6.38 5.5l-1-1.3A3 3 0 0 0 3 3H0v2h3a1 1 0 0 1 .8.4zM16 12l-4-3v2h-1a1 1 0 0 1-.8-.4L8.87 8.83 7.62 10.5l1 1.3A3 3 0 0 0 11 13h1v2z" }), React.createElement("path", { d: "M16 4l-4-3v2h-1a3 3 0 0 0-2.4 1.2l-4.8 6.4a1 1 0 0 1-.8.4H0v2h3a3 3 0 0 0 2.4-1.2l4.8-6.4A1 1 0 0 1 11 5h1v2z", fillRule: "evenodd" }));
});

var _extends$74 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$74(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var PlaybackRewind16SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$74(_ref, ["styles"]);

  return React.createElement("svg", _extends$74({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props), React.createElement("path", { d: "M8 8l8 5V3L8 8zM0 8l8 5V3L0 8z" }));
});

var _extends$75 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$75(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var PlaybackRecord16SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$75(_ref, ["styles"]);

  return React.createElement("svg", _extends$75({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props), React.createElement("circle", { cx: "8", cy: "8", r: "6" }));
});

var _extends$76 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$76(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var PlaybackPrevious16SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$76(_ref, ["styles"]);

  return React.createElement("svg", _extends$76({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props), React.createElement("path", { d: "M4 8l9 5.73V2.27L4 8zM2 2v12h2V2H2z" }));
});

var _extends$77 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$77(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var PlaybackPlay16SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$77(_ref, ["styles"]);

  return React.createElement("svg", _extends$77({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props), React.createElement("path", { d: "M14 8L3 15V1l11 7z" }), React.createElement("path", { d: "M14 8L3 15V1l11 7z" }));
});

var _extends$78 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$78(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var PlaybackPause16SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$78(_ref, ["styles"]);

  return React.createElement("svg", _extends$78({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props), React.createElement("path", { d: "M3 2h4v12H3zm6 0h4v12H9z" }));
});

var _extends$79 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$79(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var PlaybackNext16SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$79(_ref, ["styles"]);

  return React.createElement("svg", _extends$79({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props), React.createElement("path", { d: "M3 13.73L12 8 3 2.27v11.46zM12 2v12h2V2h-2z" }));
});

var _extends$80 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$80(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var PlaybackLoop16SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$80(_ref, ["styles"]);

  return React.createElement("svg", _extends$80({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props), React.createElement("path", { d: "M9 4L5 1v2H3a3 3 0 0 0-3 3v5a3 3 0 0 0 3 3h1v-2H3a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h2v2zm4-1h-1v2h1a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1h-2v-2l-4 3 4 3v-2h2a3 3 0 0 0 3-3V6a3 3 0 0 0-3-3z" }));
});

var _extends$81 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$81(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var PlaybackGoToStart16SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$81(_ref, ["styles"]);

  return React.createElement("svg", _extends$81({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props), React.createElement("path", { d: "M16 3L9 7.38V3L2 7.38V2H0v12h2V8.63L9 13V8.63L16 13V3z" }));
});

var _extends$82 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$82(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var PlaybackGoToEnd16SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$82(_ref, ["styles"]);

  return React.createElement("svg", _extends$82({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props), React.createElement("path", { d: "M14 2v5.38L7 3v4.38L0 3v10l7-4.37V13l7-4.37V14h2V2h-2z" }));
});

var _extends$83 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$83(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var PlaybackFastForward16SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$83(_ref, ["styles"]);

  return React.createElement("svg", _extends$83({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props), React.createElement("path", { d: "M0 13l8-5-8-5v10zm16-5L8 3v10l8-5z" }));
});

var _extends$84 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$84(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var Placeholder16SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$84(_ref, ["styles"]);

  return React.createElement("svg", _extends$84({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props), React.createElement("path", { d: "M13.3 12.58a7.22 7.22 0 0 1-2.38 1.79l.41.91a8 8 0 0 0 2.72-2l-.75-.65zM8.51 15a7.08 7.08 0 0 1-2.95-.42l-.35.94a8.05 8.05 0 0 0 3.37.48l-.07-1zm-5.09-1.7a7.36 7.36 0 0 1-1.79-2.38l-.9.41a7.92 7.92 0 0 0 2 2.72l.65-.75zM1 8.51a7.08 7.08 0 0 1 .42-2.95L.5 5.21A8.05 8.05 0 0 0 0 8.58l1-.07zm1.7-5.09a7.29 7.29 0 0 1 2.39-1.79l-.42-.9A8 8 0 0 0 2 2.77l.75.65zM7.49 1a7.08 7.08 0 0 1 2.95.42l.35-.92A8.05 8.05 0 0 0 7.42 0l.07 1zm5.09 1.7a7.16 7.16 0 0 1 1.79 2.39l.91-.42a8 8 0 0 0-2-2.72l-.65.75zM15 7.49a7.08 7.08 0 0 1-.42 2.95l.94.35A8.05 8.05 0 0 0 16 7.42l-1 .07z" }));
});

var _extends$85 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$85(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var Pin16SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$85(_ref, ["styles"]);

  return React.createElement("svg", _extends$85({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props), React.createElement("path", { d: "M10.22.1L8.1 2.22l1 1L6.24 6H2.91L1.74 7.17l7.07 7.07L10 13.06V9.74l2.83-2.83 1 1 2.12-2.12zM3.75 10.6L.32 15.66l5.04-3.45-1.61-1.61z" }));
});

var _extends$86 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$86(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var Photos16SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$86(_ref, ["styles"]);

  return React.createElement("svg", _extends$86({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props), React.createElement("path", { d: "M0 16h13V3H0zM9.5 5A1.5 1.5 0 1 1 8 6.5 1.5 1.5 0 0 1 9.5 5zM2 9.84l.29-.41a2 2 0 0 1 3.3 0l2.53 3.48a.28.28 0 0 0 .44 0l.95-1.17a1.23 1.23 0 0 1 1-.46 1.14 1.14 0 0 1 .52.13V14H2z" }), React.createElement("path", { d: "M14 0H1v2h13v12h2V0h-2z" }));
});

var _extends$87 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$87(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var PermissionIndividual16SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$87(_ref, ["styles"]);

  return React.createElement("svg", _extends$87({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props), React.createElement("path", { d: "M7.72 7.49C5.39 7.6 3.07 8.84 3 12.19V16h10v-3.5c0-3.64-2.2-4.9-4.63-5h-.65zM8 7c1.62 0 2.86-1.78 2.86-3.41A3.08 3.08 0 0 0 8 .44a2.93 2.93 0 0 0-2.86 3.17C5.14 5.58 6.38 7 8 7z" }));
});

var _extends$88 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$88(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var PermissionGroup16SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$88(_ref, ["styles"]);

  return React.createElement("svg", _extends$88({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props), React.createElement("path", { d: "M3.72 7.49C1.39 7.6.07 8.84 0 12.19V16h8v-3.5c0-3.64-1.2-4.9-3.63-5h-.65zM4 7c1.62 0 2.86-1.76 2.86-3.39A3.08 3.08 0 0 0 4 .44a2.93 2.93 0 0 0-2.86 3.17C1.14 5.58 2.38 7 4 7zm7.56 1.57c1.34 0 2.37-1.48 2.37-2.82a2.56 2.56 0 0 0-2.37-2.63 2.43 2.43 0 0 0-2.37 2.63 2.56 2.56 0 0 0 2.37 2.82zm.3.43h-.53a2.78 2.78 0 0 0-2.51 1.3A11.94 11.94 0 0 1 9 12.5V16h5.87v-2.9c0-3.01-.99-4.05-3.01-4.1z" }));
});

var _extends$89 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$89(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var Paste16SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$89(_ref, ["styles"]);

  return React.createElement("svg", _extends$89({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props), React.createElement("path", { d: "M7 6h3V2H9v1H1V2H0v12h7V6zm9 4h-3V7l3 3z" }), React.createElement("path", { d: "M12 11V7H8v9h8v-5h-4zM7.5 1H7V0H3v1h-.5a.5.5 0 0 0-.5.5V2h6v-.5a.5.5 0 0 0-.5-.5z" }));
});

var _extends$90 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$90(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var OnlineViewers16SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$90(_ref, ["styles"]);

  return React.createElement("svg", _extends$90({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props), React.createElement("path", { d: "M3.29 11.25h2.42A10 10 0 0 1 7.25 10V7.75H2.76a13 13 0 0 0 .53 3.5zm-.53-4h4.49v-3.5h-4a13.43 13.43 0 0 0-.49 3.5zM7.75 0v3.25h3.81A9 9 0 0 0 10 .45 7.57 7.57 0 0 0 7.75 0zm-.5 3.25V0A7.57 7.57 0 0 0 5 .45a9 9 0 0 0-1.52 2.8zm-2.48 9.83a2.17 2.17 0 0 1 .46-1.33H3.45A9 9 0 0 0 5 14.55l.54.17-.19-.2a2.13 2.13 0 0 1-.58-1.44zm7.4-4.19a10.57 10.57 0 0 0 .07-1.14H7.75v1.91A6.59 6.59 0 0 1 11 8.77a6.37 6.37 0 0 1 1.17.12zm-.45-5.14h-4v3.5h4.49a13.43 13.43 0 0 0-.49-3.5zm1.02 3.5H15a7.45 7.45 0 0 0-1-3.5h-1.75a14 14 0 0 1 .49 3.5zm-9.99 4a14.42 14.42 0 0 1-.49-3.5H0a7.45 7.45 0 0 0 1 3.5zm0-7.5H1a7.45 7.45 0 0 0-1 3.5h2.26a14 14 0 0 1 .49-3.5zm.15 8H1.32A7.58 7.58 0 0 0 4 14.14a10.33 10.33 0 0 1-1.1-2.39zm9.84-4c0 .43 0 .85-.07 1.27a8 8 0 0 1 1.94.84A7.3 7.3 0 0 0 15 7.75zm-.64-4.5h1.58A7.54 7.54 0 0 0 11 .86a10.31 10.31 0 0 1 1.1 2.39zm-9.2 0A10.31 10.31 0 0 1 4 .86a7.54 7.54 0 0 0-2.68 2.39zm12.87 9.17c-1.31-1.49-5.26-4.55-9.52 0a.91.91 0 0 0-.23.62 1 1 0 0 0 .23.63A6.77 6.77 0 0 0 11.08 16a5.47 5.47 0 0 0 4.69-2.38A1 1 0 0 0 16 13a.94.94 0 0 0-.23-.58zM11 15a2 2 0 1 1 2-2 2 2 0 0 1-2 2z" }), React.createElement("circle", { cx: "11", cy: "13", r: "1" }));
});

var _extends$91 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$91(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var Notification16SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$91(_ref, ["styles"]);

  return React.createElement("svg", _extends$91({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props), React.createElement("path", { d: "M11.84 8.77V6.52a4.17 4.17 0 0 0-3.1-4.18V.62A.62.62 0 0 0 8.12 0H6.88a.62.62 0 0 0-.62.62v1.67a4.26 4.26 0 0 0-3.1 4.23v2.25a3.26 3.26 0 0 1-2.16 3V13h13v-1.24a3.25 3.25 0 0 1-2.16-2.99zM7.5 16a2.25 2.25 0 0 0 2.09-2H5.41a2.25 2.25 0 0 0 2.09 2z" }));
});

var _extends$92 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$92(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var NotificationOff16SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$92(_ref, ["styles"]);

  return React.createElement("svg", _extends$92({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props), React.createElement("path", { d: "M12 9.5a3.58 3.58 0 0 1-.11-.73V6.52a4.17 4.17 0 0 0-3.15-4.17V.62A.62.62 0 0 0 8.12 0H6.88a.62.62 0 0 0-.62.62v1.67a3.87 3.87 0 0 0-1 .43zM3.23 5.76a4.77 4.77 0 0 0-.06.76v2.25a3.25 3.25 0 0 1-2.16 3V13h9.42zm-.81-4.5L1.28 2.38l12.28 12.36 1.12-1.05L2.42 1.26zM7.5 16a2.25 2.25 0 0 0 2.09-2H5.41a2.25 2.25 0 0 0 2.09 2z" }));
});

var _extends$93 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$93(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var NotEditable16SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$93(_ref, ["styles"]);

  return React.createElement("svg", _extends$93({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props), React.createElement("path", { d: "M1.38 11.08l3.54 3.54L0 16l1.38-4.92zM13 0h-.31a1 1 0 0 0-.52.27l-2.09 2.11 3.54 3.54 2.09-2.09a1 1 0 0 0 .29-.52 1.94 1.94 0 0 0 0-.24V3a3 3 0 0 0-3-3zm-2 8.54l1.77-1.77-3.54-3.54-1.74 1.74L11 8.54zM4.96 7.5l-2.73 2.73 3.54 3.54 2.72-2.72L4.96 7.5zM2.4 1.24L1.26 2.36l12.28 12.36 1.12-1.05L2.4 1.24z" }));
});

var _extends$94 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$94(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var Mute16SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$94(_ref, ["styles"]);

  return React.createElement("svg", _extends$94({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props), React.createElement("path", { d: "M13.7 8.03l1.68-1.61-.76-.75L13 7.33l-1.62-1.66-.76.75 1.68 1.61-1.68 1.62.76.75L13 8.73l1.62 1.67.76-.75-1.68-1.62zM4 12.02L9 16V0L4 3.98v8.04zM0 4h3v8H0z" }));
});

var _extends$95 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$95(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var More16SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$95(_ref, ["styles"]);

  return React.createElement("svg", _extends$95({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props), React.createElement("circle", { cx: "1.5", cy: "8.5", r: "1.5" }), React.createElement("circle", { cx: "7.5", cy: "8.5", r: "1.5" }), React.createElement("circle", { cx: "13.5", cy: "8.5", r: "1.5" }));
});

var _extends$96 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$96(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var MoreVertical16SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$96(_ref, ["styles"]);

  return React.createElement("svg", _extends$96({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props), React.createElement("circle", { cx: "7.5", cy: "14.5", r: "1.5" }), React.createElement("circle", { cx: "7.5", cy: "8.5", r: "1.5" }), React.createElement("circle", { cx: "7.5", cy: "2.5", r: "1.5" }));
});

var _extends$97 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$97(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var Minimize16SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$97(_ref, ["styles"]);

  return React.createElement("svg", _extends$97({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props), React.createElement("path", { d: "M0 16h8V8H0zm2-6h4v4H2zm13.71-8.29L14.29.29l-3.52 3.52-1.76-1.77L8 8l5.96-1.01-1.77-1.76 3.52-3.52z", fillRule: "evenodd" }));
});

var _extends$98 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$98(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var Maximize16SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$98(_ref, ["styles"]);

  return React.createElement("svg", _extends$98({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props), React.createElement("path", { d: "M10 1l1.77 1.77L8.59 6H0v10h10V7.41l3.22-3.22L15 6l1-6zM8 14H2V8h6z", fillRule: "evenodd" }));
});

var _extends$99 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$99(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var ManageAccess16SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$99(_ref, ["styles"]);

  return React.createElement("svg", _extends$99({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props), React.createElement("path", { d: "M5 6.63c1.51 0 2.66-1.63 2.66-3.18A2.87 2.87 0 0 0 5 .5a2.72 2.72 0 0 0-2.66 3c0 1.79 1.15 3.13 2.66 3.13zm10 6.57v-1.4h-1a2.66 2.66 0 0 0-.23-.55l.73-.73-1-1-.73.73a2.66 2.66 0 0 0-.57-.25V9h-1.4v1a2.66 2.66 0 0 0-.55.23l-.73-.73-1 1 .73.73a2.66 2.66 0 0 0-.25.57H8v1.4h1a2.66 2.66 0 0 0 .23.55l-.73.73 1 1 .73-.73a2.66 2.66 0 0 0 .55.23v1h1.4V15a2.66 2.66 0 0 0 .55-.23l.73.73 1-1-.73-.73a2.66 2.66 0 0 0 .27-.57zm-3.49.47a1.17 1.17 0 1 1 1.16-1.17 1.18 1.18 0 0 1-1.16 1.17z" }), React.createElement("path", { d: "M8.44 9.22A4.26 4.26 0 0 0 5 7.12a4.12 4.12 0 0 0-4 4.33V15h6.76a4.47 4.47 0 0 1 .68-5.78z" }));
});

var _extends$100 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$100(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var Mail16SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$100(_ref, ["styles"]);

  return React.createElement("svg", _extends$100({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props), React.createElement("path", { d: "M15 11.8V3.7l-4 4zM.21 13H14.8l-4.55-4.55L7.4 11.3 4.66 8.56zM0 3.9v7.89l3.94-3.95zM0 2v.48l7.4 7.4L15 2.3V2z" }));
});

var _extends$101 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$101(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var Lock16SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$101(_ref, ["styles"]);

  return React.createElement("svg", _extends$101({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props), React.createElement("path", { d: "M11 6v-.5a3.5 3.5 0 0 0-7 0V6H2v9h11V6zm-5-.5a1.5 1.5 0 0 1 3 0V6H6zM8 12H7V9h1z" }));
});

var _extends$102 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$102(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var Location16SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$102(_ref, ["styles"]);

  return React.createElement("svg", _extends$102({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props), React.createElement("path", { d: "M6.06 5A1.94 1.94 0 1 1 8 7a1.94 1.94 0 0 1-1.94-2zM3 5.05c0 2.79 2.55 6.74 5 11 2.47-4.24 5-8.16 5-10.95a5 5 0 1 0-10 0z" }));
});

var _extends$103 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$103(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var List16SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$103(_ref, ["styles"]);

  return React.createElement("svg", _extends$103({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props), React.createElement("path", { d: "M4 2h11v2H4zM1 2h2v2H1zm3 5h11v2H4zM1 7h2v2H1zm3 5h11v2H4zm-3 0h2v2H1z" }));
});

var _extends$104 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$104(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var Link16SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$104(_ref, ["styles"]);

  return React.createElement("svg", _extends$104({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props), React.createElement("path", { d: "M14.66 1.35a3.49 3.49 0 0 0-4.95 0L6 5.06a3.49 3.49 0 0 0 0 5l.19.16 1.23-1.28a.26.26 0 0 0 0-.35 1.51 1.51 0 0 1 0-2.12l3.71-3.71a1.51 1.51 0 0 1 2.12 0 1.49 1.49 0 0 1 0 2.12l-1.78 1.78A4.7 4.7 0 0 1 11.94 9l2.72-2.7a3.51 3.51 0 0 0 0-4.95z" }), React.createElement("path", { d: "M9.69 6L8.46 7.19a.26.26 0 0 0 0 .35 1.51 1.51 0 0 1 0 2.12l-3.7 3.71a1.51 1.51 0 0 1-2.12 0 1.49 1.49 0 0 1 0-2.12l1.77-1.78a4.7 4.7 0 0 1-.47-2.35L1.22 9.83a3.5 3.5 0 0 0 5 4.95l3.71-3.71a3.49 3.49 0 0 0 0-4.95z" }));
});

var _extends$105 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$105(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var Item16SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$105(_ref, ["styles"]);

  return React.createElement("svg", _extends$105({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props), React.createElement("path", { d: "M15 0H0v16h15zm-3 13H3v-1h9zm0-3H3V9h9zm0-3H3V6h9zm0-3H3V3h9z" }));
});

var _extends$106 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$106(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var Info16SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$106(_ref, ["styles"]);

  return React.createElement("svg", _extends$106({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props), React.createElement("path", { d: "M8 1a7 7 0 1 0 7 7 7 7 0 0 0-7-7zm1 11H7V7h2zM8 6.25A1.25 1.25 0 1 1 9.25 5 1.25 1.25 0 0 1 8 6.25z" }));
});

var _extends$107 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$107(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var Inbox16SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$107(_ref, ["styles"]);

  return React.createElement("svg", _extends$107({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props), React.createElement("path", { d: "M10.82 11a3 3 0 0 1-5.64 0H1v5h14v-5zM1 0v10h1V3h12v7h1V0H1z" }), React.createElement("path", { d: "M3 4v6h3a2 2 0 0 0 4 0h3V4z" }));
});

var _extends$108 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$108(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var Import16SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$108(_ref, ["styles"]);

  return React.createElement("svg", _extends$108({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props), React.createElement("path", { d: "M12 0v4h4l-4-4z" }), React.createElement("path", { d: "M11 0H3v4.76L9.66 9.5 3 14.24V15h13V5h-5V0z" }), React.createElement("path", { fillRule: "evenodd", d: "M3.02 8.15V6l4.92 3.5L3.02 13v-2.15H0v-2.7h3.02z" }));
});

var _extends$109 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$109(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var Home16SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$109(_ref, ["styles"]);

  return React.createElement("svg", _extends$109({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props), React.createElement("path", { d: "M13 5.59V2h-2v1.59l-3-3-8 8L1.41 10 2 9.41V15h4v-5h4v5h4V9.41l.59.59L16 8.59l-3-3z" }), React.createElement("path", { d: "M7 11h2v4H7z" }));
});

var _extends$110 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$110(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var Hierarchy16SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$110(_ref, ["styles"]);

  return React.createElement("svg", _extends$110({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props), React.createElement("path", { d: "M3 0v7h4v2H2v3H0v4h5v-4H3v-2h9v2h-2v4h5v-4h-2V9H8V7h4V0z" }));
});

var _extends$111 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$111(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var Hidden16SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$111(_ref, ["styles"]);

  return React.createElement("svg", _extends$111({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props), React.createElement("path", { d: "M5.61 10a3.13 3.13 0 0 1-.74-2.2l-2.6-2.59A9.74 9.74 0 0 0 0 8a9.37 9.37 0 0 0 8 5 8.09 8.09 0 0 0 1.83-.23l-1.66-1.66A3.12 3.12 0 0 1 5.61 10zm4.62-4.26a3.13 3.13 0 0 1 .91 2.5l2.58 2.57A9.57 9.57 0 0 0 16 8a9.46 9.46 0 0 0-8-5 8.25 8.25 0 0 0-1.85.23l1.6 1.61a3.12 3.12 0 0 1 2.48.9zM1.25 2.36l12.29 12.36 1.12-1.05L2.4 1.24 1.25 2.36z" }));
});

var _extends$112 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$112(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var Help16SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$112(_ref, ["styles"]);

  return React.createElement("svg", _extends$112({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props), React.createElement("path", { d: "M8 0a8 8 0 1 0 8 8 8 8 0 0 0-8-8zm1 14H7v-2h2zm1-5.55c-.62.29-1 .5-1 1V11H7V8.92a1.88 1.88 0 0 1 .59-1.45c.46-.41 2.16-.91 2.16-1.88 0-.59-.3-1.26-1.52-1.26-1.48 0-2 2.33-2 2.33l-1.78-.41s.41-3.86 3.8-3.86a3.33 3.33 0 0 1 3.52 3.13A3.17 3.17 0 0 1 10 8.45z" }));
});

var _extends$113 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$113(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var Grid16SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$113(_ref, ["styles"]);

  return React.createElement("svg", _extends$113({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props), React.createElement("path", { d: "M7 9H1v6h6zm0-8H1v6h6zm8 8H9v6h6zm0-8H9v6h6z" }));
});

var _extends$114 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$114(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var Graph16SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$114(_ref, ["styles"]);

  return React.createElement("svg", _extends$114({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props), React.createElement("path", { d: "M5.5 4.21l3 3L14.85.85l-.7-.7L8.5 5.79l-3-3L.15 8.15l.7.7L5.5 4.21zM0 12h3v4H0z" }), React.createElement("path", { d: "M4 8h3v8H4zm4 1h3v7H8zm4-3h3v10h-3z" }));
});

var _extends$115 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$115(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var Globe16SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$115(_ref, ["styles"]);

  return React.createElement("svg", _extends$115({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props), React.createElement("path", { d: "M2.76 7.25h4.49v-3.5h-4a13.43 13.43 0 0 0-.49 3.5zm4.49-4V0A7.57 7.57 0 0 0 5 .45a9 9 0 0 0-1.52 2.8zm-3.97 8h4v-3.5H2.76a13.43 13.43 0 0 0 .52 3.5zm8.82-8h1.58A7.54 7.54 0 0 0 11 .86a10.31 10.31 0 0 1 1.1 2.39zM7.25 15v-3.25H3.44A9 9 0 0 0 5 14.55a7.57 7.57 0 0 0 2.25.45zm5-11.25a14 14 0 0 1 .49 3.5H15a7.45 7.45 0 0 0-1-3.5zM10 .45A7.57 7.57 0 0 0 7.75 0v3.25h3.81A9 9 0 0 0 10 .45zm2.25 10.8H14a7.45 7.45 0 0 0 1-3.5h-2.26a14 14 0 0 1-.49 3.5zm-.01-3.5H7.75v3.5h4a13.43 13.43 0 0 0 .49-3.5zm-9.34 4H1.32A7.54 7.54 0 0 0 4 14.14a10.31 10.31 0 0 1-1.1-2.39zm-2.9-4a7.45 7.45 0 0 0 1 3.5h1.75a14 14 0 0 1-.49-3.5zm12.1 4a10.31 10.31 0 0 1-1.1 2.39 7.54 7.54 0 0 0 2.69-2.39zM1 3.75a7.45 7.45 0 0 0-1 3.5h2.26a14 14 0 0 1 .49-3.5zm6.75 8V15a7.57 7.57 0 0 0 2.25-.45 9 9 0 0 0 1.52-2.8zm3.97-8h-4v3.5h4.49a13.43 13.43 0 0 0-.49-3.5zm-8.82-.5A10.31 10.31 0 0 1 4 .86a7.54 7.54 0 0 0-2.68 2.39z" }));
});

var _extends$116 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$116(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var Forward16SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$116(_ref, ["styles"]);

  return React.createElement("svg", _extends$116({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props), React.createElement("path", { d: "M8 5.5H0v5h8V14l8-6-8-6z", fillRule: "evenodd" }));
});

var _extends$117 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$117(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var Forums16SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$117(_ref, ["styles"]);

  return React.createElement("svg", _extends$117({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props), React.createElement("path", { d: "M13.29 8.81a2.05 2.05 0 0 0-1.29.42V14h4v-2c0-2.28-.78-3.11-2.31-3.18h-.4zM8.24 8h-.5C5.92 8.08 5.06 9 5 11.49V14h6v-2.23c0-2.71-.86-3.69-2.76-3.77zm5.26-.12a1.91 1.91 0 0 0 1.69-2 1.91 1.91 0 0 0-1.69-2 1.8 1.8 0 0 0-1.69 2 1.77 1.77 0 0 0 1.69 2zM0 12v2h4V9.23a2.05 2.05 0 0 0-1.29-.42h-.4C.78 8.87 0 9.7 0 12zm2.5-8.12a1.91 1.91 0 0 0-1.69 2 1.91 1.91 0 0 0 1.69 2 1.77 1.77 0 0 0 1.69-2 1.8 1.8 0 0 0-1.69-2zM8 6.75a2.32 2.32 0 0 0 2.06-2.45A2.32 2.32 0 0 0 8 1.85 2.21 2.21 0 0 0 5.94 4.3 2.17 2.17 0 0 0 8 6.75z" }));
});

var _extends$118 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$118(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var Folder16SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$118(_ref, ["styles"]);

  return React.createElement("svg", _extends$118({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props), React.createElement("path", { d: "M0 2v2h6.34l1-1-1-1zm0 3v9h15V3H9L7 5z" }));
});

var _extends$119 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$119(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var FolderOpen16SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$119(_ref, ["styles"]);

  return React.createElement("svg", _extends$119({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props), React.createElement("path", { d: "M12 5V4H8L6 2H0v9.76L3.38 5H12z" }), React.createElement("path", { d: "M4 6l-4 8h12l4-8H4z" }));
});

var _extends$120 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$120(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var Flag16SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$120(_ref, ["styles"]);

  return React.createElement("svg", _extends$120({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props), React.createElement("path", { d: "M12.13 2.3a7 7 0 0 1-3.05.7 7.06 7.06 0 0 1-3-.67A3.56 3.56 0 0 0 4.54 2a3.49 3.49 0 0 0-2.39 1l4 6a3.45 3.45 0 0 1 2.42-1c1.48 0 2.32 1 4.54 1A7 7 0 0 0 16 8.38zM.88 2.85L0 3.4 7.82 15l.06.1L8 15l.74-.49z" }));
});

var _extends$121 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$121(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var Filter16SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$121(_ref, ["styles"]);

  return React.createElement("svg", _extends$121({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props), React.createElement("path", { d: "M0 2h15v2L9 8.5V13l-3 2V8.5L0 3.89V2z" }));
});

var _extends$122 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$122(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var FilterTokens16SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$122(_ref, ["styles"]);

  return React.createElement("svg", _extends$122({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props), React.createElement("path", { d: "M0 1v6h16V1zm4 4H2V3h2zM0 15h16V9H0zm2-4h2v2H2z" }));
});

var _extends$123 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$123(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var FileZip16SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$123(_ref, ["styles"]);

  return React.createElement("svg", _extends$123({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props), React.createElement("path", { d: "M1 0v16h13V5h-4v3H8v1h1v1H8v1h1v1H8v1h1v1H8v1H6v-1h1v-1H6v-1h1v-1H6v-1h1V9H6V8H5V0z" }), React.createElement("path", { d: "M10 0v4h4zM7 4h1v2H7zM6 0v7h3V0z" }));
});

var _extends$124 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$124(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var FileVideo16SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$124(_ref, ["styles"]);

  return React.createElement("svg", _extends$124({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props), React.createElement("path", { d: "M3 6h3v4H3zm6 0h3v4H9z" }), React.createElement("path", { d: "M15 5V2H0v3h1v6H0v3h15v-3h-1V5zm-2-2h1v1h-1zm-2 0h1v1h-1zM9 3h1v1H9zM7 3h1v1H7zM5 3h1v1H5zM3 3h1v1H3zM1 3h1v1H1zm1 2h5v6H2zm0 8H1v-1h1zm2 0H3v-1h1zm2 0H5v-1h1zm2 0H7v-1h1zm2 0H9v-1h1zm2 0h-1v-1h1zm2 0h-1v-1h1zm-1-2H8V5h5z" }));
});

var _extends$125 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$125(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var FileSpreadsheet16SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$125(_ref, ["styles"]);

  return React.createElement("svg", _extends$125({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props), React.createElement("path", { d: "M0 2v13h16V2zm9 12H4v-2h5zm0-3H4V9h5zm0-3H4V6h5zm0-3H4V3h5zm6 9h-5v-2h5zm0-3h-5V9h5zm0-3h-5V6h5zm0-3h-5V3h5z", fill: "#87bc40" }));
});

var _extends$126 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$126(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var FilePresentation16SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$126(_ref, ["styles"]);

  return React.createElement("svg", _extends$126({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props), React.createElement("path", { d: "M14.5 1H.5a.5.5 0 0 0 0 1H1v9h4.33l-2.11 2.92a.5.5 0 1 0 .81.59L6.56 11H7v3.38a.57.57 0 0 0 .5.62.57.57 0 0 0 .5-.62V11h.44L11 14.51a.5.5 0 1 0 .81-.59L9.67 11H14V2h.5a.5.5 0 0 0 0-1zM13 10H2V2h11z", fill: "#faa21b" }), React.createElement("path", { fill: "#faa21b", d: "M3 3h9v6H3z" }));
});

var _extends$127 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$127(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var FilePdf16SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$127(_ref, ["styles"]);

  return React.createElement("svg", _extends$127({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props), React.createElement("path", { d: "M10 0H1v16h13V4zM3 5h4v3H3zm6 7H3v-1h6zm3-2H3V9h9zm0-2H8V7h4zm0-2H8V5h4z", fill: "#ec4a41" }));
});

var _extends$128 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$128(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var FilePart16SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$128(_ref, ["styles"]);

  return React.createElement("svg", _extends$128({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props), React.createElement("path", { fill: "#ec4a41", d: "M11 8V3H5v5H0v5h16V8h-5z" }));
});

var _extends$129 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$129(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var FileImage16SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$129(_ref, ["styles"]);

  return React.createElement("svg", _extends$129({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props), React.createElement("path", { d: "M1 1v14h14V1zm12 12H3V8.51l.4-.58a2.2 2.2 0 0 1 3.6 0l2.76 3.79a.3.3 0 0 0 .48 0l1-1.27a1.36 1.36 0 0 1 1.11-.45 1.29 1.29 0 0 1 .65.18zm-2-6a2 2 0 1 1 2-2 2 2 0 0 1-2 2z" }));
});

var _extends$130 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$130(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var FileGeneric16SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$130(_ref, ["styles"]);

  return React.createElement("svg", _extends$130({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props), React.createElement("path", { d: "M1 0v16h13V5H9V0zm9 0v4h4z" }));
});

var _extends$131 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$131(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var FileDocument16SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$131(_ref, ["styles"]);

  return React.createElement("svg", _extends$131({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props), React.createElement("path", { d: "M10 0H1v16h13V4zM9 12H3v-1h6zm3-2H3V9h9zm0-2H3V7h9zm0-2H3V5h9z", fill: "#0696d7" }));
});

var _extends$132 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$132(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var FileAudio16SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$132(_ref, ["styles"]);

  return React.createElement("svg", _extends$132({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props), React.createElement("path", { d: "M4 12l5 4V-.08l-5 4V12zM0 4h3v8H0zm13.08-1.83l-.29.41a.3.3 0 0 0 0 .38 6.94 6.94 0 0 1 0 10.08.3.3 0 0 0 0 .38l.29.41a.21.21 0 0 0 .33 0 7.95 7.95 0 0 0 0-11.74.21.21 0 0 0-.33.08z" }), React.createElement("path", { d: "M11.07 10.53a.33.33 0 0 0 0 .39l.3.43a.19.19 0 0 0 .31 0 4.93 4.93 0 0 0 0-6.76.19.19 0 0 0-.31 0l-.3.43a.33.33 0 0 0 0 .39 3.91 3.91 0 0 1 0 5.06z" }));
});

var _extends$133 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$133(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var FileAssembly16SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$133(_ref, ["styles"]);

  return React.createElement("svg", _extends$133({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props), React.createElement("path", { fill: "#ec4a41", d: "M12 3h4v4h-4z" }), React.createElement("path", { fill: "#ec4a41", d: "M11 8V3H5v5H0v5h16V8h-5z" }));
});

var _extends$134 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$134(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var Field16SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$134(_ref, ["styles"]);

  return React.createElement("svg", _extends$134({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props), React.createElement("path", { d: "M7.48 11c-1.88 0-4.29.51-5.48 2l.75 1h9.5l.75-1c-1.19-1.49-3.62-2-5.52-2zM8 2.5a.5.5 0 0 0-1 0V3h1z" }), React.createElement("path", { d: "M14 10.07a7.22 7.22 0 0 0-3-5.95V6h-1V4h1v-.5a.5.5 0 0 0-1 0A6.14 6.14 0 0 0 8 3v3H7V3a6.14 6.14 0 0 0-2 .51.5.5 0 0 0-1 0V4h1v2H4V4.13a7.24 7.24 0 0 0-3 5.94c0 .29-1 .93-1 .93v1h1.55c1.84-1.85 5-2 5.93-2s4.17.15 6 2H15v-1s-1-.64-1-.93z" }));
});

var _extends$135 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$135(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var Feedback16SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$135(_ref, ["styles"]);

  return React.createElement("svg", _extends$135({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props), React.createElement("path", { d: "M2 8.58l1.42 3.58 4.83 3.38 1-1.14-3.7-3.1.24-.09-1.37-3.58zM6.91 11s.92-.46 1.23-.57c2.95-1.13 5.32-.78 7 1.77l.65-.25L11.29.31c-.21.09-.43.18-.65.25.47 3-1.05 4.85-4 6-.3.12-1.23.57-1.23.57zM.12 9.78l1 2.58 1-.36-1-2.6z" }));
});

var _extends$136 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$136(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var Featured16SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$136(_ref, ["styles"]);

  return React.createElement("svg", _extends$136({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props), React.createElement("path", { d: "M7 10h2v2H7zm0-6h2v5H7zm1-4L6.46 2.77l-2.79-1.5.2 3.16-3.15.25L2.6 7.22.08 9.14l3 1.13L2 13.24l3.1-.65.69 3.09L8 13.45l2.25 2.22.69-3.09 3.1.65-1.09-3L16 9.1l-2.6-1.88 1.88-2.55-3.16-.25.2-3.16-2.78 1.51z" }));
});

var _extends$137 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$137(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var Favorite16SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$137(_ref, ["styles"]);

  return React.createElement("svg", _extends$137({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props), React.createElement("path", { d: "M16 6H9.89L8 .19 6.11 6H0l4.94 3.59-1.88 5.82L8 11.81l4.94 3.6-1.88-5.82z" }));
});

var _extends$138 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$138(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var External16SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$138(_ref, ["styles"]);

  return React.createElement("svg", _extends$138({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props), React.createElement("path", { d: "M7.7 5.47L10.17 3H0v13h13V5.83L10.53 8.3 7.7 5.47z" }), React.createElement("path", { d: "M10.04 1.01l1.77 1.77-2.69 2.69 1.41 1.41 2.69-2.69 1.77 1.77 1-5.96-5.95 1.01z" }));
});

var _extends$139 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$139(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var ExternalLink16SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$139(_ref, ["styles"]);

  return React.createElement("svg", _extends$139({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props), React.createElement("path", { fillRule: "evenodd", d: "M10 11H4V5h2V3H2v10h10V9h-2v2z" }), React.createElement("path", { fillRule: "evenodd", d: "M7.23 2.96l1.59 1.58-3.47 3.47 1.64 1.64 3.47-3.47 1.58 1.59.98-5.79-5.79.98z" }));
});

var _extends$140 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$140(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var ExportMove16SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$140(_ref, ["styles"]);

  return React.createElement("svg", _extends$140({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props), React.createElement("path", { d: "M13 6.18V5h-1.66L13 6.18zM9 0v4h4L9 0z" }), React.createElement("path", { d: "M10.02 14.94v-3.09H7v-4.7h3.02V5H8V0H0v15h13v-2.18l-2.98 2.12z" }), React.createElement("path", { fillRule: "evenodd", d: "M11.02 8.15V6l4.92 3.5-4.92 3.5v-2.15H8v-2.7h3.02z" }));
});

var _extends$141 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$141(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var ExpandPanel16SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$141(_ref, ["styles"]);

  return React.createElement("svg", _extends$141({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props), React.createElement("path", { d: "M7 15H0V1h7z" }), React.createElement("path", { fillRule: "evenodd", d: "M11.02 6.15V4l4.92 3.5-4.92 3.5V8.85H8v-2.7h3.02z" }));
});

var _extends$142 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$142(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var Error16SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$142(_ref, ["styles"]);

  return React.createElement("svg", _extends$142({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props), React.createElement("path", { d: "M8 0L0 8l8 8 8-8zm0 4a.93.93 0 0 1 1 .83l-.34 3.75a.53.53 0 0 1-.54.42h-.24a.53.53 0 0 1-.54-.42L7 4.83A.93.93 0 0 1 8 4zm0 8a1 1 0 1 1 1-1 1 1 0 0 1-1 1z" }));
});

var _extends$143 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$143(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var Education16SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$143(_ref, ["styles"]);

  return React.createElement("svg", _extends$143({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props), React.createElement("path", { d: "M8.58 10.38a.55.55 0 0 1-.17-.05L4 8.54v2.05a.84.84 0 0 0 .14.41 7.68 7.68 0 0 0 4.36 2 7.64 7.64 0 0 0 4.36-2 .84.84 0 0 0 .14-.41V8.33l-4.24 2a.41.41 0 0 1-.18.05zM3 15V6.44l-1-.41V15h1z" }), React.createElement("path", { d: "M15.76 4.63l-7-3.49h-.14a.27.27 0 0 0-.13 0L.27 4.62A.39.39 0 0 0 0 5a.39.39 0 0 0 .21.38L2 6l5.54-2.46L9 4 3.46 6.65l5 2a.53.53 0 0 0 .17 0 .39.39 0 0 0 .18 0l4.24-2 2.78-1.29A.39.39 0 0 0 16 5a.41.41 0 0 0-.24-.37z" }));
});

var _extends$144 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$144(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var Edit16SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$144(_ref, ["styles"]);

  return React.createElement("svg", _extends$144({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props), React.createElement("path", { d: "M0 16l4.92-1.38-3.54-3.54L0 16zm2.236-5.77l7-7 3.543 3.542-7 7zM13 0h-.31a1 1 0 0 0-.52.27l-2.09 2.11 3.54 3.54 2.09-2.09a1 1 0 0 0 .29-.52 1.94 1.94 0 0 0 0-.24V3a3 3 0 0 0-3-3z" }));
});

var _extends$145 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$145(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var EditProfile16SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$145(_ref, ["styles"]);

  return React.createElement("svg", _extends$145({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props), React.createElement("path", { d: "M4 7.29A3.91 3.91 0 0 0 0 11v4h5.24L6 12.4l1.94-1.94A3.94 3.94 0 0 0 4 7.29zm2.86 5.64L6 16l3.07-.86h.01l-2.22-2.22v.01zm.713-.71l4.1-4.102 2.214 2.213-4.101 4.102zM14.12 6h-.19a.62.62 0 0 0-.32.17l-1.23 1.24 2.21 2.21 1.23-1.23a.62.62 0 0 0 .18-.32v-.15A1.88 1.88 0 0 0 14.12 6z" }), React.createElement("ellipse", { cx: "4", cy: "3.51", rx: "2.63", ry: "3" }));
});

var _extends$146 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$146(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var Download16SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$146(_ref, ["styles"]);

  return React.createElement("svg", _extends$146({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props), React.createElement("path", { fillRule: "evenodd", d: "M6.2 5.25H3.24L8.04 12l4.8-6.75H9.89V0H6.2v5.25z" }), React.createElement("path", { d: "M14 11v3H2v-3H0v5h16v-5h-2z" }));
});

var _extends$147 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$147(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var Down16SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$147(_ref, ["styles"]);

  return React.createElement("svg", _extends$147({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props), React.createElement("path", { d: "M10.5 8V0h-5v8H2l6 8 6-8z", fillRule: "evenodd" }));
});

var _extends$148 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$148(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var DocumentManagement16SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$148(_ref, ["styles"]);

  return React.createElement("svg", _extends$148({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props), React.createElement("path", { d: "M10 8h4l-4-4v4z" }), React.createElement("path", { d: "M12 14H9v-2h1v1h1V9H9V7H6v2H5V7H3v6h3v-1h1v2H2V6h7V4H0v12h14V9h-2v5z" }), React.createElement("path", { d: "M2 0v3h8.41L15 7.59V12a1 1 0 0 0 1-1V0z" }));
});

var _extends$149 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$149(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var Devices16SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$149(_ref, ["styles"]);

  return React.createElement("svg", _extends$149({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props), React.createElement("path", { d: "M2 0v5h1V1h12v10H8v2h8V0H2z" }), React.createElement("path", { d: "M0 16h7V6H0zm1-9h5v7H1z" }), React.createElement("path", { d: "M2 8h3v5H2zm12 2V2H4v3h4v5h6z" }));
});

var _extends$150 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$150(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var DeviceTablet16SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$150(_ref, ["styles"]);

  return React.createElement("svg", _extends$150({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props), React.createElement("path", { d: "M0 2v12h16V2zm13 11H1V3h12zm2-4h-1V7h1z" }), React.createElement("path", { d: "M2 4h10v8H2z" }));
});

var _extends$151 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$151(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var DeviceMobile16SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$151(_ref, ["styles"]);

  return React.createElement("svg", _extends$151({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props), React.createElement("path", { d: "M5 2h6v10H5z" }), React.createElement("path", { d: "M3 0v16h10V0zm6 15H7v-1h2zm3-2H4V1h8z" }));
});

var _extends$152 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$152(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var DeviceDesktop16SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$152(_ref, ["styles"]);

  return React.createElement("svg", _extends$152({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props), React.createElement("path", { d: "M16 12V1H0v11h6v2H2v1h12v-1h-4v-2zM1 11V2h14v9z" }), React.createElement("path", { d: "M2 3h12v7H2z" }));
});

var _extends$153 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$153(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var Dashboard16SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$153(_ref, ["styles"]);

  return React.createElement("svg", _extends$153({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props), React.createElement("path", { d: "M6 2.15A7.51 7.51 0 0 0 .15 11 7.29 7.29 0 0 0 1 13.25a1 1 0 0 0 1.25.42l3-1.22A2.47 2.47 0 0 0 7 13.94a2.6 2.6 0 0 0 .56.06 2.52 2.52 0 0 0 2.28-1.55l3 1.23a1 1 0 0 0 1.16-.43 7.51 7.51 0 0 0-8-11.1zM4 11H1v-1h3zm.65-3.65l-2-2 .71-.71 2 2zm7-2.71l.71.71-.9.9a1.33 1.33 0 0 0-1-.46zM7 3h1v3H7zm2 8.86A1.5 1.5 0 0 1 7.23 13h-.07a1.46 1.46 0 0 1-1.07-1 1.51 1.51 0 0 1 .42-1.64l3.77-3.5a.29.29 0 0 1 .42 0 .3.3 0 0 1 .06.3S9.4 10.67 9 11.86zm2-.86v-1h3v1z" }));
});

var _extends$154 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$154(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var CtaArrowRight16SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$154(_ref, ["styles"]);

  return React.createElement("svg", _extends$154({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props), React.createElement("path", { d: "M8 0a8 8 0 1 0 8 8 8 8 0 0 0-8-8zm.38 12V9.54H3V6.46h5.38V4L14 8z", fillRule: "evenodd" }));
});

var _extends$155 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$155(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var Copy16SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$155(_ref, ["styles"]);

  return React.createElement("svg", _extends$155({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props), React.createElement("path", { d: "M10 3H7V0l3 3zM5 4h1V0H0v11h5V4zm11 4h-3V5l3 3z" }), React.createElement("path", { d: "M12 9V5H6v11h10V9h-4z" }));
});

var _extends$156 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$156(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var Complete16SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$156(_ref, ["styles"]);

  return React.createElement("svg", _extends$156({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props), React.createElement("path", { d: "M8 1a7 7 0 1 0 7 7 7 7 0 0 0-7-7zm-.87 10.9L3.86 9.15l.92-1.1 2.13 1.8L11 4.56l1.13.87z" }));
});

var _extends$157 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$157(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var Compare16SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$157(_ref, ["styles"]);

  return React.createElement("svg", _extends$157({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props), React.createElement("path", { fillRule: "evenodd", d: "M5.38 8L11 4 5.38 0v2.46H0v3.08h5.38V8zm5.25 2.46V8L5 12l5.63 4v-2.46H16v-3.08h-5.37z" }));
});

var _extends$158 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$158(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var Comment16SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$158(_ref, ["styles"]);

  return React.createElement("svg", _extends$158({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props), React.createElement("path", { d: "M0 1v10h3v5l5-5h8V1zm9 7H3V7h6zm4-3H3V4h10z" }));
});

var _extends$159 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$159(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var CollapsePanel16SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$159(_ref, ["styles"]);

  return React.createElement("svg", _extends$159({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props), React.createElement("path", { d: "M0 1h7v14H0z" }), React.createElement("path", { fillRule: "evenodd", d: "M13 6V4L8.06 7.5 13 11V9h3V6h-3z" }));
});

var _extends$160 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$160(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var Collaboration16SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$160(_ref, ["styles"]);

  return React.createElement("svg", _extends$160({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props), React.createElement("path", { d: "M4 4H0v12h12v-4H4V4z" }), React.createElement("path", { d: "M4 0v4h8v8h4V0H4z" }), React.createElement("path", { d: "M5 5h6v6H5z" }));
});

var _extends$161 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$161(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var Cloud16SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$161(_ref, ["styles"]);

  return React.createElement("svg", _extends$161({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props), React.createElement("path", { d: "M13.5 8h-.05a4 4 0 1 0-7.31-3H6a3 3 0 0 0-3 3h-.5a2.5 2.5 0 0 0 0 5h11a2.5 2.5 0 0 0 0-5z" }));
});

var _extends$162 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$162(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var ClosedCaptioning16SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$162(_ref, ["styles"]);

  return React.createElement("svg", _extends$162({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props), React.createElement("path", { d: "M3.69 11.8c-.88 0-1.53-1-1.53-3.4S2.83 5 3.65 5 4.78 5.59 5 6.9l1.88-.55c-.35-2.08-1.34-3.12-3.2-3.12C1.41 3.23.11 5.1.11 8.42s1.36 5.16 3.57 5.16c1.9 0 2.89-1.2 3.3-3.33l-1.86-.58c-.26 1.38-.71 2.13-1.43 2.13zm9.4-2.13c-.25 1.38-.7 2.13-1.42 2.13-.88 0-1.53-1-1.53-3.4S10.8 5 11.63 5s1.12.59 1.37 1.9l1.89-.55c-.35-2.07-1.34-3.12-3.21-3.12-2.29 0-3.59 1.87-3.59 5.19s1.35 5.16 3.57 5.16c1.9 0 2.89-1.2 3.3-3.33z" }));
});

var _extends$163 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$163(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var Clock16SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$163(_ref, ["styles"]);

  return React.createElement("svg", _extends$163({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props), React.createElement("path", { d: "M8 1a7 7 0 1 0 7 7 7 7 0 0 0-7-7zm4 8H7V3h1v5h4z" }));
});

var _extends$164 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$164(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var Checkmark16SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$164(_ref, ["styles"]);

  return React.createElement("svg", _extends$164({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props), React.createElement("path", { d: "M.52 8.77L2.28 7l3.54 3.53 7.9-7.9 1.76 1.77-9.66 9.67-5.3-5.3z" }));
});

var _extends$165 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$165(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var Checklist16SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$165(_ref, ["styles"]);

  return React.createElement("svg", _extends$165({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props), React.createElement("path", { d: "M4 3h1v1H4zm0 4h1v1H4zm0 4h1v1H4z" }), React.createElement("path", { d: "M1 0v15h14V0zm5 13H3v-3h3zm0-4H3V6h3zm0-4H3V2h3zm7 7H8v-1h5zm0-4H8V7h5zm0-4H8V3h5z" }));
});

var _extends$166 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$166(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var Chat16SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$166(_ref, ["styles"]);

  return React.createElement("svg", _extends$166({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props), React.createElement("path", { d: "M12 5v4H5.41L5 9.41V13h6l3 3v-3h2V5h-4z" }), React.createElement("path", { d: "M5 8h6V0H0v8h2v3l3-3z" }));
});

var _extends$167 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$167(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var CartFull16SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$167(_ref, ["styles"]);

  return React.createElement("svg", _extends$167({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props), React.createElement("path", { d: "M4.07 4l-.29-1.17-2.76-1.68-1.04 1.7L2.03 4.1 4 12h10l2-8H4.07z" }), React.createElement("circle", { cx: "11.5", cy: "14.5", r: "1.5" }), React.createElement("circle", { cx: "5.5", cy: "14.5", r: "1.5" }));
});

var _extends$168 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$168(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var CartEmpty16SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$168(_ref, ["styles"]);

  return React.createElement("svg", _extends$168({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props), React.createElement("path", { d: "M4.07 4l-.29-1.17L1 1.15 0 2.86 2 4.1 4 12h10l2-8zm8.37 6H5.56l-1-4h8.88z" }), React.createElement("circle", { cx: "11.5", cy: "14.5", r: "1.5" }), React.createElement("circle", { cx: "5.5", cy: "14.5", r: "1.5" }));
});

var _extends$169 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$169(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var CaretUp16SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$169(_ref, ["styles"]);

  return React.createElement("svg", _extends$169({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props), React.createElement("path", { d: "M1.71 10.03l6.3-6.3 6.3 6.3-1.77 1.77-4.53-4.54-4.54 4.54-1.76-1.77z" }));
});

var _extends$170 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$170(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var CaretRight16SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$170(_ref, ["styles"]);

  return React.createElement("svg", _extends$170({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props), React.createElement("path", { d: "M4.28 12.63l4.54-4.54-4.54-4.53 1.77-1.77 6.3 6.3-6.3 6.31-1.77-1.77z" }));
});

var _extends$171 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$171(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var CaretLeft16SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$171(_ref, ["styles"]);

  return React.createElement("svg", _extends$171({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props), React.createElement("path", { d: "M3.65 8.09l6.3-6.3 1.77 1.77-4.54 4.53 4.54 4.54-1.77 1.77-6.3-6.31z" }));
});

var _extends$172 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$172(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var CaretDown16SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$172(_ref, ["styles"]);

  return React.createElement("svg", _extends$172({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props), React.createElement("path", { d: "M1.69 6.13l1.77-1.76L7.99 8.9l4.54-4.53 1.76 1.76-6.3 6.31-6.3-6.31z" }));
});

var _extends$173 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$173(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var Calendar16SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$173(_ref, ["styles"]);

  return React.createElement("svg", _extends$173({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props), React.createElement("path", { d: "M1 2v12h13V2zm4 11H2v-2h3zm0-3H2V8h3zm0-3H2V5h3zm4 6H6v-2h3zm0-3H6V8h3zm0-3H6V5h3zm4 6h-3v-2h3zm0-3h-3V8h3zm0-3h-3V5h3z" }));
});

var _extends$174 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$174(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var Building16SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$174(_ref, ["styles"]);

  return React.createElement("svg", _extends$174({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props), React.createElement("path", { d: "M14 8V2h-1v14h2V8h-1zM3 16h3v-3h3v3h3V0H3zM8 2h2v2H8zm0 3h2v2H8zm0 3h2v2H8zM5 2h2v2H5zm0 3h2v2H5zm0 3h2v2H5zM1 8H0v8h2V2H1v6z" }));
});

var _extends$175 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$175(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var Bookmark16SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$175(_ref, ["styles"]);

  return React.createElement("svg", _extends$175({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props), React.createElement("path", { fill: "#231f20", d: "M12 16l-4.49-4L3 16V0h9v16z" }));
});

var _extends$176 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$176(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var Billing16SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$176(_ref, ["styles"]);

  return React.createElement("svg", _extends$176({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props), React.createElement("path", { d: "M14 0H1v16h13zm-2 14H7v-1h5zm0-2H3V2h9z" }), React.createElement("path", { d: "M7 9h4v2H7zm0-3h4v2H7zM4 6h2v2H4zm0-3h2v2H4zm3 0h4v2H7zM4 9h2v2H4z" }));
});

var _extends$177 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$177(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var BillStack16SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$177(_ref, ["styles"]);

  return React.createElement("svg", _extends$177({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props), React.createElement("path", { d: "M6 2h4v12H6zm-6 9h5v1H0zm11 0h5v1h-5zM0 10h5V8H2V4h3V2H0v8zm11-8v2h3v4h-3v2h5V2h-5z" }), React.createElement("path", { d: "M3 5h2v2H3zm8 0h2v2h-2zm0 8h5v1h-5zM0 13h5v1H0z" }));
});

var _extends$178 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$178(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var Back16SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$178(_ref, ["styles"]);

  return React.createElement("svg", _extends$178({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props), React.createElement("path", { fillRule: "evenodd", d: "M7.88 5.38v-3.5L0 7.56l7.88 5.69v-3.5H16V5.38H7.88z" }));
});

var _extends$179 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$179(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var Back1616SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$179(_ref, ["styles"]);

  return React.createElement("svg", _extends$179({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props), React.createElement("path", { d: "M8 2L0 8l8 6v-3.5h8v-5H8z", fillRule: "evenodd" }));
});

var _extends$180 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$180(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var Attachment16SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$180(_ref, ["styles"]);

  return React.createElement("svg", _extends$180({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props), React.createElement("path", { d: "M10 3v3h3l-3-3zm4 3v9H2v1h13V6h-1z" }), React.createElement("path", { d: "M13 7H9V3H6v4.5a1.5 1.5 0 0 1-3 0V5h1v2.5a.5.5 0 0 0 1 0V3H3V2a1 1 0 0 1 2 0v1h1V2a2 2 0 0 0-4 0v1H0v11h13z" }));
});

var _extends$181 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$181(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var Attach16SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$181(_ref, ["styles"]);

  return React.createElement("svg", _extends$181({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props), React.createElement("path", { d: "M12 3v4h4l-4-4z" }), React.createElement("path", { d: "M11 3H7v4.5a1.5 1.5 0 0 1-3 0V5h1v2.5a.5.5 0 0 0 1 0V3H4V2a1 1 0 0 1 2 0v1h1V2a2 2 0 0 0-4 0v1H0v12h16V8h-5z" }));
});

var _extends$182 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$182(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var AreaPost16SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$182(_ref, ["styles"]);

  return React.createElement("svg", _extends$182({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props), React.createElement("path", { d: "M0 0h2v2H0zm4 0h2v2H4zm4 0h2v2H8zM4 12h2v2H4zm8-12h2v2h-2zm0 4h2v2h-2zm4 7h-3V8h-2v3H8v2h3v3h2v-3h3v-2zM0 4h2v2H0zm0 4h2v2H0zm0 4h2v2H0z" }));
});

var _extends$183 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$183(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var Archive16SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$183(_ref, ["styles"]);

  return React.createElement("svg", _extends$183({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props), React.createElement("path", { d: "M0 1h16v3H0zm1 14h14V5H1zm3-7h8v1H4z" }));
});

var _extends$184 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$184(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var Alert16SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$184(_ref, ["styles"]);

  return React.createElement("svg", _extends$184({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props), React.createElement("path", { d: "M15.63 14.35L8.37 1.66a.42.42 0 0 0-.74 0L.37 14.35a.43.43 0 0 0 .37.65h14.52a.43.43 0 0 0 .37-.65zM8 13a1 1 0 1 1 1-1 1 1 0 0 1-1 1zm.66-3.42a.53.53 0 0 1-.54.42h-.24a.53.53 0 0 1-.54-.42L7 5.83A.93.93 0 0 1 8 5a.93.93 0 0 1 1 .83z" }));
});

var _extends$185 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$185(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var Add16SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$185(_ref, ["styles"]);

  return React.createElement("svg", _extends$185({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props), React.createElement("path", { d: "M6 1v5H1v3h5v5h3V9h5V6H9V1z" }));
});

var _extends$186 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$186(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var AddPage16SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$186(_ref, ["styles"]);

  return React.createElement("svg", _extends$186({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props), React.createElement("path", { d: "M9 0v4h4L9 0z" }), React.createElement("path", { d: "M10 11V9h3V5H8V0H0v15h8v-4h2z" }), React.createElement("path", { d: "M11 10v2H9v2h2v2h2v-2h2v-2h-2v-2h-2z" }));
});

var _extends$187 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$187(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var AddMember16SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$187(_ref, ["styles"]);

  return React.createElement("svg", _extends$187({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props), React.createElement("path", { d: "M6 6.63c1.51 0 2.66-1.63 2.66-3.18A2.87 2.87 0 0 0 6 .5a2.72 2.72 0 0 0-2.66 3c0 1.79 1.15 3.13 2.66 3.13zm0 .49a4.12 4.12 0 0 0-4 4.33V15h6v-4h2a4.1 4.1 0 0 0-4-3.88z" }), React.createElement("path", { d: "M13 12v-2h-2v2H9v2h2v2h2v-2h2v-2h-2z" }));
});

var _extends$188 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$188(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var AddFolder16SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$188(_ref, ["styles"]);

  return React.createElement("svg", _extends$188({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props), React.createElement("path", { d: "M6.34 3l-1-1H0v2h5.34l1-1z" }), React.createElement("path", { d: "M9 11h2V9h3V3H8L6 5H0v9h9v-3z" }), React.createElement("path", { d: "M12 10v2h-2v2h2v2h2v-2h2v-2h-2v-2h-2z" }));
});

var _extends$189 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$189(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var ZoomOut24SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$189(_ref, ["styles"]);

  return React.createElement("svg", _extends$189({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, props), React.createElement("path", { d: "M16.44 14.32l-.56.56-.46-.46A6.92 6.92 0 0 0 17 10a7 7 0 1 0-7 7 6.92 6.92 0 0 0 4.42-1.58l.46.46-.56.56 5.33 5.32 2.11-2.11zM10 16a6 6 0 1 1 6-6 6 6 0 0 1-6 6zm5.74.44l.7-.7 3.91 3.91-.7.7z" }), React.createElement("path", { d: "M13 9H7v2h6V9z" }));
});

var _extends$190 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$190(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var ZoomIn24SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$190(_ref, ["styles"]);

  return React.createElement("svg", _extends$190({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, props), React.createElement("path", { d: "M16.44 14.32l-.56.56-.46-.46A6.92 6.92 0 0 0 17 10a7 7 0 1 0-7 7 6.92 6.92 0 0 0 4.42-1.58l.46.46-.56.56 5.33 5.32 2.11-2.11zM10 16a6 6 0 1 1 6-6 6 6 0 0 1-6 6zm5.74.44l.7-.7 3.91 3.91-.7.7z" }), React.createElement("path", { d: "M13 9h-2V7H9v2H7v2h2v2h2v-2h2V9z" }));
});

var _extends$191 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$191(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var Volume24SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$191(_ref, ["styles"]);

  return React.createElement("svg", _extends$191({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, props), React.createElement("path", { d: "M5 9H2v7h3l7 5V4zm0 6H3v-5h2zm6 4.06l-5-3.57v-6l5-3.57zm10-6.56a9.45 9.45 0 0 1-3.5 7.35l.62.8a10.5 10.5 0 0 0 0-16.3l-.62.8A9.45 9.45 0 0 1 21 12.5z" }), React.createElement("path", { d: "M18 12.5a6.5 6.5 0 0 1-2.33 5l.61.79a7.48 7.48 0 0 0 0-11.54l-.61.79A6.5 6.5 0 0 1 18 12.5z" }), React.createElement("path", { d: "M15 12.5a3.48 3.48 0 0 1-1.16 2.59l.6.79a4.44 4.44 0 0 0 0-6.76l-.6.79A3.48 3.48 0 0 1 15 12.5z" }));
});

var _extends$192 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$192(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var Visible24SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$192(_ref, ["styles"]);

  return React.createElement("svg", _extends$192({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, props), React.createElement("path", { d: "M12 5.42C5.38 5.42 2 12 2 12s3.17 6.6 10 6.6A10.9 10.9 0 0 0 22 12s-3.65-6.58-10-6.58zm0 12.18c-5.13 0-8-4.19-8.85-5.58C4 10.62 7 6.42 12 6.42s8 4.3 8.87 5.67A9.75 9.75 0 0 1 12 17.6z" }), React.createElement("path", { d: "M12 8a4 4 0 1 0 4 4 4 4 0 0 0-4-4zm0 7a3 3 0 1 1 3-3 3 3 0 0 1-3 3z" }));
});

var _extends$193 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$193(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var UserInactive24SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$193(_ref, ["styles"]);

  return React.createElement("svg", _extends$193({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, props), React.createElement("path", { d: "M12.21 19H5v-4.5a4.49 4.49 0 0 1 8.85-1.1 5.58 5.58 0 0 1 .87-.64 5.49 5.49 0 0 0-3.31-3.41A4.2 4.2 0 0 0 13 6a3.78 3.78 0 0 0-3.5-4A3.78 3.78 0 0 0 6 6a4.2 4.2 0 0 0 1.59 3.35A5.49 5.49 0 0 0 4 14.5V20h8.61a5.09 5.09 0 0 1-.4-1zM7 6a2.79 2.79 0 0 1 2.5-3A2.79 2.79 0 0 1 12 6a2.79 2.79 0 0 1-2.5 3A2.79 2.79 0 0 1 7 6z" }), React.createElement("path", { d: "M17.5 13a4.5 4.5 0 1 0 4.5 4.5 4.49 4.49 0 0 0-4.5-4.5zM15 18v-1h5v1z" }));
});

var _extends$194 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$194(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var Upload24SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$194(_ref, ["styles"]);

  return React.createElement("svg", _extends$194({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, props), React.createElement("path", { d: "M12.1 2L6 10h3v6h6v-6h3zM14 9v6h-4V9H8l4.06-5.33L16 9z", fillRule: "evenodd" }), React.createElement("path", { d: "M17 16v2H7v-2H3v6h18v-6zm3 5H4v-4h2v2h12v-2h2z" }));
});

var _extends$195 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$195(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var Up24SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$195(_ref, ["styles"]);

  return React.createElement("svg", _extends$195({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, props), React.createElement("path", { d: "M11.5 2L4 12h4v10h7V12h4zm2.5 9v10H9V11H6l5.5-7.33L17 11z", fillRule: "evenodd" }));
});

var _extends$196 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$196(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var Unpin24SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$196(_ref, ["styles"]);

  return React.createElement("svg", _extends$196({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, props), React.createElement("path", { d: "M10.35 8.23l.7.7 2.1-2.1 4 4L15.07 13l.7.7 1.89-1.88 1.08 1.09L22 9.6 14.4 2l-3.26 3.26 1.09 1.08zm4.05-4.82l6.19 6.19-1.85 1.84-.52-.52-5-5-.61-.61zm-1 12.11v3.44l-.09.08-8.35-8.35.08-.09h3.44l-1-1H4.63l-1.09 1.09 4.42 4.42-4.67 5.58 5.58-4.68 4.44 4.45 1.09-1.09v-2.85l-1-1zM4.413 5.12l.707-.707L19.588 18.88l-.707.707z" }));
});

var _extends$197 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$197(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var Unlock24SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$197(_ref, ["styles"]);

  return React.createElement("svg", _extends$197({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, props), React.createElement("path", { d: "M19 2a5 5 0 0 0-5 5v3H5v11h14V10h-2V7a2 2 0 0 1 4 0v2h3V7a5 5 0 0 0-5-5zm-1 9v9H6v-9zm5-3h-1V7a3 3 0 0 0-6 0v3h-1V7a4 4 0 0 1 8 0z" }), React.createElement("path", { d: "M11 13h2v5h-2z" }));
});

var _extends$198 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$198(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var Unlink24SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$198(_ref, ["styles"]);

  return React.createElement("svg", _extends$198({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, props), React.createElement("path", { d: "M13.6 16.08l-3.69 3.69a4 4 0 0 1-5.68-5.67L7.34 11a5.42 5.42 0 0 0 .55 2.7l-2 2a1.72 1.72 0 0 0 2.44 2.43L12 14.46l-1-1-1 1a2 2 0 0 1-.23-.18A4 4 0 0 1 8.57 11L7.22 9.7l-.58.58-3.11 3.11a5 5 0 1 0 7.08 7.09l3.7-3.7zm-5.06-1.63A4 4 0 0 0 9 15a2.75 2.75 0 0 0 .26.22h.05l.25.19-2 2a.72.72 0 1 1-1-1zm1.86-6.52L14 4.38a4 4 0 0 1 5.67 0 4 4 0 0 1 0 5.67l-3.11 3.11a5.42 5.42 0 0 0-.55-2.7l2-2a1.72 1.72 0 0 0-1.22-2.96 1.67 1.67 0 0 0-1.21.5L12 9.55l1 1 .9-.89c.07.06.15.11.22.18a4 4 0 0 1 1.16 3l1.46 1.47.44-.44 3.12-3.11a5 5 0 0 0-3.51-8.56 5 5 0 0 0-3.54 1.47L9.7 7.22zm4.92 1.77a4 4 0 0 0-.46-.56 2.75 2.75 0 0 0-.26-.22l-.25-.2 2-2a.74.74 0 0 1 .51-.2.73.73 0 0 1 .51.2.71.71 0 0 1 .21.51.68.68 0 0 1-.21.51zM3.296 4.003l.707-.707 16.71 16.708-.708.708z" }));
});

var _extends$199 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$199(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var Undo24SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$199(_ref, ["styles"]);

  return React.createElement("svg", _extends$199({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, props), React.createElement("path", { d: "M22 17.17C22 12.36 18.73 8 13.57 8H12V4L2 11.5 12 19v-4h2.5c3.84 0 5.5 1 7.5 3.78v-1.61zM14.5 14H11v3l-7.33-5.5L11 6v3h2.57c4.36 0 6.9 3.45 7.34 7-1.53-1.33-3.35-2-6.41-2z" }));
});

var _extends$200 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$200(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var Unavailable24SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$200(_ref, ["styles"]);

  return React.createElement("svg", _extends$200({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, props), React.createElement("path", { d: "M11.5 2a9.5 9.5 0 1 0 9.5 9.5A9.5 9.5 0 0 0 11.5 2zm0 18a8.5 8.5 0 1 1 8.5-8.5 8.51 8.51 0 0 1-8.5 8.5z" }), React.createElement("path", { d: "M5 9v5h13V9zm12 4H6v-3h11z" }));
});

var _extends$201 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$201(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var TreeView24SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$201(_ref, ["styles"]);

  return React.createElement("svg", _extends$201({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, props), React.createElement("path", { d: "M22 15v-5H12v2H7V8h5V3H2v5h4v12h6v2h10v-5H12v2H7v-6h5v2zM3 7V4h8v3H3zm10 11h8v3h-8v-3zm0-7h8v3h-8v-3z" }));
});

var _extends$202 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$202(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var Trash24SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$202(_ref, ["styles"]);

  return React.createElement("svg", _extends$202({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, props), React.createElement("path", { d: "M19 5h-3V3.13A1.08 1.08 0 0 0 15 2H8a1.11 1.11 0 0 0-1 1.13V5H4v4h1v13h13V9h1zm-4-2v2h-1V4H9v1H8V3zm2 18H6V9h11zm1-13H5V6h13z" }));
});

var _extends$203 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$203(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var Tag24SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$203(_ref, ["styles"]);

  return React.createElement("svg", _extends$203({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, props), React.createElement("path", { d: "M12 3H3v9l10 10 9-9zm-8 8.59V4h7.59l9 9L13 20.59z" }), React.createElement("path", { d: "M7.5 6A1.5 1.5 0 1 0 9 7.5 1.5 1.5 0 0 0 7.5 6zm0 2a.5.5 0 1 1 .5-.5.5.5 0 0 1-.5.5zm3.481 1.05l.708-.707 4.66 4.66-.708.707zm-1.146 4.126l.707-.707 3.168 3.168-.708.707z" }));
});

var _extends$204 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$204(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var Sync24SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$204(_ref, ["styles"]);

  return React.createElement("svg", _extends$204({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, props), React.createElement("path", { d: "M22 13.81l-.22-9.6-2.87 2.07A9 9 0 0 0 3.67 8.61l3.8 1.3A5 5 0 0 1 12 7a4.94 4.94 0 0 1 3.68 1.65l-2.82 2.06zM16.42 8A5.94 5.94 0 0 0 7 8.7L5.06 8a8 8 0 0 1 13.08-1.08l.6.72 2-1.48.15 6.24-5.92-2 2.2-1.6zm.11 6.08a5 5 0 0 1-8.23 1.27l2.84-2.08-9.09-3.1.22 9.6 2.79-2a9 9 0 0 0 15.28-2.35zM12 20a8 8 0 0 1-6.17-2.91l-.6-.73-2 1.47-.15-6.25L9 13.6l-2.18 1.6.74.82a6 6 0 0 0 9.44-.73l2 .71a8 8 0 0 1-7 4z" }));
});

var _extends$205 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$205(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var SurveyEquipment24SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$205(_ref, ["styles"]);

  return React.createElement("svg", _extends$205({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, props), React.createElement("path", { d: "M12 6a3 3 0 1 0 3 3 3 3 0 0 0-3-3zm0 5a2 2 0 1 1 2-2 2 2 0 0 1-2 2z" }), React.createElement("path", { d: "M20 13v-1l-.82-5.74A1.47 1.47 0 0 0 17.72 5H17V3a1 1 0 0 0-1-1H8a1 1 0 0 0-1 1v2h-.72a1.47 1.47 0 0 0-1.46 1.26L4 12v1H3v4h1v2a1 1 0 0 0 1 1h1v1h2v1h8v-1h2v-1h1a1 1 0 0 0 1-1v-2h1v-4zM8 3h2v1a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1V3h2v11H8zm0 12h8v1H8zm-2 4H5v-6.93l.81-5.66A.47.47 0 0 1 6.28 6H7v10H6zm11 1H7v-3h10zm2-1h-1v-3h-1V6h.72a.47.47 0 0 1 .47.41l.81 5.66z" }));
});

var _extends$206 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$206(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var Support24SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$206(_ref, ["styles"]);

  return React.createElement("svg", _extends$206({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, props), React.createElement("path", { d: "M12 3a9 9 0 1 0 9 9 9 9 0 0 0-9-9zm0 17a8 8 0 1 1 8-8 8 8 0 0 1-8 8z" }), React.createElement("path", { d: "M16.81 16.62c-.33.43-1.32 1.56-2.37 1.28-3.91-1-7.32-6.81-6.26-10.79.27-1.05 1.74-1.35 2.28-1.42a.28.28 0 0 1 .28.16l1.11 2.74a.25.25 0 0 1-.1.29 4.59 4.59 0 0 1-2.13.72c-.52 2 1.49 5.31 3.38 5.81.12-.53 1.22-1.25 1.66-1.52A.25.25 0 0 1 15 14l1.85 2.35a.27.27 0 0 1-.04.27z" }));
});

var _extends$207 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$207(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var Subscription24SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$207(_ref, ["styles"]);

  return React.createElement("svg", _extends$207({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, props), React.createElement("path", { d: "M12 17.46V17H8v-2h4.58a5.44 5.44 0 0 1 .63-1H8v-2h7v.53a5.8 5.8 0 0 1 1-.4V5H4v13h8a4.89 4.89 0 0 1 0-.54zM8 6h7v2H8zm0 3h7v2H8zm-1 8H5v-2h2zm0-3H5v-2h2zm0-3H5V9h2zm0-3H5V6h2z", fillRule: "evenodd" }), React.createElement("path", { d: "M21.94 16.82l-1.4.13a2.84 2.84 0 0 1 .05.51 3.09 3.09 0 1 1-3.09-3.12 3.05 3.05 0 0 1 1.21.26l-.84 1.46 4-.37L20.21 12l-.79 1.37a4.27 4.27 0 0 0-1.92-.45 4.66 4.66 0 1 0 4.44 3.9z", fillRule: "evenodd" }), React.createElement("path", { d: "M12.62 20H3V3h14v8.94h1V2H2v19h11.27a5.53 5.53 0 0 1-.65-1z", fillRule: "evenodd" }));
});

var _extends$208 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$208(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var Sort24SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$208(_ref, ["styles"]);

  return React.createElement("svg", _extends$208({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, props), React.createElement("path", { d: "M19 14V5h-5v9h-3l5.5 7.68L22 14zm-6 1h2V6h3v9h2.05l-3.55 5z", fillRule: "evenodd" }), React.createElement("path", { d: "M7.5 2.32L2 10h3v9h5v-9h3zM9 9v9H6V9H4l3.5-5 3.55 5z", fillRule: "evenodd" }));
});

var _extends$209 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$209(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var SocialYoutube24SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$209(_ref, ["styles"]);

  return React.createElement("svg", _extends$209({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, props), React.createElement("path", { d: "M21.58 6.75A2.5 2.5 0 0 0 19.81 5C18.25 4.56 12 4.56 12 4.56s-6.25 0-7.81.42a2.51 2.51 0 0 0-1.77 1.77A25.91 25.91 0 0 0 2 11.56a25.91 25.91 0 0 0 .42 4.81 2.51 2.51 0 0 0 1.77 1.77c1.56.42 7.81.42 7.81.42s6.25 0 7.81-.42a2.51 2.51 0 0 0 1.77-1.77 25.91 25.91 0 0 0 .42-4.81 25.91 25.91 0 0 0-.42-4.81zM10 14.56v-6l5.2 3z" }));
});

var _extends$210 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$210(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var SocialTwitter24SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$210(_ref, ["styles"]);

  return React.createElement("svg", _extends$210({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, props), React.createElement("path", { d: "M22 5.93a8.41 8.41 0 0 1-2.36.63 4.06 4.06 0 0 0 1.8-2.23 8.21 8.21 0 0 1-2.61 1 4.12 4.12 0 0 0-7.1 2.73 4.06 4.06 0 0 0 .11.92 11.71 11.71 0 0 1-8.45-4.2 4 4 0 0 0-.56 2 4 4 0 0 0 1.83 3.35 4.17 4.17 0 0 1-1.86-.5v.07a4.05 4.05 0 0 0 3.29 4 4.28 4.28 0 0 1-1.85.07 4.1 4.1 0 0 0 3.83 2.8A8.35 8.35 0 0 1 3 18.25a8.39 8.39 0 0 1-1-.06A11.75 11.75 0 0 0 8.29 20 11.48 11.48 0 0 0 20 8.75V8a8.28 8.28 0 0 0 2-2.07z" }));
});

var _extends$211 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$211(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var SocialLinkedin24SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$211(_ref, ["styles"]);

  return React.createElement("svg", _extends$211({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, props), React.createElement("path", { d: "M19.67 3H4.33A1.31 1.31 0 0 0 3 4.29V19.7A1.31 1.31 0 0 0 4.32 21h15.35A1.31 1.31 0 0 0 21 19.7V4.3A1.31 1.31 0 0 0 19.67 3zM8.34 18.34H5.67V9.75h2.67zM7 8.57A1.55 1.55 0 1 1 8.55 7 1.54 1.54 0 0 1 7 8.57zm11.33 9.76h-2.66v-4.17c0-1 0-2.28-1.39-2.28s-1.6 1.09-1.6 2.21v4.25H10V9.75h2.56v1.17a2.79 2.79 0 0 1 2.53-1.39c2.7 0 3.2 1.78 3.2 4.09z", fill: "#231f20" }));
});

var _extends$212 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$212(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var SocialInstagram24SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$212(_ref, ["styles"]);

  return React.createElement("svg", _extends$212({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, props), React.createElement("path", { d: "M12 3.8c2.67 0 3 0 4 .06a5.66 5.66 0 0 1 1.86.34 3.35 3.35 0 0 1 1.9 1.9 5.41 5.41 0 0 1 .38 1.9c0 1.05.06 1.37.06 4s0 3-.06 4a5.66 5.66 0 0 1-.34 1.86 3.35 3.35 0 0 1-1.9 1.9 5.66 5.66 0 0 1-1.9.34c-1 0-1.37.06-4 .06s-3 0-4-.06a5.55 5.55 0 0 1-1.94-.3 3.35 3.35 0 0 1-1.9-1.9 5.6 5.6 0 0 1-.3-1.9c0-1.05-.06-1.37-.06-4s0-3 .06-4a5.6 5.6 0 0 1 .34-1.9 3.35 3.35 0 0 1 1.9-1.9A5.6 5.6 0 0 1 8 3.86c1.05 0 1.37-.06 4-.06M12 2c-2.72 0-3.06 0-4.12.06a7.22 7.22 0 0 0-2.43.46 5.1 5.1 0 0 0-2.93 2.93 7.22 7.22 0 0 0-.46 2.43C2 8.94 2 9.28 2 12s0 3.06.06 4.12a7.22 7.22 0 0 0 .46 2.43 5.12 5.12 0 0 0 2.92 2.92 7.22 7.22 0 0 0 2.43.46C8.94 22 9.28 22 12 22s3.06 0 4.12-.06a7.22 7.22 0 0 0 2.43-.46 5.12 5.12 0 0 0 2.92-2.92 7.22 7.22 0 0 0 .46-2.43c0-1.07.06-1.41.06-4.12S22 9 21.93 7.89a7.22 7.22 0 0 0-.46-2.43 5.12 5.12 0 0 0-2.92-2.92 7.22 7.22 0 0 0-2.43-.46C15.06 2 14.72 2 12 2z" }), React.createElement("path", { d: "M12 6.86A5.14 5.14 0 1 0 17.14 12 5.14 5.14 0 0 0 12 6.86zm0 8.47A3.33 3.33 0 1 1 15.33 12 3.33 3.33 0 0 1 12 15.33z" }), React.createElement("circle", { cx: "17.34", cy: "6.66", r: "1.2" }));
});

var _extends$213 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$213(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var SocialFacebook24SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$213(_ref, ["styles"]);

  return React.createElement("svg", _extends$213({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, props), React.createElement("path", { d: "M19.37 3H4.63A1.63 1.63 0 0 0 3 4.63v14.74A1.63 1.63 0 0 0 4.63 21h8.27v-7.2h-2.7v-2.7h2.7v-2c0-2.32 1.37-3.59 3.38-3.59a19 19 0 0 1 2 .11V8.4h-1.37c-1.09 0-1.31.54-1.31 1.32v1.38h2.67l-.35 2.7H15.6V21h3.77A1.63 1.63 0 0 0 21 19.37V4.63A1.63 1.63 0 0 0 19.37 3z" }));
});

var _extends$214 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$214(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var SocialBlog24SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$214(_ref, ["styles"]);

  return React.createElement("svg", _extends$214({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, props), React.createElement("path", { d: "M16.24 8C13 4.72 8.45 3 3 3H2v4h1c8.16 0 13.78 5.63 14 14.08l.07.92H21v-1c.06-5.32-1.59-9.83-4.76-13zM18 21c-.23-9-6.26-15-15-15V4c10.43 0 17.11 6.57 17 17z" }), React.createElement("path", { d: "M3 9H2v4h1c4.88 0 7.8 2.91 8 8v.14l.23.82H15V21c0-5.78-3.77-12-12-12zm9 12c-.22-5.66-3.58-9-9-9v-2c7.11 0 11 5.2 11 11z" }), React.createElement("path", { d: "M5.5 16A2.5 2.5 0 1 0 8 18.5 2.5 2.5 0 0 0 5.5 16zm0 4A1.5 1.5 0 1 1 7 18.5 1.5 1.5 0 0 1 5.5 20z" }));
});

var _extends$215 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$215(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var Share24SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$215(_ref, ["styles"]);

  return React.createElement("svg", _extends$215({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, props), React.createElement("path", { d: "M16 16a3 3 0 0 0-2.14.9L8.7 13.29a2.9 2.9 0 0 0 0-2.59l5.16-3.61a3.08 3.08 0 1 0-.56-.82L8.12 9.88a3 3 0 1 0 0 4.23l5.16 3.61A3 3 0 0 0 13 19a3 3 0 1 0 3-3zm0-13a2 2 0 1 1-2 2 2 2 0 0 1 2-2zM6 14a2 2 0 1 1 2-2 2 2 0 0 1-2 2zm10 7a2 2 0 1 1 2-2 2 2 0 0 1-2 2z" }));
});

var _extends$216 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$216(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var Settings24SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$216(_ref, ["styles"]);

  return React.createElement("svg", _extends$216({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, props), React.createElement("path", { d: "M12 7.67A4.33 4.33 0 1 0 16.33 12 4.34 4.34 0 0 0 12 7.67zm0 7.66A3.33 3.33 0 1 1 15.33 12 3.33 3.33 0 0 1 12 15.33z" }), React.createElement("path", { d: "M22 14v-4h-2.95a7.22 7.22 0 0 0-.65-1.57l2.09-2.09-2.83-2.83-2.09 2.09A7.22 7.22 0 0 0 14 5V2h-4v3a7.22 7.22 0 0 0-1.57.65L6.34 3.51 3.51 6.34 5.6 8.43A7.22 7.22 0 0 0 5 10H2v4h3a7.22 7.22 0 0 0 .65 1.57l-2.14 2.09 2.83 2.83 2.09-2.09a7.22 7.22 0 0 0 1.57.65V22h4v-2.95a7.22 7.22 0 0 0 1.57-.65l2.09 2.09 2.83-2.83-2.09-2.09a7.22 7.22 0 0 0 .65-1.57zm-2.93 3.66l-1.41 1.41-1.91-1.91-.66.37a7.07 7.07 0 0 1-1.36.56l-.73.2V21h-2v-2.71l-.73-.2a7.07 7.07 0 0 1-1.36-.56l-.66-.37-1.91 1.91-1.41-1.41 1.91-1.92-.37-.66a6.73 6.73 0 0 1-.56-1.35l-.2-.73H3v-2h2.71l.2-.73a6.73 6.73 0 0 1 .56-1.35l.37-.66-1.91-1.92 1.41-1.41 1.91 1.91.66-.37a7.07 7.07 0 0 1 1.36-.56l.73-.2V3h2v2.71l.73.2a7.07 7.07 0 0 1 1.36.56l.66.37 1.91-1.91 1.41 1.41-1.91 1.92.37.66a6.73 6.73 0 0 1 .56 1.35l.2.73H21v2h-2.71l-.2.73a6.73 6.73 0 0 1-.56 1.35l-.37.66z" }));
});

var _extends$217 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$217(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var Service24SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$217(_ref, ["styles"]);

  return React.createElement("svg", _extends$217({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, props), React.createElement("path", { d: "M12 2A10 10 0 0 0 2 12a9.88 9.88 0 0 0 1.62 5.43v.05c.18.26.36.53.56.78l4.92-4.92-.23-.61a4.11 4.11 0 0 1 .93-4.37 4.07 4.07 0 0 1 2.89-1.2 4.19 4.19 0 0 1 1.31.2l-2.86 2.86.14 2.4 2.44.22L16.64 10a4.11 4.11 0 0 1-5.36 5.14l-.61-.23-4.21 4.17-.72.72c.25.2.52.38.78.56h.05A9.88 9.88 0 0 0 12 22a10 10 0 0 0 0-20zm0 19a9 9 0 0 1-4.7-1.34L10.92 16a5.1 5.1 0 0 0 6-7.74l-3.5 3.51-1.12-.1-.07-1.09 3.51-3.5a5.1 5.1 0 0 0-7.74 6L4.34 16.7A9 9 0 1 1 12 21z" }));
});

var _extends$218 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$218(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var SelectNone24SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$218(_ref, ["styles"]);

  return React.createElement("svg", _extends$218({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, props), React.createElement("path", { d: "M18 7v1h2v12H8v-2H7v3h14V7h-3z" }), React.createElement("path", { d: "M17 3H3v14h14zm-1 13H4V4h12z" }));
});

var _extends$219 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$219(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var SelectAll24SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$219(_ref, ["styles"]);

  return React.createElement("svg", _extends$219({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, props), React.createElement("path", { d: "M18 7v1h2v12H8v-2H7v3h14V7z" }), React.createElement("path", { d: "M17 3H3v14h14zm-1 13H4V4h12z" }), React.createElement("path", { d: "M13.45 7.79l-.71-.71-4.24 4.25-1.92-1.91-.7.7 2.62 2.63 4.95-4.96z" }));
});

var _extends$220 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$220(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var Security24SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$220(_ref, ["styles"]);

  return React.createElement("svg", _extends$220({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, props), React.createElement("path", { d: "M19 6a9.84 9.84 0 0 1-7-3 9.84 9.84 0 0 1-7 3H4c0 11.39 7.14 15 8 15s8-3.61 8-15.06c-.2.06-.64.06-1 .06zm-7 14c-.78-.33-6.59-3.2-7-13a10.83 10.83 0 0 0 7-2.61A10.83 10.83 0 0 0 19 7c-.41 9.77-6.22 12.64-7 13z" }));
});

var _extends$221 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$221(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var Search24SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$221(_ref, ["styles"]);

  return React.createElement("svg", _extends$221({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, props), React.createElement("path", { d: "M16.44 13.32l-.56.56-.46-.46A6.92 6.92 0 0 0 17 9a7 7 0 1 0-7 7 6.92 6.92 0 0 0 4.42-1.58l.46.46-.56.56 5.33 5.32 2.11-2.11zM10 15a6 6 0 1 1 6-6 6 6 0 0 1-6 6zm5.74.44l.7-.7 3.91 3.91-.7.7z" }));
});

var _extends$222 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$222(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var Save24SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$222(_ref, ["styles"]);

  return React.createElement("svg", _extends$222({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, props), React.createElement("path", { d: "M18 3H3v15l3 3h15V3zm-1 1v7H7V4zM7 20v-5h10v5zm13 0h-2v-6H6v5.59l-2-2V4h2v8h12V4h2z", fillRule: "evenodd" }), React.createElement("path", { d: "M8 16h2v3H8z" }));
});

var _extends$223 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$223(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var SaveAs24SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$223(_ref, ["styles"]);

  return React.createElement("svg", _extends$223({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, props), React.createElement("path", { d: "M6 14h10v.37l1-1V13H5v5.59l-2-2V3h2v8h12V3h2v8.4a1.64 1.64 0 0 1 .73-.37L20 11V2H2v15l3 3h6.52l.28-1H6zM6 3h10v7H6zm6.86 15.93L12 22l3.07-.86h.01l-2.22-2.22v.01z", fillRule: "evenodd" }), React.createElement("path", { d: "M13.578 18.22l4.101-4.102 2.213 2.213-4.1 4.102z" }), React.createElement("path", { d: "M20.12 12h-.19a.62.62 0 0 0-.32.17l-1.23 1.23 2.21 2.21 1.23-1.23a.62.62 0 0 0 .17-.32v-.15A1.88 1.88 0 0 0 20.12 12z", fillRule: "evenodd" }), React.createElement("path", { d: "M7 15h2v3H7z" }));
});

var _extends$224 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$224(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var Report24SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$224(_ref, ["styles"]);

  return React.createElement("svg", _extends$224({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, props), React.createElement("path", { d: "M3 2v20h17V2zm16 19H4V3h15z" }), React.createElement("path", { d: "M18 19h-1v-7h-3v7h-1v-5h-3v5H9v-9H6v9H5v1h13zM8 19H7v-8h1zm4 0h-1v-4h1zm4 0h-1v-6h1zM5 5h13v1H5zm0 2h6v1H5z" }));
});

var _extends$225 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$225(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var Redo24SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$225(_ref, ["styles"]);

  return React.createElement("svg", _extends$225({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, props), React.createElement("path", { d: "M22 11.5L12 4v4h-1.57C5.27 8 2 12.36 2 17.17v1.61C4 16 5.66 15 9.5 15H12v4zM9.5 14c-3.06 0-4.88.7-6.41 2.07.44-3.59 3-7 7.34-7H13V6l7.33 5.5L13 17v-3z" }));
});

var _extends$226 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$226(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var Recommend24SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$226(_ref, ["styles"]);

  return React.createElement("svg", _extends$226({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, props), React.createElement("path", { d: "M20.68 11.35A2.4 2.4 0 0 0 18.26 9h-4.6c.06-.2.13-.42.21-.65a12.11 12.11 0 0 0 .8-4.12.89.89 0 0 0 0-.23 2.09 2.09 0 0 0-2.08-2h-.17a2.14 2.14 0 0 0-2.09 2.16c0 1.19-1.56 3.22-2.69 4.7a11.86 11.86 0 0 0-1.84 2.78 2.27 2.27 0 0 1-.66.41A2 2 0 0 0 4 13.81V18a2 2 0 0 0 1.6 2 2.15 2.15 0 0 1 .54.39q.18.16.36.3A6.24 6.24 0 0 0 10.24 22h4.53A3.37 3.37 0 0 0 18 19.67a2.34 2.34 0 0 0 1.59-2.24 2.31 2.31 0 0 0-.11-.69 2.39 2.39 0 0 0 .52-3.69 2.39 2.39 0 0 0 .68-1.7zm-2.43 1.94a1.38 1.38 0 0 1 0 2.76.25.25 0 0 0-.23.21c0 .17.07.16.22.35a1.4 1.4 0 0 1 .28.82 1.37 1.37 0 0 1-1.27 1.37.16.16 0 0 0-.12.05.22.22 0 0 0-.06.13 2.35 2.35 0 0 1-2.35 2h-4.48a5.19 5.19 0 0 1-3.14-1.04c-.38-.29-.78-.78-1.33-.87a1 1 0 0 1-.77-1v-4.26a1 1 0 0 1 .57-.81c.45-.22 1-.54 1.14-.93.57-1.63 4.62-5.42 4.62-7.87A1.14 1.14 0 0 1 12.44 3h.08a1.09 1.09 0 0 1 1.15 1 .28.28 0 0 1 0 .13c0 2.79-1.21 4.37-1.21 5.82h5.8a1.39 1.39 0 0 1 1.42 1.37 1.41 1.41 0 0 1-1.43 1.42.26.26 0 0 0 0 .52z" }));
});

var _extends$227 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$227(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var Quantities24SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$227(_ref, ["styles"]);

  return React.createElement("svg", _extends$227({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, props), React.createElement("path", { d: "M22 15h-5v-4h4V2H10v9h4v4H2v5h2v2h16v-2h2zm-11-5V3h9v7zm4 1h1v4h-1zm4 10H5v-1h14zm2-2H3v-3h18z" }), React.createElement("path", { d: "M18 5v1h-5V5h5m1-1h-7v3h7zm-2 4h2v1h-2z" }));
});

var _extends$228 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$228(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var Publish24SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$228(_ref, ["styles"]);

  return React.createElement("svg", _extends$228({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, props), React.createElement("path", { d: "M12.5 2.32L7 10h3v6h5v-6h3zM14 9v6h-3V9H9l3.5-5 3.55 5z", fillRule: "evenodd" }), React.createElement("path", { d: "M3 17v5h18v-5zm17 4H4v-3h16z" }), React.createElement("path", { d: "M6 19h12v1H6z" }));
});

var _extends$229 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$229(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var Properties24SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$229(_ref, ["styles"]);

  return React.createElement("svg", _extends$229({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, props), React.createElement("path", { d: "M20 2H3v20h17zm-1 19H4V3h15z" }), React.createElement("path", { d: "M5 10h13V4H5zm1-5h11v4H6zm7 9v2h3v-2h2v-1h-2v-2h-3v2H5v1zm1-2h1v3h-1z" }), React.createElement("path", { d: "M7 18v2h3v-2h8v-1h-8v-2H7v2H5v1zm1-2h1v3H8z" }));
});

var _extends$230 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$230(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var ProjectManagement24SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$230(_ref, ["styles"]);

  return React.createElement("svg", _extends$230({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, props), React.createElement("path", { d: "M5 6h10v1H5z" }), React.createElement("path", { d: "M15 6H5v1h10V6zM5 9h10v1H5z" }), React.createElement("path", { d: "M15 9H5v1h10V9zm1.5 2a5.5 5.5 0 1 0 5.5 5.5 5.5 5.5 0 0 0-5.5-5.5zm0 10a4.5 4.5 0 1 1 4.5-4.5 4.49 4.49 0 0 1-4.5 4.5z" }), React.createElement("path", { d: "M17 16v-3h-1v4h4v-1h-3zm-6.82 2H3V3h14v7a6.72 6.72 0 0 1 1 .16V2H2v17h8.5a6.85 6.85 0 0 1-.32-1z" }), React.createElement("path", { d: "M11.82 12H5v1h6a6.51 6.51 0 0 1 .82-1z" }), React.createElement("path", { d: "M11.82 12H5v1h6a6.32 6.32 0 0 1 .79-1z" }));
});

var _extends$231 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$231(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var Profile24SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$231(_ref, ["styles"]);

  return React.createElement("svg", _extends$231({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, props), React.createElement("path", { d: "M12 2a10 10 0 1 0 10 10A10 10 0 0 0 12 2zM8.12 20.11a.4.4 0 0 1-.12-.23v-2.3c0-3.63 2.51-4.17 4-4.17s4 .54 4 4.17v2.47a8.88 8.88 0 0 1-7.88.06zM12 12c-1.2 0-2-1.29-2-2.5S10.8 7 12 7s2 1.29 2 2.5-.8 2.5-2 2.5zm4 8.05a8.91 8.91 0 0 0 1-.57v-1.9c0-2.71-1.32-4.49-3.59-5A3.7 3.7 0 0 0 15 9.5C15 7.82 13.85 6 12 6S9 7.82 9 9.5a3.7 3.7 0 0 0 1.59 3.08c-2.26.51-3.59 2.29-3.59 5v1.89a8.23 8.23 0 0 0 1.12.63 9 9 0 1 1 7.88-.05z" }));
});

var _extends$232 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$232(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var ProductsAndServices24SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$232(_ref, ["styles"]);

  return React.createElement("svg", _extends$232({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, props), React.createElement("path", { d: "M20.42 5.89l-8-3.7a1 1 0 0 0-.84 0l-8 3.7a1 1 0 0 0-.58.9v8.91a1 1 0 0 0 .47.84l8 5a1 1 0 0 0 1.06 0l8-5a1 1 0 0 0 .47-.84V6.79a1 1 0 0 0-.58-.9zM20 15.56a.24.24 0 0 1-.12.21l-7.75 4.82a.24.24 0 0 1-.26 0l-7.75-4.82a.24.24 0 0 1-.12-.21V7a.24.24 0 0 1 .15-.22l7.75-3.63a.23.23 0 0 1 .2 0l7.75 3.58A.24.24 0 0 1 20 7z" }), React.createElement("path", { d: "M18.93 7.4l-.39-.18a.08.08 0 0 0-.09 0l-6.45 4-6.45-4a.07.07 0 0 0-.09 0l-.39.18a.12.12 0 0 0-.07.11V8a.11.11 0 0 0 0 .08l6.46 4v7a.11.11 0 0 0 0 .08l.4.24a.09.09 0 0 0 .12 0l.4-.24a.11.11 0 0 0 0-.08v-7l6.46-4A.14.14 0 0 0 19 8v-.5a.12.12 0 0 0-.07-.1z" }));
});

var _extends$233 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$233(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var Print24SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$233(_ref, ["styles"]);

  return React.createElement("svg", _extends$233({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, props), React.createElement("path", { d: "M18 6V2H6v4H2v12h4v4h12v-4h4V6zM7 3h10v6H7zm10 18H7v-5h1v4h8v-4h1zm-8-5h6v3H9zm12 1h-3v-2H6v2H3V7h3v3h12V7h3z" }));
});

var _extends$234 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$234(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var PlaybackStop24SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$234(_ref, ["styles"]);

  return React.createElement("svg", _extends$234({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, props), React.createElement("path", { d: "M4 4v16h16V4zm15 15H5V5h14z" }));
});

var _extends$235 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$235(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var PlaybackShuffle24SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$235(_ref, ["styles"]);

  return React.createElement("svg", _extends$235({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, props), React.createElement("path", { d: "M15 15l-2.14-3L15 9v3l7-5-7-5v3a4.41 4.41 0 0 0-3.44 1.73l-1.23 1.72-.51-.72A4.36 4.36 0 0 0 6.35 6H2v4h4.35l1.43 2-1.43 2H2v4h4.35a4.36 4.36 0 0 0 3.47-1.73l.51-.72 1.23 1.72A4.41 4.41 0 0 0 15 19v3l7-5-7-5zM7.16 9.42A1 1 0 0 0 6.35 9H3V7h3.35A3.35 3.35 0 0 1 9 8.31l.71 1-1.31 1.83zM9 15.69A3.35 3.35 0 0 1 6.35 17H3v-2h3.35a1 1 0 0 0 .81-.42l5.22-7.26A3.33 3.33 0 0 1 15 6h1V3.94L20.28 7 16 10.06V8h-1a1 1 0 0 0-.81.42zm7-1.75L20.28 17 16 20.06V18h-1a3.33 3.33 0 0 1-2.66-1.32l-1.43-2 1.3-1.83 1.94 2.72A1 1 0 0 0 15 16h1z" }));
});

var _extends$236 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$236(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var PlaybackRewind24SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$236(_ref, ["styles"]);

  return React.createElement("svg", _extends$236({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, props), React.createElement("path", { d: "M12 12l10 7V5zm9 5.08L13.74 12 21 6.92zM2 12l10 7V5zm9 5.08L3.74 12 11 6.92z" }));
});

var _extends$237 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$237(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var PlaybackRecord24SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$237(_ref, ["styles"]);

  return React.createElement("svg", _extends$237({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, props), React.createElement("path", { d: "M12 4a8 8 0 1 0 8 8 8 8 0 0 0-8-8zm0 15a7 7 0 1 1 7-7 7 7 0 0 1-7 7z" }));
});

var _extends$238 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$238(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var PlaybackPrevious24SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$238(_ref, ["styles"]);

  return React.createElement("svg", _extends$238({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, props), React.createElement("path", { d: "M7 12l11 7V5zm10 5.18L8.86 12 17 6.82zM6 4v16h1V4H6z" }));
});

var _extends$239 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$239(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var PlaybackPlay24SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$239(_ref, ["styles"]);

  return React.createElement("svg", _extends$239({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, props), React.createElement("path", { d: "M6 3v18l14-9zm1 1.83L18.15 12 7 19.17z" }));
});

var _extends$240 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$240(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var PlaybackPause24SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$240(_ref, ["styles"]);

  return React.createElement("svg", _extends$240({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, props), React.createElement("path", { d: "M4 20h7V4H4zM5 5h5v14H5zm8-1v16h7V4zm6 15h-5V5h5z" }));
});

var _extends$241 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$241(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var PlaybackNext24SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$241(_ref, ["styles"]);

  return React.createElement("svg", _extends$241({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, props), React.createElement("path", { d: "M6 19l11-7L6 5zM7 6.82L15.14 12 7 17.18zM17 4v16h1V4h-1z" }));
});

var _extends$242 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$242(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var PlaybackLoop24SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$242(_ref, ["styles"]);

  return React.createElement("svg", _extends$242({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, props), React.createElement("path", { d: "M15 7L8 2v3H6a4 4 0 0 0-4 4v6a4 4 0 0 0 4 4h1v-4H6V9h2v3zM6 8a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1v2a3 3 0 0 1-3-3V9a3 3 0 0 1 3-3h3V3.94L13.28 7 9 10.06V8H6zm12-3h-1v4h1v6h-2v-3l-7 5 7 5v-3h2a4 4 0 0 0 4-4V9a4 4 0 0 0-4-4zm3 10a3 3 0 0 1-3 3h-3v2.06L10.72 17 15 13.94V16h3a1 1 0 0 0 1-1V9a1 1 0 0 0-1-1V6a3 3 0 0 1 3 3z" }));
});

var _extends$243 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$243(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var PlaybackGoToStart24SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$243(_ref, ["styles"]);

  return React.createElement("svg", _extends$243({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, props), React.createElement("path", { d: "M22 6l-9 5.4V6L3 12l10 6v-5.4l9 5.4zM12 16.23L4.94 12 12 7.77zm9 0L13.94 12 21 7.77zM2 4v16h1V4H2z" }));
});

var _extends$244 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$244(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var PlaybackGoToEnd24SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$244(_ref, ["styles"]);

  return React.createElement("svg", _extends$244({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, props), React.createElement("path", { d: "M11 11.4L2 6v12l9-5.4V18l10-6-10-6zm-8 4.83V7.77L10.06 12zm9-8.46L19.06 12 12 16.23zM21 4v16h1V4h-1z" }));
});

var _extends$245 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$245(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var PlaybackFastForward24SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$245(_ref, ["styles"]);

  return React.createElement("svg", _extends$245({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, props), React.createElement("path", { d: "M2 19l10-7L2 5zM3 6.92L10.26 12 3 17.08zM22 12L12 5v14zm-9-5.08L20.26 12 13 17.08z" }));
});

var _extends$246 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$246(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var Placeholder24SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$246(_ref, ["styles"]);

  return React.createElement("svg", _extends$246({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, props), React.createElement("path", { d: "M20.11 6.17l-.81.59a9.07 9.07 0 0 1 1.33 2.7l1-.28a9.81 9.81 0 0 0-1.52-3.01zm-4.66-2.48A9 9 0 0 1 18 5.3l.66-.75a9.84 9.84 0 0 0-2.81-1.78zm4.49 12.55a9.08 9.08 0 0 1-1.85 2.37l.68.74a10.13 10.13 0 0 0 2.05-2.64zM2.09 10.75l1 .13A8.81 8.81 0 0 1 4 8l-.9-.45a10 10 0 0 0-1.01 3.2zM21 12a8.63 8.63 0 0 1-.34 2.42l1 .26A10.1 10.1 0 0 0 22 12v-.68l-1 .08zM9 3.52a8.6 8.6 0 0 1 4.55-.37l.17-1a9.75 9.75 0 0 0-5.05.41zM5 6.34a8.77 8.77 0 0 1 2.25-2l-.53-.86a9.92 9.92 0 0 0-2.5 2.2zm2.06 13.17a9.15 9.15 0 0 1-2.22-2.08L4 18a10 10 0 0 0 2.47 2.31zm9.45.26a8.81 8.81 0 0 1-2.8 1.06l.19 1a9.91 9.91 0 0 0 3.1-1.19zM3.83 15.76A9 9 0 0 1 3 12.83l-1 .09a10 10 0 0 0 .87 3.26zM11.74 22v-1a9 9 0 0 1-3-.59l-.36.94a9.88 9.88 0 0 0 3.36.65z" }));
});

var _extends$247 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$247(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var Pin24SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$247(_ref, ["styles"]);

  return React.createElement("svg", _extends$247({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, props), React.createElement("path", { d: "M14.4 2l-3.26 3.26 1.09 1.08L9 9.6H4.63l-1.09 1.09L8 15.11l-4.71 5.58L8.87 16l4.44 4.45 1.09-1.09V15l3.26-3.26 1.08 1.09L22 9.6zm-1 17l-.09.08L5 10.69v-.09h4.39l4 4zm.5-4.84l-4-4 3.27-3.27 4 4zm4.32-3.2l-5-5-.61-.61 1.79-1.94 6.19 6.19-1.85 1.84z" }));
});

var _extends$248 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$248(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var Photos24SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$248(_ref, ["styles"]);

  return React.createElement("svg", _extends$248({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, props), React.createElement("path", { d: "M5 3v2h1V4h14v14h-1v1h2V3H5z" }), React.createElement("path", { d: "M13.5 8a2.5 2.5 0 1 0 2.5 2.5A2.5 2.5 0 0 0 13.5 8zm0 4a1.5 1.5 0 1 1 1.5-1.5 1.5 1.5 0 0 1-1.5 1.5z", fillRule: "evenodd" }), React.createElement("path", { d: "M2 6v16h16V6zm15 15H3v-3.38l2.43-3.09a1.63 1.63 0 0 1 2.63 0l.3.41 3 3.89a1.34 1.34 0 0 0 1.08.54 1.35 1.35 0 0 0 1-.48l1-1.22.18-.21a.66.66 0 0 1 .49-.22.63.63 0 0 1 .55.32L17 19.71zm-.43-3.93a1.63 1.63 0 0 0-1.43-.85 1.61 1.61 0 0 0-1.24.57l-1.21 1.43a.37.37 0 0 1-.57 0l-3.25-4.3a2.63 2.63 0 0 0-4.23 0L3 16V7h14v10.78z" }));
});

var _extends$249 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$249(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var PermissionIndividual24SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$249(_ref, ["styles"]);

  return React.createElement("svg", _extends$249({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, props), React.createElement("path", { d: "M13.33 10.54A3.9 3.9 0 0 0 15 7c0-2.43-1.29-4-3.35-4A3.69 3.69 0 0 0 8 6.72V7a3.94 3.94 0 0 0 1.87 3.54C7.35 11.17 6 13.33 6 17v4h11v-4c0-3.71-1.14-5.83-3.67-6.46zM9 7a2.72 2.72 0 0 1 2.42-3h.18C13.39 4 14 5.55 14 7s-.59 3-2.35 3A2.72 2.72 0 0 1 9 7.22 1.64 1.64 0 0 1 9 7zm7.08 13.08H7V17c0-5.11 2.67-5.71 4.63-5.71 3.12 0 4.47 1.76 4.47 5.71z" }));
});

var _extends$250 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$250(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var PermissionGroup24SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$250(_ref, ["styles"]);

  return React.createElement("svg", _extends$250({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, props), React.createElement("path", { d: "M9.9 11.67a4.34 4.34 0 0 0 2-3.74 3.65 3.65 0 0 0-3.39-3.84A3.62 3.62 0 0 0 5 7.83v.09a4 4 0 0 0 2 3.72c-2.08.46-3 2.11-3 5.36v4h9v-3.7c0-3.3-.92-5.12-3.1-5.63zM6 7.92A2.61 2.61 0 0 1 8.4 5.1h.15a2.66 2.66 0 0 1 2.39 2.84c0 1.46-1 3.09-2.39 3.09A2.86 2.86 0 0 1 6 7.92zM5 20v-3c.08-3.6 1.22-4.37 3.1-4.45h.65c2 .09 3.25.94 3.25 4.84V20zm12.5-6.84a3.66 3.66 0 0 0 1.5-3.07 3 3 0 0 0-2.71-3.26h-.11a3.15 3.15 0 0 0-3.1 3.2v.07a3.52 3.52 0 0 0 1.63 3.05 3 3 0 0 0-1.07.52l.62.78a2.59 2.59 0 0 1 1.55-.45h.54C18 14 19 14.72 19 17.89V20h-5v1h6v-3.11c0-2.75-.79-4.24-2.5-4.73zm-3.42-3.07a2.15 2.15 0 0 1 2-2.27h.09A2.06 2.06 0 0 1 18 10.09c0 1.17-.74 2.47-1.82 2.47a2.27 2.27 0 0 1-2.1-2.45z" }));
});

var _extends$251 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$251(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var Paste24SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$251(_ref, ["styles"]);

  return React.createElement("svg", _extends$251({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, props), React.createElement("path", { d: "M10 19H3V5h1v2h9V5h1v3h1V4h-2a1 1 0 0 0-1-1h-1V2H6v1H5a1 1 0 0 0-1 1H2v16h8zM5 4h2V3h3v1h2v2H5z" }), React.createElement("path", { d: "M19 9h-8v13h11V12zm2 12h-9V10h7v2h2z" }));
});

var _extends$252 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$252(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var OnlineViewers24SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$252(_ref, ["styles"]);

  return React.createElement("svg", _extends$252({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, props), React.createElement("path", { d: "M8.75 18.67A15.37 15.37 0 0 1 7.63 16h1.74c.24-.26.57-.61 1-1h-3A17 17 0 0 1 7 12h3.62v2.75c.3-.27.63-.55 1-.83V12h3.62v.19a3.84 3.84 0 0 1 .76-.08h.22V12h3a8.75 8.75 0 0 1-.22 1 7.17 7.17 0 0 1 .75.46 8 8 0 0 0 .25-2A8.76 8.76 0 0 0 11 3a8.76 8.76 0 0 0-9 8.5 8.76 8.76 0 0 0 9 8.5c-.43-.37-.81-.73-1.12-1.05a10 10 0 0 1-1.13-.28zM19.18 11h-3a16.78 16.78 0 0 0-.33-3h2.36a8.22 8.22 0 0 1 .97 3zm-1.64-4h-1.89a14.44 14.44 0 0 0-.79-2.12A7.72 7.72 0 0 1 17.54 7zm-5.91-3a5.53 5.53 0 0 1 1.87.33A15.37 15.37 0 0 1 14.62 7h-3zm3.23 4a16.14 16.14 0 0 1 .39 3h-3.62V8zm-4.24 3H7a17 17 0 0 1 .39-3h3.24zM8.75 4.33A5.53 5.53 0 0 1 10.62 4v3h-3a15.37 15.37 0 0 1 1.13-2.67zm-1.36.55A14.44 14.44 0 0 0 6.6 7H4.71a7.72 7.72 0 0 1 2.68-2.12zM4 8h2.36A16.78 16.78 0 0 0 6 11H3a8.22 8.22 0 0 1 1-3zm0 7a8.22 8.22 0 0 1-.93-3H6a16.78 16.78 0 0 0 .33 3zm.71 1H6.6a14.44 14.44 0 0 0 .79 2.12A7.72 7.72 0 0 1 4.71 16z" }), React.createElement("path", { d: "M16 13.36c-2.82 0-6 3.82-6 3.82S13.05 21 16 21s6-3.81 6-3.81-3.11-3.83-6-3.83zm0 5.82a2 2 0 1 1 2-2 2 2 0 0 1-2 2z" }), React.createElement("circle", { cx: "16", cy: "17.18", r: "1" }));
});

var _extends$253 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$253(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var Notification24SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$253(_ref, ["styles"]);

  return React.createElement("svg", _extends$253({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, props), React.createElement("path", { d: "M18 14.54V10a6 6 0 0 0-4-5.65V2h-4v2.35A6 6 0 0 0 6 10v4.54A5.4 5.4 0 0 0 3 19h6a3 3 0 0 0 6 0h6a5.4 5.4 0 0 0-3-4.46zM12 21a2 2 0 0 1-2-2h4a2 2 0 0 1-2 2zm-7.83-3a5.1 5.1 0 0 1 2.34-2.6l.49-.3V10a5 5 0 0 1 3.33-4.71l.67-.23V3h2v2.06l.67.23A5 5 0 0 1 17 10v5.1l.49.3a5.1 5.1 0 0 1 2.34 2.6z" }));
});

var _extends$254 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$254(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var NotificationOff24SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$254(_ref, ["styles"]);

  return React.createElement("svg", _extends$254({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, props), React.createElement("path", { d: "M10.33 5.29l.67-.23V3h2v2.06l.67.23A5 5 0 0 1 17 10v4.88l.58.58a5.48 5.48 0 0 1 2 2L21 18.87a5.47 5.47 0 0 0-3-4.33V10a6 6 0 0 0-4-5.65V2h-4v2.35a5.91 5.91 0 0 0-2.17 1.36l.71.71a5 5 0 0 1 1.79-1.13zM4.17 18a5.1 5.1 0 0 1 2.34-2.6l.49-.3V10a4.43 4.43 0 0 1 .07-.81l-.83-.83A5.91 5.91 0 0 0 6 10v4.54A5.4 5.4 0 0 0 3 19h6a3 3 0 0 0 6 0h1.88l-1-1zM12 21a2 2 0 0 1-2-2h4a2 2 0 0 1-2 2zm9-2.11l-.11.11H21v-.11zM4.413 5.12l.707-.707L19.588 18.88l-.707.707z" }));
});

var _extends$255 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$255(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var NotEditable24SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$255(_ref, ["styles"]);

  return React.createElement("svg", _extends$255({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, props), React.createElement("path", { d: "M17.62 3h-.34a1.16 1.16 0 0 0-.59.31L11.07 9l.71.71L15 6.47 17.53 9l-3.19 3.18.71.71 5.62-5.62a1.16 1.16 0 0 0 .33-.55 2.45 2.45 0 0 0 0-.27v-.07A3.38 3.38 0 0 0 17.62 3zM20 6.58l-1.77 1.76-2.56-2.57L17.4 4h.15A2.4 2.4 0 0 1 20 6.38v.2zM8.75 17.82l-2.57-2.57 3.48-3.47-.66-.71-4.4 4.39L3 21l5.54-1.55 4.39-4.4-.71-.71zm-.75.73l-3.57 1 1-3.57L8 18.53zM4.413 5.12l.707-.707L19.588 18.88l-.707.707z" }));
});

var _extends$256 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$256(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var Mute24SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$256(_ref, ["styles"]);

  return React.createElement("svg", _extends$256({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, props), React.createElement("path", { d: "M5 9H2v7h3l7 5V4zm0 6H3v-5h2zm6 4.06l-5-3.57v-6l5-3.57zm9.33-8.68l-.71-.71-2.12 2.12-2.12-2.12-.71.71 2.12 2.12-2.12 2.12.71.71 2.12-2.12 2.12 2.12.71-.71-2.12-2.12 2.12-2.12z" }));
});

var _extends$257 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$257(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var More24SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$257(_ref, ["styles"]);

  return React.createElement("svg", _extends$257({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, props), React.createElement("path", { d: "M18.5 10a2.5 2.5 0 1 0 2.5 2.5 2.5 2.5 0 0 0-2.5-2.5zm0 4a1.5 1.5 0 1 1 1.5-1.5 1.5 1.5 0 0 1-1.5 1.5zm-7-4a2.5 2.5 0 1 0 2.5 2.5 2.5 2.5 0 0 0-2.5-2.5zm0 4a1.5 1.5 0 1 1 1.5-1.5 1.5 1.5 0 0 1-1.5 1.5zm-7-4A2.5 2.5 0 1 0 7 12.5 2.5 2.5 0 0 0 4.5 10zm0 4A1.5 1.5 0 1 1 6 12.5 1.5 1.5 0 0 1 4.5 14z" }));
});

var _extends$258 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$258(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var MoreVertical24SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$258(_ref, ["styles"]);

  return React.createElement("svg", _extends$258({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, props), React.createElement("path", { d: "M11.5 16a2.5 2.5 0 1 0 2.5 2.5 2.5 2.5 0 0 0-2.5-2.5zm0 4a1.5 1.5 0 1 1 1.5-1.5 1.5 1.5 0 0 1-1.5 1.5zm0-11a2.5 2.5 0 1 0 2.5 2.5A2.5 2.5 0 0 0 11.5 9zm0 4a1.5 1.5 0 1 1 1.5-1.5 1.5 1.5 0 0 1-1.5 1.5zm0-6A2.5 2.5 0 1 0 9 4.5 2.5 2.5 0 0 0 11.5 7zm0-4A1.5 1.5 0 1 1 10 4.5 1.5 1.5 0 0 1 11.5 3z" }));
});

var _extends$259 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$259(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var Minimize24SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$259(_ref, ["styles"]);

  return React.createElement("svg", _extends$259({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, props), React.createElement("path", { fillRule: "evenodd", d: "M11 13.89V21H3v-8h7.13l.17-1H2v10h10v-8.28l-1 .17zm10.78-8.83L19 2.24l-4.29 4.24-2.12-2.12-1.42 8.48 8.49-1.41-2.12-2.12zm-4.2 5.7l-5.19.87.87-5.19 1.45 1.45L19 3.65l1.42 1.41-4.3 4.25z" }));
});

var _extends$260 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$260(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var Maximize24SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$260(_ref, ["styles"]);

  return React.createElement("svg", _extends$260({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, props), React.createElement("path", { d: "M12.53 4.41l2.12 2.12L11.18 10H2v12h12v-9.16l3.48-3.48 2.12 2.12L21 3zm6.4 5L17.48 8 13 12.42V21H3V11h8.59l4.47-4.47-1.45-1.45 5.18-.87z", fillRule: "evenodd" }));
});

var _extends$261 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$261(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var ManageAccess24SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$261(_ref, ["styles"]);

  return React.createElement("svg", _extends$261({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, props), React.createElement("path", { d: "M20.43 18.33l.05-.18H22v-1.3h-1.52l-.05-.18a2.7 2.7 0 0 0-.27-.66l-.09-.16 1.07-1.07-.92-.92-1.07 1.07-.15-.09a2.7 2.7 0 0 0-.66-.27l-.18-.05V13h-1.3v1.52l-.18.05a2.7 2.7 0 0 0-.66.27l-.16.09-1.07-1.07-.92.92 1.07 1.07-.09.16a2.7 2.7 0 0 0-.27.66l-.05.18H13v1.3h1.52l.05.18a2.7 2.7 0 0 0 .27.66l.09.16-1.07 1.07.92.92 1.07-1.07.16.09a2.7 2.7 0 0 0 .66.27l.18.05V22h1.3v-1.52l.18-.05a2.7 2.7 0 0 0 .66-.27l.16-.09 1.07 1.07.92-.92-1.07-1.07.09-.16a2.7 2.7 0 0 0 .27-.66zm-2.93 1a1.79 1.79 0 1 1 1.79-1.79 1.79 1.79 0 0 1-1.79 1.75z" }), React.createElement("path", { d: "M12.21 19H5v-4.5a4.49 4.49 0 0 1 8.85-1.1 5.58 5.58 0 0 1 .87-.64 5.49 5.49 0 0 0-3.31-3.41A4.2 4.2 0 0 0 13 6a3.78 3.78 0 0 0-3.5-4A3.78 3.78 0 0 0 6 6a4.2 4.2 0 0 0 1.59 3.35A5.49 5.49 0 0 0 4 14.5V20h8.61a5.09 5.09 0 0 1-.4-1zM7 6a2.79 2.79 0 0 1 2.5-3A2.79 2.79 0 0 1 12 6a2.79 2.79 0 0 1-2.5 3A2.79 2.79 0 0 1 7 6z" }));
});

var _extends$262 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$262(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var Mail24SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$262(_ref, ["styles"]);

  return React.createElement("svg", _extends$262({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, props), React.createElement("path", { d: "M22 5H2v14h20zm-10 8L3.94 6H20zM3 6.46l5.79 5.05L3 17.29zm6.55 5.71l1.83 1.6a1 1 0 0 0 1.24 0l1.83-1.6L20.29 18H3.71zm5.66-.66l5.79-5v10.78z" }));
});

var _extends$263 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$263(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var Lock24SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$263(_ref, ["styles"]);

  return React.createElement("svg", _extends$263({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, props), React.createElement("path", { d: "M17 10V9A5 5 0 0 0 7 9v1H5v11h14V10zM8 9a4 4 0 0 1 8 0v1h-1V9a3 3 0 0 0-6 0v1H8zm6 0v1h-4V9a2 2 0 0 1 4 0zm4 11H6v-9h12z" }), React.createElement("path", { d: "M11 13h2v5h-2z" }));
});

var _extends$264 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$264(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var Location24SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$264(_ref, ["styles"]);

  return React.createElement("svg", _extends$264({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, props), React.createElement("path", { d: "M12 2a6.86 6.86 0 0 0-7 6.67 7.15 7.15 0 0 0 .4 2.42 81.08 81.08 0 0 0 4.82 8.07l1.34 2.13.44.71.42-.71c.69-1.16 1.66-2.7 2.62-4.24a64.33 64.33 0 0 0 3.53-5.93A6.8 6.8 0 0 0 19 8.67 6.86 6.86 0 0 0 12 2zm5.63 8.76c-.24.66-1.93 3.35-3.42 5.71-.8 1.28-1.6 2.54-2.24 3.59l-.88-1.4c-1.78-2.8-4.42-7-4.75-7.91A6.13 6.13 0 0 1 6 8.67 5.85 5.85 0 0 1 12 3a5.85 5.85 0 0 1 6 5.67 6 6 0 0 1-.37 2.09z" }), React.createElement("path", { d: "M12 6a3 3 0 1 0 3 3 3 3 0 0 0-3-3zm0 5a2 2 0 1 1 2-2 2 2 0 0 1-2 2z" }));
});

var _extends$265 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$265(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var List24SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$265(_ref, ["styles"]);

  return React.createElement("svg", _extends$265({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, props), React.createElement("path", { d: "M2 3v4h4V3zm3 3H3V4h2zm2-3v4h15V3zm14 3H8V4h13zM2 10v4h4v-4zm3 3H3v-2h2zm2-3v4h15v-4zm14 3H8v-2h13zM2 17v4h4v-4zm3 3H3v-2h2zm2-3v4h15v-4zm14 3H8v-2h13z" }));
});

var _extends$266 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$266(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var Link24SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$266(_ref, ["styles"]);

  return React.createElement("svg", _extends$266({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, props), React.createElement("path", { d: "M20.34 3.67a5 5 0 0 0-7.09 0L9 7.92a5.11 5.11 0 0 0-.52.63v-.12l-1.84 1.85-3.11 3.11a5 5 0 1 0 7.08 7.09l4.25-4.25a5.11 5.11 0 0 0 .52-.63v.12l1.85-1.85 3.12-3.11a5 5 0 0 0-.01-7.09zm-5.48 5.47a2.75 2.75 0 0 0-.26-.22l-.25-.2 2-2a.74.74 0 0 1 .51-.2.73.73 0 0 1 .51.2.71.71 0 0 1 .21.51.68.68 0 0 1-.21.51l-2 2a4 4 0 0 0-.51-.6zM9 15a2.75 2.75 0 0 0 .26.22h.05l.25.19-2 2a.72.72 0 1 1-1-1l2-2A4 4 0 0 0 9 15zm5.16.51l-4.25 4.26a4 4 0 0 1-5.68-5.67L7.34 11a5.42 5.42 0 0 0 .55 2.7l-2 2a1.72 1.72 0 0 0 2.44 2.43l4.25-4.25a1.72 1.72 0 0 0 0-2.43.28.28 0 0 1 0-.4l1.41-1.4c.07.06.15.11.22.18a4 4 0 0 1-.05 5.69zm5.47-5.47l-3.11 3.11a5.42 5.42 0 0 0-.55-2.7l2-2a1.72 1.72 0 0 0-1.18-2.95 1.67 1.67 0 0 0-1.21.5l-4.26 4.25a1.72 1.72 0 0 0 0 2.43.28.28 0 0 1 0 .4l-1.4 1.4a2 2 0 0 1-.23-.18 4 4 0 0 1 0-5.67L14 4.38a4 4 0 0 1 5.67 0 4 4 0 0 1-.04 5.67z" }));
});

var _extends$267 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$267(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var Item24SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$267(_ref, ["styles"]);

  return React.createElement("svg", _extends$267({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, props), React.createElement("path", { d: "M20 21H4V3h16zM5 4v16h14V4z" }), React.createElement("path", { d: "M7 7h10v1H7zm0 3h10v1H7zm0 3h10v1H7zm0 3h10v1H7z" }));
});

var _extends$268 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$268(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var Info24SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$268(_ref, ["styles"]);

  return React.createElement("svg", _extends$268({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, props), React.createElement("path", { d: "M12 3a9 9 0 1 0 9 9 9 9 0 0 0-9-9zm0 17a8 8 0 1 1 8-8 8 8 0 0 1-8 8z" }), React.createElement("path", { d: "M13 12v-1h-3v1h1v4h-1v1h4v-1h-1v-4z" }), React.createElement("circle", { cx: "12", cy: "8", r: "1.25" }));
});

var _extends$269 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$269(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var Inbox24SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$269(_ref, ["styles"]);

  return React.createElement("svg", _extends$269({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, props), React.createElement("path", { d: "M3 2v20h18V2zm17 19H4v-5h5.18a3 3 0 0 0 5.64 0H20zM6 15V6h12v9h-4a2 2 0 0 1-4 0zm14 0h-1V5H5v10H4V3h16z" }));
});

var _extends$270 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$270(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var Import24SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$270(_ref, ["styles"]);

  return React.createElement("svg", _extends$270({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, props), React.createElement("path", { d: "M17 3H6v5h1V4h10v4h4v12H6v1h16V8zm1 4V5.41L19.59 7z" }), React.createElement("path", { d: "M14 14L7 9v3H2v4h5v3zM3 15v-2h5v-2l4.28 3L8 17v-2z", fillRule: "evenodd" }));
});

var _extends$271 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$271(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var Home24SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$271(_ref, ["styles"]);

  return React.createElement("svg", _extends$271({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, props), React.createElement("path", { d: "M19 9V4h-3v2l-4-4L2 12l1 2h1v7h16v-7h1l1-2zm-2-4h1v3h-1zm-3 15h-4v-2h1v-1h-1v-2h4zm5 0h-4v-6H9v6H5v-5.59l7-7 7 7zm1.38-7H19l-7-7-7 7H3.62l-.4-.8L12 3.41l8.78 8.79z" }));
});

var _extends$272 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$272(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var Hierarchy24SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$272(_ref, ["styles"]);

  return React.createElement("svg", _extends$272({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, props), React.createElement("path", { d: "M21 16h-3v-3h-6v-2h6V2H5v9h6v2H5v3H2v6h7v-6H6v-2h11v2h-3v6h7zM6 3h11v7H6zm2 18H3v-4h5zm12 0h-5v-4h5z" }));
});

var _extends$273 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$273(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var Hidden24SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$273(_ref, ["styles"]);

  return React.createElement("svg", _extends$273({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, props), React.createElement("path", { d: "M11.23 9.11A3.25 3.25 0 0 1 12 9a3 3 0 0 1 3 3 3.25 3.25 0 0 1-.11.77l.79.79A3.89 3.89 0 0 0 16 12a4 4 0 0 0-4-4 3.89 3.89 0 0 0-1.56.32zm1.54 5.78A3.25 3.25 0 0 1 12 15a3 3 0 0 1-3-3 3.25 3.25 0 0 1 .11-.77l-.79-.79A3.89 3.89 0 0 0 8 12a4 4 0 0 0 4 4 3.89 3.89 0 0 0 1.56-.32zM3.296 4.003l.707-.707 16.71 16.708-.708.708z" }), React.createElement("path", { d: "M9.06 6.94A8.63 8.63 0 0 1 12 6.42c4.82 0 8 4.3 8.87 5.67a10.37 10.37 0 0 1-3 3.63l.7.71A11.52 11.52 0 0 0 22 12s-3.65-6.6-10-6.6a9.51 9.51 0 0 0-3.71.75zM15 17.16a10.34 10.34 0 0 1-3 .44c-5.13 0-8-4.19-8.85-5.58a13.91 13.91 0 0 1 3.19-3.56l-.72-.72A14.74 14.74 0 0 0 2 12s3.17 6.6 10 6.6a10.82 10.82 0 0 0 3.82-.66z" }));
});

var _extends$274 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$274(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var Help24SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$274(_ref, ["styles"]);

  return React.createElement("svg", _extends$274({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, props), React.createElement("path", { d: "M12 3a9 9 0 1 0 9 9 9 9 0 0 0-9-9zm0 17a8 8 0 1 1 8-8 8 8 0 0 1-8 8z" }), React.createElement("path", { d: "M12.35 6.33A3.15 3.15 0 0 0 9 9.23v.24l1.49.32v-.25c.23-1.19.83-1.77 1.83-1.77a1.77 1.77 0 0 1 1.15.38 1.18 1.18 0 0 1 .46 1 1.45 1.45 0 0 1-.48 1.08 6 6 0 0 1-.8.51 3.91 3.91 0 0 0-.77.5 1.55 1.55 0 0 0-.32.48 1.79 1.79 0 0 0-.17.6c0 .19-.08 1.44-.08 2.15v.25h1.5v-1.83a.89.89 0 0 1 .12-.55 2.73 2.73 0 0 1 .83-.55 2.91 2.91 0 0 0 1.85-2.61 2.66 2.66 0 0 0-.91-2.06 3.41 3.41 0 0 0-2.35-.79z" }), React.createElement("circle", { cx: "12", cy: "17", r: "1" }));
});

var _extends$275 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$275(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var Grid24SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$275(_ref, ["styles"]);

  return React.createElement("svg", _extends$275({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, props), React.createElement("path", { d: "M11 11H3V3h8zM4 4v6h6V4zm17 7h-8V3h8zm-7-7v6h6V4zm-3 17H3v-8h8zm-7-7v6h6v-6zm17 7h-8v-8h8zm-7-7v6h6v-6z" }));
});

var _extends$276 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$276(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var Graph24SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$276(_ref, ["styles"]);

  return React.createElement("svg", _extends$276({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, props), React.createElement("path", { d: "M2.88 14.83l-.76-.66 7.32-8.36 5 4 6.68-7.64.76.66-7.32 8.36-5-4-6.68 7.64zM18 9v13h4V9zm3 12h-2V10h2zm-8-7v8h4v-8zm3 7h-2v-6h2z" }), React.createElement("path", { d: "M8 12v10h4V12zm3 9H9v-8h2zm-8-4v5h4v-5zm3 4H4v-3h2z" }));
});

var _extends$277 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$277(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var Globe24SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$277(_ref, ["styles"]);

  return React.createElement("svg", _extends$277({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, props), React.createElement("path", { d: "M12 2a10 10 0 1 0 10 10A10 10 0 0 0 12 2zm8.94 9H18a16 16 0 0 0-.47-3h2.55a9 9 0 0 1 .86 3zm-1.46-4h-2.29a9.59 9.59 0 0 0-1.94-3.38A9.07 9.07 0 0 1 19.48 7zm-7 0V3.1C14 3.38 15.3 4.87 16.12 7zm3.95 1a13.94 13.94 0 0 1 .57 3h-4.5V8zM11.5 3.1V7H7.88C8.7 4.87 10 3.38 11.5 3.1zm0 4.9v3H7a13.85 13.85 0 0 1 .51-3zm0 4v3H7.31A14.41 14.41 0 0 1 7 12zm0 4v4.9c-1.71-.32-3.18-2.25-3.95-4.9zm1 4.9V16h3.95c-.77 2.65-2.24 4.58-3.95 4.9zm0-5.9v-3H17a14.41 14.41 0 0 1-.31 3zM8.75 3.62A9.59 9.59 0 0 0 6.81 7H4.52a9.07 9.07 0 0 1 4.23-3.38zM6.5 8a16.07 16.07 0 0 0-.5 3H3a8.86 8.86 0 0 1 1-3zM6 12a15.88 15.88 0 0 0 .28 3H3.53A8.78 8.78 0 0 1 3 12zm-2 4h2.5a10.38 10.38 0 0 0 2.22 4.37A9 9 0 0 1 4 16zm11.33 4.37A10.4 10.4 0 0 0 17.5 16h2.55a9 9 0 0 1-4.77 4.37zM20.47 15h-2.75a15.88 15.88 0 0 0 .28-3h3a8.78 8.78 0 0 1-.53 3z" }));
});

var _extends$278 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$278(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var Forward24SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$278(_ref, ["styles"]);

  return React.createElement("svg", _extends$278({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, props), React.createElement("path", { d: "M22 11.5L12 4v4H2v7h10v4zM3 14V9h10V6l7.33 5.5L13 17v-3z", fillRule: "evenodd" }));
});

var _extends$279 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$279(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var Forums24SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$279(_ref, ["styles"]);

  return React.createElement("svg", _extends$279({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, props), React.createElement("path", { d: "M20 11.36A3.23 3.23 0 0 0 21 9a2.78 2.78 0 0 0-2.5-3A2.78 2.78 0 0 0 16 9a3.23 3.23 0 0 0 1 2.36 4 4 0 0 0-.56.35 5.08 5.08 0 0 1 .39 1A2.49 2.49 0 0 1 21 14.5V18h-4v1h5v-4.5a3.5 3.5 0 0 0-2-3.14zM18.5 11c-.81 0-1.5-.92-1.5-2s.69-2 1.5-2 1.5.92 1.5 2-.69 2-1.5 2zm-4.81-.61A3.69 3.69 0 0 0 15 7.5 3.28 3.28 0 0 0 12 4a3.28 3.28 0 0 0-3 3.5 3.69 3.69 0 0 0 1.31 2.89A4 4 0 0 0 8 14v5h8v-5a4 4 0 0 0-2.31-3.61zM10 7.5A2.3 2.3 0 0 1 12 5a2.3 2.3 0 0 1 2 2.5 2.3 2.3 0 0 1-2 2.5 2.3 2.3 0 0 1-2-2.5zM15 18H9v-4a3 3 0 0 1 6 0zm-8 0H3v-3.5a2.49 2.49 0 0 1 4.19-1.83 5.08 5.08 0 0 1 .39-1 4 4 0 0 0-.58-.31A3.23 3.23 0 0 0 8 9a2.78 2.78 0 0 0-2.5-3A2.78 2.78 0 0 0 3 9a3.23 3.23 0 0 0 1 2.36 3.5 3.5 0 0 0-2 3.14V19h5zM5.5 7C6.31 7 7 7.92 7 9s-.69 2-1.5 2S4 10.08 4 9s.69-2 1.5-2z" }));
});

var _extends$280 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$280(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var Folder24SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$280(_ref, ["styles"]);

  return React.createElement("svg", _extends$280({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, props), React.createElement("path", { d: "M11.79 6L9 4H2v16h19V6zM3 5h6l1.8 1.42L10 7H3zm17 14H3V8h7.26l1.52-1H20z" }));
});

var _extends$281 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$281(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var FolderOpen24SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$281(_ref, ["styles"]);

  return React.createElement("svg", _extends$281({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, props), React.createElement("path", { d: "M18.36 20H2V4h6.65l3 2H20v3h1.69zM4.19 19h13.45l2.67-9H6.86zM3 5v14h.14l3-10H19V7h-7.65l-3-2z" }));
});

var _extends$282 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$282(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var Flag24SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$282(_ref, ["styles"]);

  return React.createElement("svg", _extends$282({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, props), React.createElement("path", { d: "M18 13.81a9.73 9.73 0 0 0 4-.88l-5.37-8.34a9.71 9.71 0 0 1-4.2 1 9.82 9.82 0 0 1-4.13-.9 4.72 4.72 0 0 0-2.12-.44A4.72 4.72 0 0 0 3.69 5l-.59-.92-.83.56L13.11 20.7l.83-.56-4.7-7a4.89 4.89 0 0 1 2.53-.72c2.03.03 3.23 1.4 6.23 1.39zm-9.81-2.18L4.25 5.78a3.72 3.72 0 0 1 1.93-.54 4 4 0 0 1 1.69.35 10.78 10.78 0 0 0 4.51 1 10.89 10.89 0 0 0 3.86-.73l4.24 6.59a8.9 8.9 0 0 1-2.47.37H18a8.81 8.81 0 0 1-3.38-.71 7.78 7.78 0 0 0-2.8-.64 5.78 5.78 0 0 0-3.11.89z" }));
});

var _extends$283 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$283(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var Filter24SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$283(_ref, ["styles"]);

  return React.createElement("svg", _extends$283({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, props), React.createElement("path", { d: "M3 4v2.33L10 12v8l4-2v-6l7-5.54V4zm17 2l-7 5.54v5.86l-2 1v-6.88L4 5.85V5h16z" }));
});

var _extends$284 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$284(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var FilterTokens24SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$284(_ref, ["styles"]);

  return React.createElement("svg", _extends$284({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, props), React.createElement("path", { d: "M21 11H3V4h18zM4 5v5h16V5zm17 8H3v7h18zm-1 6H4v-5h16z" }), React.createElement("path", { d: "M8 6H5v3h3zM7 8H6V7h1zm1 7H5v3h3zm-1 2H6v-1h1z" }));
});

var _extends$285 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$285(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var FileZip24SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$285(_ref, ["styles"]);

  return React.createElement("svg", _extends$285({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, props), React.createElement("path", { d: "M15 3H4v18h16V8zm1 2.41L17.59 7H16zM11 4h1v1h-1zm2 2v5h-3V6zm-2 7h-1v1h1v1h-1v1h1v1h-1v1h1v1h-1v1H5V4h5v1H9v7h2zm8 7h-7v-1h1v-1h-1v-1h1v-1h-1v-1h1v-1h-1v-1h1v-1h1V5h-1V4h2v4h4z" }), React.createElement("path", { d: "M11 8h1v2h-1z" }));
});

var _extends$286 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$286(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var FileVideo24SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$286(_ref, ["styles"]);

  return React.createElement("svg", _extends$286({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, props), React.createElement("path", { d: "M21 7V4H2v3h1v10H2v3h19v-3h-1V7zm-2-2h1v1h-1zm-2 0h1v1h-1zm-2 0h1v1h-1zm-2 0h1v1h-1zm-2 0h1v1h-1zM9 5h1v1H9zM7 5h1v1H7zM5 5h1v1H5zM3 5h1v1H3zm1 14H3v-1h1zM4 7h7v10H4zm2 12H5v-1h1zm2 0H7v-1h1zm2 0H9v-1h1zm2 0h-1v-1h1zm2 0h-1v-1h1zm2 0h-1v-1h1zm2 0h-1v-1h1zm2 0h-1v-1h1zm-1-2h-7V7h7z" }));
});

var _extends$287 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$287(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var FileSpreadsheet24SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$287(_ref, ["styles"]);

  return React.createElement("svg", _extends$287({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, props), React.createElement("path", { d: "M20 4H4v16h16zM8 5h5v2H8zm0 3h5v2H8zm0 3h5v2H8zm0 3h5v2H8zm0 5v-2h5v2zm11 0h-5v-2h5zm0-3h-5v-2h5zm0-3h-5v-2h5zm0-3h-5V8h5zm0-3h-5V5h5z", fill: "#87bc40" }));
});

var _extends$288 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$288(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var FilePresentation24SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$288(_ref, ["styles"]);

  return React.createElement("svg", _extends$288({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, props), React.createElement("path", { d: "M19.5 4h-16a.5.5 0 0 0 0 1H4v12h5.33l-2.11 2.92a.49.49 0 0 0 0 .7.51.51 0 0 0 .78-.05v-.07l2.56-3.5H11v3.38a.57.57 0 0 0 .5.63.57.57 0 0 0 .5-.62V17h.44L15 20.51a.5.5 0 0 0 .81-.58L13.67 17H19V5h.5a.5.5 0 0 0 0-1zM18 16H5V5h13z", fill: "#faa21b" }), React.createElement("path", { fill: "#faa21b", d: "M12 8h5v1h-5zm0 2h5v1h-5zm0 2h4v1h-4zM8.5 8a2.5 2.5 0 1 0 2.5 2.5A2.5 2.5 0 0 0 8.5 8zm0 4a1.5 1.5 0 1 1 1.5-1.5A1.5 1.5 0 0 1 8.5 12z" }));
});

var _extends$289 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$289(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var FilePdf24SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$289(_ref, ["styles"]);

  return React.createElement("svg", _extends$289({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, props), React.createElement("path", { d: "M15 3H4v18h16V8zm1 2.41L17.59 7H16zM19 20H5V4h10v4h4z", fill: "#ec4a41" }), React.createElement("path", { fill: "#ec4a41", d: "M7 13h10v1H7zm0 2h7v1H7zm5-4h5v1h-5zm0-2h5v1h-5zM7 9h4v3H7z" }));
});

var _extends$290 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$290(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var FilePart24SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$290(_ref, ["styles"]);

  return React.createElement("svg", _extends$290({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, props), React.createElement("path", { d: "M20 11h-5V6H9v5H4v6h16zm-1 5H5v-4h5V7h4v5h5z", fill: "#ec4a41" }));
});

var _extends$291 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$291(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var FileImage24SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$291(_ref, ["styles"]);

  return React.createElement("svg", _extends$291({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, props), React.createElement("path", { d: "M3 3v18h18V3zm17 17H4v-3.82l2.75-3.39A2 2 0 0 1 8.34 12a2 2 0 0 1 1.59.76l.3.4 3.35 4.31a1.41 1.41 0 0 0 2.17.06L17.13 16a.84.84 0 0 1 .65-.29.83.83 0 0 1 .73.41L20 18.48zm0-3.41l-.61-1a1.85 1.85 0 0 0-1.61-.92 1.89 1.89 0 0 0-1.4.62L15 16.87a.42.42 0 0 1-.63 0l-3.65-4.7a3 3 0 0 0-4.76 0L4 14.59V4h16z" }), React.createElement("path", { d: "M15.5 11A2.5 2.5 0 1 0 13 8.5a2.5 2.5 0 0 0 2.5 2.5zm0-4A1.5 1.5 0 1 1 14 8.5 1.5 1.5 0 0 1 15.5 7z" }));
});

var _extends$292 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$292(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var FileGeneric24SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$292(_ref, ["styles"]);

  return React.createElement("svg", _extends$292({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, props), React.createElement("path", { d: "M15 3H4v18h16V8zm1 2.41L17.59 7H16zM19 20H5V4h10v4h4z" }));
});

var _extends$293 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$293(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var FileDocument24SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$293(_ref, ["styles"]);

  return React.createElement("svg", _extends$293({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, props), React.createElement("path", { d: "M15 3H4v18h16V8zm1 2.41L17.59 7H16zM19 20H5V4h10v4h4z", fill: "#0696d7" }), React.createElement("path", { fill: "#0696d7", d: "M7 13h10v1H7zm0 2h7v1H7zm0-4h10v1H7zm0-2h10v1H7z" }));
});

var _extends$294 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$294(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var FileAudio24SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$294(_ref, ["styles"]);

  return React.createElement("svg", _extends$294({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, props), React.createElement("path", { d: "M5 9H2v7h3l7 5V4zm0 6H3v-5h2zm6 4.06l-5-3.57v-6l5-3.57zm10-6.56a9.45 9.45 0 0 1-3.5 7.35l.62.8a10.5 10.5 0 0 0 0-16.3l-.62.8A9.45 9.45 0 0 1 21 12.5z" }), React.createElement("path", { d: "M18 12.5a6.5 6.5 0 0 1-2.33 5l.61.79a7.48 7.48 0 0 0 0-11.54l-.61.79A6.5 6.5 0 0 1 18 12.5z" }), React.createElement("path", { d: "M15 12.5a3.48 3.48 0 0 1-1.16 2.59l.6.79a4.44 4.44 0 0 0 0-6.76l-.6.79A3.48 3.48 0 0 1 15 12.5z" }));
});

var _extends$295 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$295(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var FileAssembly24SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$295(_ref, ["styles"]);

  return React.createElement("svg", _extends$295({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, props), React.createElement("path", { d: "M20 6H9v5H4v6h16zm-1 10H5v-4h5V7h4v5h5zm0-5h-4V7h4z", fill: "#ec4a41" }));
});

var _extends$296 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$296(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var Field24SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$296(_ref, ["styles"]);

  return React.createElement("svg", _extends$296({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, props), React.createElement("path", { d: "M20.83 15.82a4.42 4.42 0 0 1-1.25-2c0-4.7-3.36-8.54-7.58-8.83h-1c-4.22.29-7.58 4.13-7.58 8.83a4.42 4.42 0 0 1-1.25 2 .74.74 0 0 0-.17.43v.25a.5.5 0 0 0 .5.5H3l1.62 1.7a1 1 0 0 0 .72.31h12.29a1 1 0 0 0 .72-.31L20 17h.53a.5.5 0 0 0 .5-.5v-.25a.78.78 0 0 0-.2-.43zM17.63 18H5.37l-1-1v-.05C5.9 15.52 9 15 11.42 15s5.58.51 7.06 2l.05.05zM19 16c-2.2-1.85-6.26-2-7.49-2s-5.28.15-7.51 2h-.66a4.17 4.17 0 0 0 1.08-2.14A8 8 0 0 1 8 7v2.5a.5.5 0 0 0 1 0v-3a6.6 6.6 0 0 1 2-.5v2.5a.5.5 0 0 0 1 0V6a6.31 6.31 0 0 1 2 .49v3a.5.5 0 1 0 1 0V7a8 8 0 0 1 3.58 6.82A4.1 4.1 0 0 0 19.66 16z" }));
});

var _extends$297 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$297(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var Feedback24SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$297(_ref, ["styles"]);

  return React.createElement("svg", _extends$297({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, props), React.createElement("path", { d: "M21.58 14.53c-.89-2.28-4.22-10-5-11.9a1 1 0 0 0-.58-.56.87.87 0 0 0-.45-.07 1 1 0 0 0-1 .79c-.55 3.38-1.75 4.47-2.88 5.2a7.34 7.34 0 0 1-1.46.64c-2.76.68-4.64 1.53-5.57 2.53a1.32 1.32 0 0 0-.49.93L3 13c-.73.59-.67 1.13-.49 1.47l1.11 2.33a1.16 1.16 0 0 0 1.08.74 1.78 1.78 0 0 0 .47-.07l1.45-.34c1 1.07 3.6 4.38 3.67 4.46.36.66 1.31.33 1.44.26l1.85-.64a1.15 1.15 0 0 0 .65-.86.84.84 0 0 0-.28-.74l-2.17-2.58a3.81 3.81 0 0 0 .52-.85.73.73 0 0 0-.06-.72.94.94 0 0 0-.81-.33l-1.27.2-.23-.33 1.78-.56a11.28 11.28 0 0 1 2.7-.3 8.93 8.93 0 0 1 5.59 1.6.82.82 0 0 0 .2.12 1 1 0 0 0 1.35-1.33zM5 16.52c-.3.08-.31.05-.41-.14l-1.15-2.33s0-.08.23-.25l.9-.73 1.14 2.67a4.62 4.62 0 0 0 .27.54zm6.46-3l-2 .64a1.18 1.18 0 0 0-.62.67.64.64 0 0 0 .09.54 7.88 7.88 0 0 0 .71.88.49.49 0 0 0 .44.16l1.12-.18a6.58 6.58 0 0 1-.41.53.5.5 0 0 0 0 .65l2.43 2.89-1.84.7a.41.41 0 0 1-.32 0c-.12-.16-3.05-3.84-3.85-4.66a3 3 0 0 1-.57-.91l-1.42-3.37.19-.21C6 11.26 7.3 10.39 10.5 9.6l.2-.06c.2.51.42 1.1.65 1.71s.54 1.45.8 2.09c-.45.08-.72.15-.73.15zm3-.34c-.45 0-.87 0-1.24.06-.27-.68-.58-1.51-.89-2.31-.23-.62-.46-1.22-.66-1.74a6 6 0 0 0 .64-.33C13.57 8 15 6.71 15.63 3c.81 1.92 4.1 9.55 4.94 11.89a9.9 9.9 0 0 0-6.16-1.74z" }));
});

var _extends$298 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$298(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var Featured24SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$298(_ref, ["styles"]);

  return React.createElement("svg", _extends$298({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, props), React.createElement("path", { d: "M22 13.66l-3.18-2.44L21.19 8l-4-.32.26-4-3.51 1.85L12 2l-1.94 3.53-3.52-1.91.26 4L2.81 8l2.37 3.25L2 13.66l3.74 1.44-1.38 3.79 3.91-.83.88 3.94L12 19.16 14.85 22l.88-3.94 3.91.83-1.38-3.79zm-7 3.22L14.27 20 12 17.75 9.73 20 9 16.88l-3.12.66 1.09-3L4 13.37l2.54-2-1.87-2.55 3.18-.25-.2-3.21 2.81 1.52L12 4.08l1.54 2.81 2.81-1.52-.21 3.21 3.18.25-1.89 2.59 2.54 2-3 1.15 1.09 3z" }), React.createElement("path", { d: "M11 8h2v5h-2zm0 6h2v2h-2z" }));
});

var _extends$299 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$299(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var Favorite24SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$299(_ref, ["styles"]);

  return React.createElement("svg", _extends$299({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, props), React.createElement("path", { d: "M22 9.5h-7.64L12 2.24 9.64 9.5H2L8.18 14l-2.36 7.26L12 16.77l6.18 4.49L15.82 14zm-5.72 9.14L12 15.53l-4.28 3.11 1.64-5-4.28-3.14h5.29l1.63-5 1.63 5h5.29l-4.28 3.11z" }));
});

var _extends$300 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$300(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var External24SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$300(_ref, ["styles"]);

  return React.createElement("svg", _extends$300({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, props), React.createElement("path", { fillRule: "evenodd", d: "M17 20H4V6h9.76l.46-.46-.54-.54H3v16h15V10.24l-1 1V20z" }), React.createElement("path", { d: "M13.51 3.42l2.12 2.12L12.17 9 15 11.83l3.46-3.46 2.12 2.12L22 2zm6.37 4.95l-1.43-1.43L15 10.4 13.59 9l3.46-3.46-1.42-1.41 5.15-.91z", fillRule: "evenodd" }));
});

var _extends$301 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$301(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var ExternalLink24SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$301(_ref, ["styles"]);

  return React.createElement("svg", _extends$301({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, props), React.createElement("path", { fillRule: "evenodd", d: "M18 18H6V6h4V5H5v14h14v-5h-1v4z" }), React.createElement("path", { d: "M11.88 5.05L14 7.17l-3.54 3.54 2.83 2.83L16.83 10 19 12.12l1.41-8.48zm6.36 5l-1.43-1.48-3.53 3.54-1.4-1.4 3.53-3.54L14 5.76l5.15-.91z", fillRule: "evenodd" }));
});

var _extends$302 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$302(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var ExportMove24SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$302(_ref, ["styles"]);

  return React.createElement("svg", _extends$302({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, props), React.createElement("path", { d: "M18 10.06V8l-5-5H2v18h16v-3.06l-1 .68V20H3V4h10v4h4v1.38zM14 7V5.41L15.59 7z" }), React.createElement("path", { d: "M22 14l-7-5v3h-5v4h5v3zm-11 1v-2h5v-2l4.28 3L16 17v-2z", fillRule: "evenodd" }));
});

var _extends$303 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$303(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var ExpandPanel24SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$303(_ref, ["styles"]);

  return React.createElement("svg", _extends$303({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, props), React.createElement("path", { d: "M22 12l-7-5v3h-4v4h4v3zm-10 1v-2h4V9l4.28 3L16 15v-2z", fillRule: "evenodd" }), React.createElement("path", { d: "M2 3v18h8V3zm7 17H3V4h6z" }));
});

var _extends$304 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$304(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var Error24SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$304(_ref, ["styles"]);

  return React.createElement("svg", _extends$304({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, props), React.createElement("path", { d: "M12 2L2 12l10 10 10-10zM3.41 12L12 3.41 20.59 12 12 20.59z" }), React.createElement("circle", { cx: "12", cy: "15", r: "1" }), React.createElement("path", { d: "M11.88 13h.24a.55.55 0 0 0 .54-.5L13 8a1 1 0 0 0-2 0l.34 4.5a.55.55 0 0 0 .54.5z" }));
});

var _extends$305 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$305(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var Education24SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$305(_ref, ["styles"]);

  return React.createElement("svg", _extends$305({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, props), React.createElement("path", { d: "M12 4L2 9l3 1.5V20h3v-3.9a8.69 8.69 0 0 0 4 .9c3.31 0 6-1.57 6-3.5V11l4-2zM7 19H6v-8.5a.5.5 0 0 1 1 0zm10-5.5c0 1.18-2 2.5-5 2.5a7.15 7.15 0 0 1-4-1.06V12l4 2 5-2.5zm-5-.62l-4-2v-.38a1.62 1.62 0 0 0-.07-.44L12 9.49a.51.51 0 0 0 .43-.57.51.51 0 0 0-.57-.42l-4.7.66A1.46 1.46 0 0 0 6.5 9a1.48 1.48 0 0 0-1.16.56L4.21 9 12 5.12 19.74 9z" }));
});

var _extends$306 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$306(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var Edit24SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$306(_ref, ["styles"]);

  return React.createElement("svg", _extends$306({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, props), React.createElement("path", { d: "M17.63 3h-.35a1.16 1.16 0 0 0-.59.31L4.55 15.46 3 21l5.54-1.55L20.67 7.31a1.16 1.16 0 0 0 .33-.59 2.45 2.45 0 0 0 0-.27v-.08A3.37 3.37 0 0 0 17.63 3zM15 6.47L17.53 9l-8.78 8.82-2.57-2.57zM4.44 19.56l1-3.57L8 18.53zM20 6.58l-1.77 1.76-2.56-2.57L17.4 4h.15A2.4 2.4 0 0 1 20 6.37v.21z" }));
});

var _extends$307 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$307(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var EditProfile24SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$307(_ref, ["styles"]);

  return React.createElement("svg", _extends$307({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, props), React.createElement("path", { d: "M12.86 18.93L12 22l3.07-.86h.01l-2.22-2.22v.01zm.718-.71l4.101-4.102 2.213 2.213-4.1 4.102zM20.12 12h-.19a.62.62 0 0 0-.32.17l-1.23 1.23 2.21 2.21 1.23-1.23a.62.62 0 0 0 .17-.32v-.15A1.88 1.88 0 0 0 20.12 12zM5 14.5a4.5 4.5 0 0 1 9 0v1.87l1-1v-.87a5.49 5.49 0 0 0-3.59-5.15A4.2 4.2 0 0 0 13 6a3.78 3.78 0 0 0-3.5-4A3.78 3.78 0 0 0 6 6a4.2 4.2 0 0 0 1.59 3.35A5.49 5.49 0 0 0 4 14.5V20h7.52l.28-1H5zM7 6a2.79 2.79 0 0 1 2.5-3A2.79 2.79 0 0 1 12 6a2.79 2.79 0 0 1-2.5 3A2.79 2.79 0 0 1 7 6z" }));
});

var _extends$308 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$308(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var Download24SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$308(_ref, ["styles"]);

  return React.createElement("svg", _extends$308({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, props), React.createElement("path", { d: "M15 8V2H9v6H6l6.1 8L18 8zm-2.92 6.33L8 9h2V3h4v6h2z", fillRule: "evenodd" }), React.createElement("path", { d: "M17 16v2H7v-2H3v6h18v-6zm3 5H4v-4h2v2h12v-2h2z" }));
});

var _extends$309 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$309(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var Down24SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$309(_ref, ["styles"]);

  return React.createElement("svg", _extends$309({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, props), React.createElement("path", { d: "M15 12V2H8v10H4l7.5 10L19 12zm-9 1h3V3h5v10h3l-5.5 7.33z", fillRule: "evenodd" }));
});

var _extends$310 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$310(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var DocumentManagement24SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$310(_ref, ["styles"]);

  return React.createElement("svg", _extends$310({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, props), React.createElement("path", { d: "M5 3v3h1V4h15v12h-1v1h2V3H5z" }), React.createElement("path", { d: "M14 7H2v14h17v-9zm1 2.41L16.59 11H15zM18 20H3V8h11v4h4z" }), React.createElement("path", { d: "M9 13v-2h4v-1H4v8h7v-2h-1v1H5v-6h3v2h1zm8 0h-1v4h-2v-1h-1v2h4v-5z" }));
});

var _extends$311 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$311(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var Devices24SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$311(_ref, ["styles"]);

  return React.createElement("svg", _extends$311({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, props), React.createElement("path", { d: "M15 16h7V3H4v4h1V4h16v11h-9v1h2v2h-2v1h7v-1h-4v-2z" }), React.createElement("path", { d: "M2 8v14h9V8zm8 13H3v-2h7zm-7-3V9h7v9z" }));
});

var _extends$312 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$312(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var DeviceTablet24SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$312(_ref, ["styles"]);

  return React.createElement("svg", _extends$312({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, props), React.createElement("path", { d: "M19 11h1v2h-1z" }), React.createElement("path", { d: "M2 4v16h20V4zm1 15V5h14v14zm18 0h-3V5h3z" }));
});

var _extends$313 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$313(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var DeviceMobile24SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$313(_ref, ["styles"]);

  return React.createElement("svg", _extends$313({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, props), React.createElement("path", { d: "M5 2v20h13V2zm12 19H6v-3h11zM6 17V3h11v14z" }), React.createElement("path", { d: "M10 19h3v1h-3z" }));
});

var _extends$314 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$314(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var DeviceDesktop24SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$314(_ref, ["styles"]);

  return React.createElement("svg", _extends$314({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, props), React.createElement("path", { d: "M14 18h8V3H2v15h8v2H6v1h12v-1h-4v-2zm-1 2h-2v-2h2zM3 17V4h18v13z" }));
});

var _extends$315 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$315(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var Dashboard24SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$315(_ref, ["styles"]);

  return React.createElement("svg", _extends$315({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, props), React.createElement("path", { d: "M11.79 4A9.51 9.51 0 0 0 4.1 19.46L9.46 17a2.48 2.48 0 0 0 1.46 1 2.86 2.86 0 0 0 .58.06 2.46 2.46 0 0 0 2-1.05l5.37 2.51A9.41 9.41 0 0 0 21 13.55 9.61 9.61 0 0 0 11.79 4zM13 15.8a1.49 1.49 0 0 1-1.5 1.2 1.48 1.48 0 0 1-1.41-1 1.51 1.51 0 0 1 .42-1.64l4.11-3.49zm5.62 2.41L13.94 16l2.18-6.45 1-1-.71-.71-1.21 1.25-5.36 4.55A2.5 2.5 0 0 0 9.08 16l-4.66 2.21A8.5 8.5 0 0 1 11.5 5h.26A8.67 8.67 0 0 1 20 13.55a8.44 8.44 0 0 1-1.42 4.66z" }), React.createElement("path", { d: "M4 13h3v1H4zm12 0h3v1h-3zM5.847 8.547l.707-.707 2.122 2.121-.707.707zM11 6h1v3h-1z" }));
});

var _extends$316 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$316(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var CtaArrowRight24SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$316(_ref, ["styles"]);

  return React.createElement("svg", _extends$316({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, props), React.createElement("path", { d: "M12 2a10 10 0 1 0 10 10A10 10 0 0 0 12 2zm0 19a9 9 0 1 1 9-9 9 9 0 0 1-9 9z", fillRule: "evenodd" }), React.createElement("path", { d: "M11 10H6v4h5v3l7-5-7-5zm1-1l4.28 3L12 15v-2H7v-2h5z", fillRule: "evenodd" }));
});

var _extends$317 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$317(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var Copy24SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$317(_ref, ["styles"]);

  return React.createElement("svg", _extends$317({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, props), React.createElement("path", { d: "M7 17H4V4h7v1h2l-2-2H3v15h4v-1z" }), React.createElement("path", { d: "M16 6H8v15h13V11zm1 2.41L18.59 10H17zM20 20H9V7h7v4h4z" }));
});

var _extends$318 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$318(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var Complete24SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$318(_ref, ["styles"]);

  return React.createElement("svg", _extends$318({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, props), React.createElement("path", { d: "M12 3a9 9 0 1 0 9 9 9 9 0 0 0-9-9zm0 17a8 8 0 1 1 8-8 8 8 0 0 1-8 8z" }), React.createElement("path", { d: "M16.29 8.73l-5.65 5.65-2.5-2.49-.71.71 3.21 3.2L17 9.43l-.71-.7z" }));
});

var _extends$319 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$319(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var Compare24SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$319(_ref, ["styles"]);

  return React.createElement("svg", _extends$319({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, props), React.createElement("path", { d: "M15.68 7.5L8 2v3H2v5h6v3zM3 9V6h6V4l5 3.5-5 3.55V9zm13 5v-3l-7.68 5.5L16 22v-3h6v-5zm5 4h-6v2.05l-5-3.55 5-3.5v2h6z", fillRule: "evenodd" }));
});

var _extends$320 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$320(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var Comment24SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$320(_ref, ["styles"]);

  return React.createElement("svg", _extends$320({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, props), React.createElement("path", { d: "M2 3v13h4v6l6-6h10V3zm19 12h-9.41L7 19.59V15H3V4h18z" }), React.createElement("path", { d: "M6 7h13v1H6zm0 4h8v1H6z" }));
});

var _extends$321 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$321(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var CollapsePanel24SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$321(_ref, ["styles"]);

  return React.createElement("svg", _extends$321({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, props), React.createElement("path", { d: "M18 10V7l-7 5 7 5v-3h4v-4zm3 3h-4v2l-4.28-3L17 9v2h4z", fillRule: "evenodd" }), React.createElement("path", { d: "M2 3v18h8V3zm7 17H3V4h6z" }));
});

var _extends$322 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$322(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var Collaboration24SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$322(_ref, ["styles"]);

  return React.createElement("svg", _extends$322({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, props), React.createElement("path", { d: "M8 9v7h8V8H8zm1 0h6v6H9z" }), React.createElement("path", { d: "M21 3H8v4h1V4h11v11h-3v1h4zm-6 14v3H4V9h3V8H3v13h13v-4z" }));
});

var _extends$323 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$323(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var Cloud24SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$323(_ref, ["styles"]);

  return React.createElement("svg", _extends$323({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, props), React.createElement("path", { d: "M19.55 13.06A5.08 5.08 0 0 0 20 11a5 5 0 0 0-9.67-1.76A4.18 4.18 0 0 0 9 9a4 4 0 0 0-4 4 3 3 0 0 0 0 6h14a3 3 0 0 0 .55-5.94zM19 18H5a2 2 0 0 1 0-4h1v-1a3 3 0 0 1 3-3 2.89 2.89 0 0 1 1 .19l.92.33.35-.92A4 4 0 0 1 19 11a4 4 0 0 1-.36 1.64l-.53 1.17 1.26.23A2 2 0 0 1 19 18z" }));
});

var _extends$324 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$324(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var ClosedCaptioning24SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$324(_ref, ["styles"]);

  return React.createElement("svg", _extends$324({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, props), React.createElement("path", { d: "M7.85 12.87c-.17 1-.52 2.07-1.16 2.07-.79 0-1.28-1.32-1.28-3.44 0-2.54.67-3.44 1.23-3.44.25 0 .77 0 1.1 1.78l.11.54 3.15-.9-.08-.48c-.46-2.72-1.84-4-4.21-4C3.74 5 2 7.38 2 11.52S3.77 18 6.68 18C9 18 10.45 16.6 11 13.74v-.44l-3-1zM9.92 14c-.5 2.08-1.51 3-3.24 3C4.36 17 3 15 3 11.52 3 9.46 3.51 6 6.71 6c1.72 0 2.71.86 3.14 2.77l-1.24.35c-.26-1-.76-2.06-2-2.06-.67 0-2.24.44-2.24 4.44s1.43 4.44 2.28 4.44c1.3 0 1.81-1.41 2-2.33zM18 12.32l-.11.55c-.17 1-.52 2.07-1.16 2.07-.79 0-1.28-1.32-1.28-3.44 0-2.54.66-3.44 1.23-3.44.25 0 .77 0 1.1 1.78l.11.54 3.11-.9-.08-.48c-.46-2.72-1.84-4-4.21-4C13.74 5 12 7.38 12 11.52S13.77 18 16.68 18c2.32 0 3.77-1.4 4.32-4.26v-.44zM16.68 17C14.36 17 13 15 13 11.52 13 9.46 13.51 6 16.71 6c1.72 0 2.71.86 3.14 2.77l-1.24.35c-.26-1-.76-2.12-2-2.12-.67 0-2.24.5-2.24 4.5s1.47 4.5 2.32 4.5c1.3 0 1.81-1.47 2-2.39l1.2.37c-.47 2.08-1.48 3.02-3.21 3.02z" }));
});

var _extends$325 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$325(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var Clock24SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$325(_ref, ["styles"]);

  return React.createElement("svg", _extends$325({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, props), React.createElement("path", { d: "M11.5 3a8.5 8.5 0 1 0 8.5 8.5A8.51 8.51 0 0 0 11.5 3zm0 16a7.5 7.5 0 1 1 7.5-7.5 7.5 7.5 0 0 1-7.5 7.5z" }), React.createElement("path", { d: "M12 11V6h-1v6h6v-1h-5z" }));
});

var _extends$326 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$326(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var Checkmark24SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$326(_ref, ["styles"]);

  return React.createElement("svg", _extends$326({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, props), React.createElement("path", { d: "M17.23 5.55l-7.78 7.78-3.54-3.54-2.82 2.83 3.53 3.54L9.45 19l2.83-2.83 7.78-7.78zm-7.78 12l-4.95-5 1.41-1.41 3.54 3.53L17.23 7l1.41 1.42z" }));
});

var _extends$327 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$327(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var Checklist24SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$327(_ref, ["styles"]);

  return React.createElement("svg", _extends$327({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, props), React.createElement("path", { d: "M3 2v19h18V2zm17 18H4V3h16z" }), React.createElement("path", { d: "M6 5v3h3V5zm2 2H7V6h1zm3-1h7v1h-7zm-5 4v3h3v-3zm2 2H7v-1h1zm3-1h7v1h-7zm-5 4v3h3v-3zm2 2H7v-1h1zm3-1h7v1h-7z" }));
});

var _extends$328 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$328(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var Chat24SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$328(_ref, ["styles"]);

  return React.createElement("svg", _extends$328({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, props), React.createElement("path", { d: "M17 8v1h4v8h-3v2.59L15.41 17H9v-2.59l-1 1V18h7l4 4v-4h3V8h-5z" }), React.createElement("path", { d: "M2 3v10h3v4l4-4h7V3zm13 9H8.59L6 14.59V12H3V4h12z" }));
});

var _extends$329 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$329(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var CartFull24SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$329(_ref, ["styles"]);

  return React.createElement("svg", _extends$329({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, props), React.createElement("circle", { cx: "7.5", cy: "20.5", r: "1.5" }), React.createElement("circle", { cx: "16.5", cy: "20.5", r: "1.5" }), React.createElement("path", { d: "M7.9 15H18l3-8H6.87l-.36-1.8-4.1-1.88-.41.91 3.63 1.66 1.63 8.23L5 18h14v-1H6.73z" }));
});

var _extends$330 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$330(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var CartEmpty24SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$330(_ref, ["styles"]);

  return React.createElement("svg", _extends$330({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, props), React.createElement("circle", { cx: "7.5", cy: "20.5", r: "1.5" }), React.createElement("circle", { cx: "16.5", cy: "20.5", r: "1.5" }), React.createElement("path", { d: "M7.9 15H18l3-8H6.87l-.36-1.8-4.1-1.88-.41.91 3.63 1.66 1.63 8.23L5 18h14v-1H6.73zm-.83-7h12.49l-2.23 6H8.25z" }));
});

var _extends$331 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$331(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var CaretUp24SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$331(_ref, ["styles"]);

  return React.createElement("svg", _extends$331({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, props), React.createElement("path", { d: "M12 4.1L2.1 14l3.54 3.54L12 11.17l6.36 6.37L21.9 14zm0 5.66l-6.36 6.36L3.51 14 12 5.51 20.49 14l-2.13 2.12z" }));
});

var _extends$332 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$332(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var CaretRight24SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$332(_ref, ["styles"]);

  return React.createElement("svg", _extends$332({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, props), React.createElement("path", { d: "M10 2.1L6.46 5.64 12.83 12l-6.37 6.36L10 21.9l9.9-9.9zM7.88 18.36L14.24 12 7.88 5.64 10 3.51 18.49 12 10 20.49z" }));
});

var _extends$333 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$333(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var CaretLeft24SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$333(_ref, ["styles"]);

  return React.createElement("svg", _extends$333({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, props), React.createElement("path", { d: "M17.54 5.64L14 2.1 4.1 12l9.9 9.9 3.54-3.54L11.17 12zm-1.42 12.72L14 20.49 5.51 12 14 3.51l2.12 2.13L9.76 12z" }));
});

var _extends$334 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$334(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var CaretDown24SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$334(_ref, ["styles"]);

  return React.createElement("svg", _extends$334({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, props), React.createElement("path", { d: "M18.36 6.46L12 12.83 5.64 6.46 2.1 10l9.9 9.9 9.9-9.9zM3.51 10l2.13-2.12L12 14.24l6.36-6.36L20.49 10 12 18.49z" }));
});

var _extends$335 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$335(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var Calendar24SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$335(_ref, ["styles"]);

  return React.createElement("svg", _extends$335({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, props), React.createElement("path", { d: "M4 4v16h16V4zm1 4h4v3H5zm0 4h4v3H5zm0 7v-3h4v3zm5 0v-3h4v3zm4-8h-4V8h4zm0 1v3h-4v-3zm5 7h-4v-3h4zm0-4h-4v-3h4zm0-4h-4V8h4zM5 7V5h14v2z" }));
});

var _extends$336 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$336(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var Building24SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$336(_ref, ["styles"]);

  return React.createElement("svg", _extends$336({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, props), React.createElement("path", { d: "M21 10h-2V3h-2V2H7v1H5v7H3v12h18zM5 21H4V11h1zm2 0H6V4h1zm3 0v-4h4v4zm6 0h-1v-5H9v5H8V3h8zm2 0h-1V4h1zm2 0h-1V11h1z" }), React.createElement("path", { d: "M9 5h2v2H9zm4 0h2v2h-2zM9 8h2v2H9zm4 0h2v2h-2zm-4 3h2v2H9zm4 0h2v2h-2z" }));
});

var _extends$337 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$337(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var Bookmark24SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$337(_ref, ["styles"]);

  return React.createElement("svg", _extends$337({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, props), React.createElement("path", { d: "M17 3H7v18l5-4 5 4zm-1 15.92l-4-3.2-4 3.2V4h8z" }));
});

var _extends$338 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$338(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var Billing24SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$338(_ref, ["styles"]);

  return React.createElement("svg", _extends$338({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, props), React.createElement("path", { d: "M19 2H4v20h16V3a1 1 0 0 0-1-1zm0 19H5V3h14z" }), React.createElement("path", { d: "M11 19h7v1h-7zm7-14H6v13h12zM9 17H7v-2h2zm0-3H7v-2h2zm0-3H7V9h2zm0-3H7V6h2zm8 9h-7v-2h7zm0-3h-7v-2h7zm0-3h-7V9h7zm0-3h-7V6h7z" }));
});

var _extends$339 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$339(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var BillStack24SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$339(_ref, ["styles"]);

  return React.createElement("svg", _extends$339({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, props), React.createElement("path", { d: "M22 5H2v15h20zM9 19H3v-1h6zm0-2H3v-1h6zm0-4H5V8h4zm0-6H4v7h5v1H3V6h6zm5 3v9h-4V6h4zm1-2h4v5h-4zm6 11h-6v-1h6zm0-2h-6v-1h6zm0-2h-6v-1h5V7h-5V6h6z" }));
});

var _extends$340 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$340(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var Back24SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$340(_ref, ["styles"]);

  return React.createElement("svg", _extends$340({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, props), React.createElement("path", { d: "M12 8V4L2 11.5 12 19v-4h10V8zm9 6H11v3l-7.33-5.5L11 6v3h10z", fillRule: "evenodd" }));
});

var _extends$341 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$341(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var Attachment24SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$341(_ref, ["styles"]);

  return React.createElement("svg", _extends$341({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, props), React.createElement("path", { d: "M20 11v2h1v8H6v-1H5v2h17v-9l-2-2z" }), React.createElement("path", { d: "M14 5h-3v1h3v4h4v8H3V6h5V5H6v-.5a1.5 1.5 0 0 1 3 0V10a1 1 0 0 1-2 0V8H6v2a2 2 0 0 0 4 0V4.5a2.5 2.5 0 0 0-5 0V5H2v14h17v-9zm1 4V7.41L16.59 9z" }));
});

var _extends$342 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$342(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var Attach24SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$342(_ref, ["styles"]);

  return React.createElement("svg", _extends$342({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, props), React.createElement("path", { d: "M16 6h-4v1h4v4h4v9H4V7h5V6H7v-.5a1.5 1.5 0 0 1 3 0V12a1 1 0 0 1-2 0V9H7v3a2 2 0 0 0 4 0V5.5a2.5 2.5 0 0 0-5 0V6H3v15h18V11zm1 4V8.41L18.59 10z" }));
});

var _extends$343 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$343(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var AreaPost24SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$343(_ref, ["styles"]);

  return React.createElement("svg", _extends$343({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, props), React.createElement("path", { d: "M3 9h1v4H3zm1-5h3V3H3v4h1V4zm5-1h4v1H9zM4 18v-3H3v4h4v-1H4zM15 3v1h3v3h1V3h-4zM9 18h3v1H9zm13-1h-3v-3h-2v3h-3v2h3v3h2v-3h3v-2zm-4-8h1v3h-1z" }));
});

var _extends$344 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$344(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var Archive24SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$344(_ref, ["styles"]);

  return React.createElement("svg", _extends$344({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, props), React.createElement("path", { d: "M21 5H3v4h1v11h16V9h1zm-2 14H5V9h14zm1-11H4V6h16z" }), React.createElement("path", { d: "M8 12h8v1H8z" }));
});

var _extends$345 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$345(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var Alert24SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$345(_ref, ["styles"]);

  return React.createElement("svg", _extends$345({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, props), React.createElement("path", { d: "M21.84 18.1L13.07 3.75a1.25 1.25 0 0 0-2.14 0L2.16 18.1A1.25 1.25 0 0 0 3.23 20h17.54a1.25 1.25 0 0 0 1.07-1.9zm-.85.77a.24.24 0 0 1-.22.13H3.23a.24.24 0 0 1-.23-.13.23.23 0 0 1 0-.25l8.79-14.35a.24.24 0 0 1 .42 0L21 18.62a.23.23 0 0 1 0 .25z" }), React.createElement("circle", { cx: "12", cy: "16", r: "1" }), React.createElement("path", { d: "M11.48 13.68a.36.36 0 0 0 .34.32h.36a.36.36 0 0 0 .34-.32L13 9.19a1.68 1.68 0 0 0 0-.5.94.94 0 0 0-.94-.69h-.12a.94.94 0 0 0-.91.69 1.68 1.68 0 0 0 0 .5z" }));
});

var _extends$346 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$346(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var Add24SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$346(_ref, ["styles"]);

  return React.createElement("svg", _extends$346({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, props), React.createElement("path", { d: "M21 10h-7V3h-4v7H3v4h7.13v7H14v-7h7zm-1 3h-7v7h-2v-7H4v-2h7V4h2v7h7z" }));
});

var _extends$347 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$347(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var AddPage24SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$347(_ref, ["styles"]);

  return React.createElement("svg", _extends$347({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, props), React.createElement("path", { d: "M3 3h9v4h4v6h1V7l-5-5H2v17h11v-1H3zm10 1.41L14.59 6H13z" }), React.createElement("path", { d: "M19 17v-3h-2v3h-3v2h3v3h2v-3h3v-2h-3z" }));
});

var _extends$348 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$348(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var AddMember24SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$348(_ref, ["styles"]);

  return React.createElement("svg", _extends$348({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, props), React.createElement("path", { d: "M5 14.5a4.5 4.5 0 0 1 9 0V16h1v-1.5a5.49 5.49 0 0 0-3.59-5.15A4.2 4.2 0 0 0 13 6a3.78 3.78 0 0 0-3.5-4A3.78 3.78 0 0 0 6 6a4.2 4.2 0 0 0 1.59 3.35A5.49 5.49 0 0 0 4 14.5V20h9v-1H5zM7 6a2.79 2.79 0 0 1 2.5-3A2.79 2.79 0 0 1 12 6a2.79 2.79 0 0 1-2.5 3A2.79 2.79 0 0 1 7 6z" }), React.createElement("path", { d: "M19 17v-3h-2v3h-3v2h3v3h2v-3h3v-2h-3z" }));
});

var _extends$349 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$349(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var AddFolder24SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$349(_ref, ["styles"]);

  return React.createElement("svg", _extends$349({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, props), React.createElement("path", { d: "M3 8h7.26l1.52-1H20v9h1V6h-9.21L9 4H2v16h11v-1H3zm0-3h6l1.8 1.42L10 7H3z" }), React.createElement("path", { d: "M19 17v-3h-2v3h-3v2h3v3h2v-3h3v-2h-3z" }));
});

var ADD_FOLDER = "AddFolder";
var ADD_MEMBER = "AddMember";
var ADD_PAGE = "AddPage";
var ADD = "Add";
var ALERT = "Alert";
var ARCHIVE = "Archive";
var AREA_POST = "AreaPost";
var ATTACH = "Attach";
var ATTACHMENT = "Attachment";
var BACK = "Back";
var BILL_STACK = "BillStack";
var BILLING = "Billing";
var BOOKMARK = "Bookmark";
var BUILDING = "Building";
var CALENDAR = "Calendar";
var CARET_DOWN = "CaretDown";
var CARET_LEFT = "CaretLeft";
var CARET_RIGHT = "CaretRight";
var CARET_UP = "CaretUp";
var CART_EMPTY = "CartEmpty";
var CART_FULL = "CartFull";
var CHAT = "Chat";
var CHECKLIST = "Checklist";
var CHECKMARK = "Checkmark";
var CLOCK = "Clock";
var CLOSED_CAPTIONING = "ClosedCaptioning";
var CLOUD = "Cloud";
var COLLABORATION = "Collaboration";
var COLLAPSE_PANEL = "CollapsePanel";
var COMMENT = "Comment";
var COMPARE = "Compare";
var COMPLETE = "Complete";
var COPY = "Copy";
var CTA_ARROW_RIGHT = "CtaArrowRight";
var DASHBOARD = "Dashboard";
var DEVICE_DESKTOP = "DeviceDesktop";
var DEVICE_MOBILE = "DeviceMobile";
var DEVICE_TABLET = "DeviceTablet";
var DEVICES = "Devices";
var DOCUMENT_MANAGEMENT = "DocumentManagement";
var DOWN = "Down";
var DOWNLOAD = "Download";
var EDIT_PROFILE = "EditProfile";
var EDIT = "Edit";
var EDUCATION = "Education";
var ERROR = "Error";
var EXPAND_PANEL = "ExpandPanel";
var EXPORT_MOVE = "ExportMove";
var EXTERNAL_LINK = "ExternalLink";
var EXTERNAL = "External";
var FAVORITE = "Favorite";
var FEATURED = "Featured";
var FEEDBACK = "Feedback";
var FIELD = "Field";
var FILE_ASSEMBLY = "FileAssembly";
var FILE_AUDIO = "FileAudio";
var FILE_DOCUMENT = "FileDocument";
var FILE_GENERIC = "FileGeneric";
var FILE_IMAGE = "FileImage";
var FILE_PART = "FilePart";
var FILE_PDF = "FilePdf";
var FILE_PRESENTATION = "FilePresentation";
var FILE_SPREADSHEET = "FileSpreadsheet";
var FILE_VIDEO = "FileVideo";
var FILE_ZIP = "FileZip";
var FILTER_TOKENS = "FilterTokens";
var FILTER = "Filter";
var FLAG = "Flag";
var FOLDER_OPEN = "FolderOpen";
var FOLDER = "Folder";
var FORUMS = "Forums";
var FORWARD = "Forward";
var GLOBE = "Globe";
var GRAPH = "Graph";
var GRID = "Grid";
var HELP = "Help";
var HIDDEN = "Hidden";
var HIERARCHY = "Hierarchy";
var HOME = "Home";
var IMPORT = "Import";
var INBOX = "Inbox";
var INFO = "Info";
var ITEM = "Item";
var LINK = "Link";
var LIST = "List";
var LOCATION = "Location";
var LOCK = "Lock";
var MAIL = "Mail";
var MANAGE_ACCESS = "ManageAccess";
var MAXIMIZE = "Maximize";
var MINIMIZE = "Minimize";
var MORE_VERTICAL = "MoreVertical";
var MORE = "More";
var MUTE = "Mute";
var NOT_EDITABLE = "NotEditable";
var NOTIFICATION_OFF = "NotificationOff";
var NOTIFICATION = "Notification";
var ONLINE_VIEWERS = "OnlineViewers";
var PASTE = "Paste";
var PERMISSION_GROUP = "PermissionGroup";
var PERMISSION_INDIVIDUAL = "PermissionIndividual";
var PHOTOS = "Photos";
var PIN = "Pin";
var PLACEHOLDER = "Placeholder";
var PLAYBACK_FAST_FORWARD = "PlaybackFastForward";
var PLAYBACK_GO_TO_END = "PlaybackGoToEnd";
var PLAYBACK_GO_TO_START = "PlaybackGoToStart";
var PLAYBACK_LOOP = "PlaybackLoop";
var PLAYBACK_NEXT = "PlaybackNext";
var PLAYBACK_PAUSE = "PlaybackPause";
var PLAYBACK_PLAY = "PlaybackPlay";
var PLAYBACK_PREVIOUS = "PlaybackPrevious";
var PLAYBACK_RECORD = "PlaybackRecord";
var PLAYBACK_REWIND = "PlaybackRewind";
var PLAYBACK_SHUFFLE = "PlaybackShuffle";
var PLAYBACK_STOP = "PlaybackStop";
var PRINT = "Print";
var PRODUCTS_AND_SERVICES = "ProductsAndServices";
var PROFILE = "Profile";
var PROJECT_MANAGEMENT = "ProjectManagement";
var PROPERTIES = "Properties";
var PUBLISH = "Publish";
var QUANTITIES = "Quantities";
var RECOMMEND = "Recommend";
var REDO = "Redo";
var REPORT = "Report";
var SAVE_AS = "SaveAs";
var SAVE = "Save";
var SEARCH = "Search";
var SECURITY = "Security";
var SELECT_ALL = "SelectAll";
var SELECT_NONE = "SelectNone";
var SERVICE = "Service";
var SETTINGS = "Settings";
var SHARE = "Share";
var SOCIAL_BLOG = "SocialBlog";
var SOCIAL_FACEBOOK = "SocialFacebook";
var SOCIAL_INSTAGRAM = "SocialInstagram";
var SOCIAL_LINKEDIN = "SocialLinkedin";
var SOCIAL_TWITTER = "SocialTwitter";
var SOCIAL_YOUTUBE = "SocialYoutube";
var SORT = "Sort";
var SUBSCRIPTION = "Subscription";
var SUPPORT = "Support";
var SURVEY_EQUIPMENT = "SurveyEquipment";
var SYNC = "Sync";
var TAG = "Tag";
var TRASH = "Trash";
var TREE_VIEW = "TreeView";
var UNAVAILABLE = "Unavailable";
var UNDO = "Undo";
var UNLINK = "Unlink";
var UNLOCK = "Unlock";
var UNPIN = "Unpin";
var UP = "Up";
var UPLOAD = "Upload";
var USER_INACTIVE = "UserInactive";
var VISIBLE = "Visible";
var VOLUME = "Volume";
var ZOOM_IN = "ZoomIn";
var ZOOM_OUT = "ZoomOut";
var BACK_16 = "Back16";
var CARET_DOWN_M = "CaretDownM";
var CARET_DOWN_S = "CaretDownS";
var CARET_DOWN_XS = "CaretDownXs";
var CARET_LEFT_M = "CaretLeftM";
var CARET_LEFT_S = "CaretLeftS";
var CARET_LEFT_XS = "CaretLeftXs";
var CARET_RIGHT_M = "CaretRightM";
var CARET_RIGHT_S = "CaretRightS";
var CARET_RIGHT_XS = "CaretRightXs";
var CARET_UP_M = "CaretUpM";
var CARET_UP_S = "CaretUpS";
var CARET_UP_XS = "CaretUpXs";
var CHECKMARK_S = "CheckmarkS";
var CHECKMARK_XS = "CheckmarkXs";
var CLOSE_L = "CloseL";
var CLOSE_M = "CloseM";
var CLOSE_S = "CloseS";
var CLOSE_XS = "CloseXs";
var HAMBURGER_CLOSE = "HamburgerClose";
var HAMBURGER_DEFAULT = "HamburgerDefault";
var OPERATOR_MINUS_S = "OperatorMinusS";
var OPERATOR_MINUS_XS = "OperatorMinusXs";
var OPERATOR_PLUS_S = "OperatorPlusS";
var OPERATOR_PLUS_XS = "OperatorPlusXs";
var names = {
	ADD_FOLDER: ADD_FOLDER,
	ADD_MEMBER: ADD_MEMBER,
	ADD_PAGE: ADD_PAGE,
	ADD: ADD,
	ALERT: ALERT,
	ARCHIVE: ARCHIVE,
	AREA_POST: AREA_POST,
	ATTACH: ATTACH,
	ATTACHMENT: ATTACHMENT,
	BACK: BACK,
	BILL_STACK: BILL_STACK,
	BILLING: BILLING,
	BOOKMARK: BOOKMARK,
	BUILDING: BUILDING,
	CALENDAR: CALENDAR,
	CARET_DOWN: CARET_DOWN,
	CARET_LEFT: CARET_LEFT,
	CARET_RIGHT: CARET_RIGHT,
	CARET_UP: CARET_UP,
	CART_EMPTY: CART_EMPTY,
	CART_FULL: CART_FULL,
	CHAT: CHAT,
	CHECKLIST: CHECKLIST,
	CHECKMARK: CHECKMARK,
	CLOCK: CLOCK,
	CLOSED_CAPTIONING: CLOSED_CAPTIONING,
	CLOUD: CLOUD,
	COLLABORATION: COLLABORATION,
	COLLAPSE_PANEL: COLLAPSE_PANEL,
	COMMENT: COMMENT,
	COMPARE: COMPARE,
	COMPLETE: COMPLETE,
	COPY: COPY,
	CTA_ARROW_RIGHT: CTA_ARROW_RIGHT,
	DASHBOARD: DASHBOARD,
	DEVICE_DESKTOP: DEVICE_DESKTOP,
	DEVICE_MOBILE: DEVICE_MOBILE,
	DEVICE_TABLET: DEVICE_TABLET,
	DEVICES: DEVICES,
	DOCUMENT_MANAGEMENT: DOCUMENT_MANAGEMENT,
	DOWN: DOWN,
	DOWNLOAD: DOWNLOAD,
	EDIT_PROFILE: EDIT_PROFILE,
	EDIT: EDIT,
	EDUCATION: EDUCATION,
	ERROR: ERROR,
	EXPAND_PANEL: EXPAND_PANEL,
	EXPORT_MOVE: EXPORT_MOVE,
	EXTERNAL_LINK: EXTERNAL_LINK,
	EXTERNAL: EXTERNAL,
	FAVORITE: FAVORITE,
	FEATURED: FEATURED,
	FEEDBACK: FEEDBACK,
	FIELD: FIELD,
	FILE_ASSEMBLY: FILE_ASSEMBLY,
	FILE_AUDIO: FILE_AUDIO,
	FILE_DOCUMENT: FILE_DOCUMENT,
	FILE_GENERIC: FILE_GENERIC,
	FILE_IMAGE: FILE_IMAGE,
	FILE_PART: FILE_PART,
	FILE_PDF: FILE_PDF,
	FILE_PRESENTATION: FILE_PRESENTATION,
	FILE_SPREADSHEET: FILE_SPREADSHEET,
	FILE_VIDEO: FILE_VIDEO,
	FILE_ZIP: FILE_ZIP,
	FILTER_TOKENS: FILTER_TOKENS,
	FILTER: FILTER,
	FLAG: FLAG,
	FOLDER_OPEN: FOLDER_OPEN,
	FOLDER: FOLDER,
	FORUMS: FORUMS,
	FORWARD: FORWARD,
	GLOBE: GLOBE,
	GRAPH: GRAPH,
	GRID: GRID,
	HELP: HELP,
	HIDDEN: HIDDEN,
	HIERARCHY: HIERARCHY,
	HOME: HOME,
	IMPORT: IMPORT,
	INBOX: INBOX,
	INFO: INFO,
	ITEM: ITEM,
	LINK: LINK,
	LIST: LIST,
	LOCATION: LOCATION,
	LOCK: LOCK,
	MAIL: MAIL,
	MANAGE_ACCESS: MANAGE_ACCESS,
	MAXIMIZE: MAXIMIZE,
	MINIMIZE: MINIMIZE,
	MORE_VERTICAL: MORE_VERTICAL,
	MORE: MORE,
	MUTE: MUTE,
	NOT_EDITABLE: NOT_EDITABLE,
	NOTIFICATION_OFF: NOTIFICATION_OFF,
	NOTIFICATION: NOTIFICATION,
	ONLINE_VIEWERS: ONLINE_VIEWERS,
	PASTE: PASTE,
	PERMISSION_GROUP: PERMISSION_GROUP,
	PERMISSION_INDIVIDUAL: PERMISSION_INDIVIDUAL,
	PHOTOS: PHOTOS,
	PIN: PIN,
	PLACEHOLDER: PLACEHOLDER,
	PLAYBACK_FAST_FORWARD: PLAYBACK_FAST_FORWARD,
	PLAYBACK_GO_TO_END: PLAYBACK_GO_TO_END,
	PLAYBACK_GO_TO_START: PLAYBACK_GO_TO_START,
	PLAYBACK_LOOP: PLAYBACK_LOOP,
	PLAYBACK_NEXT: PLAYBACK_NEXT,
	PLAYBACK_PAUSE: PLAYBACK_PAUSE,
	PLAYBACK_PLAY: PLAYBACK_PLAY,
	PLAYBACK_PREVIOUS: PLAYBACK_PREVIOUS,
	PLAYBACK_RECORD: PLAYBACK_RECORD,
	PLAYBACK_REWIND: PLAYBACK_REWIND,
	PLAYBACK_SHUFFLE: PLAYBACK_SHUFFLE,
	PLAYBACK_STOP: PLAYBACK_STOP,
	PRINT: PRINT,
	PRODUCTS_AND_SERVICES: PRODUCTS_AND_SERVICES,
	PROFILE: PROFILE,
	PROJECT_MANAGEMENT: PROJECT_MANAGEMENT,
	PROPERTIES: PROPERTIES,
	PUBLISH: PUBLISH,
	QUANTITIES: QUANTITIES,
	RECOMMEND: RECOMMEND,
	REDO: REDO,
	REPORT: REPORT,
	SAVE_AS: SAVE_AS,
	SAVE: SAVE,
	SEARCH: SEARCH,
	SECURITY: SECURITY,
	SELECT_ALL: SELECT_ALL,
	SELECT_NONE: SELECT_NONE,
	SERVICE: SERVICE,
	SETTINGS: SETTINGS,
	SHARE: SHARE,
	SOCIAL_BLOG: SOCIAL_BLOG,
	SOCIAL_FACEBOOK: SOCIAL_FACEBOOK,
	SOCIAL_INSTAGRAM: SOCIAL_INSTAGRAM,
	SOCIAL_LINKEDIN: SOCIAL_LINKEDIN,
	SOCIAL_TWITTER: SOCIAL_TWITTER,
	SOCIAL_YOUTUBE: SOCIAL_YOUTUBE,
	SORT: SORT,
	SUBSCRIPTION: SUBSCRIPTION,
	SUPPORT: SUPPORT,
	SURVEY_EQUIPMENT: SURVEY_EQUIPMENT,
	SYNC: SYNC,
	TAG: TAG,
	TRASH: TRASH,
	TREE_VIEW: TREE_VIEW,
	UNAVAILABLE: UNAVAILABLE,
	UNDO: UNDO,
	UNLINK: UNLINK,
	UNLOCK: UNLOCK,
	UNPIN: UNPIN,
	UP: UP,
	UPLOAD: UPLOAD,
	USER_INACTIVE: USER_INACTIVE,
	VISIBLE: VISIBLE,
	VOLUME: VOLUME,
	ZOOM_IN: ZOOM_IN,
	ZOOM_OUT: ZOOM_OUT,
	BACK_16: BACK_16,
	CARET_DOWN_M: CARET_DOWN_M,
	CARET_DOWN_S: CARET_DOWN_S,
	CARET_DOWN_XS: CARET_DOWN_XS,
	CARET_LEFT_M: CARET_LEFT_M,
	CARET_LEFT_S: CARET_LEFT_S,
	CARET_LEFT_XS: CARET_LEFT_XS,
	CARET_RIGHT_M: CARET_RIGHT_M,
	CARET_RIGHT_S: CARET_RIGHT_S,
	CARET_RIGHT_XS: CARET_RIGHT_XS,
	CARET_UP_M: CARET_UP_M,
	CARET_UP_S: CARET_UP_S,
	CARET_UP_XS: CARET_UP_XS,
	CHECKMARK_S: CHECKMARK_S,
	CHECKMARK_XS: CHECKMARK_XS,
	CLOSE_L: CLOSE_L,
	CLOSE_M: CLOSE_M,
	CLOSE_S: CLOSE_S,
	CLOSE_XS: CLOSE_XS,
	HAMBURGER_CLOSE: HAMBURGER_CLOSE,
	HAMBURGER_DEFAULT: HAMBURGER_DEFAULT,
	OPERATOR_MINUS_S: OPERATOR_MINUS_S,
	OPERATOR_MINUS_XS: OPERATOR_MINUS_XS,
	OPERATOR_PLUS_S: OPERATOR_PLUS_S,
	OPERATOR_PLUS_XS: OPERATOR_PLUS_XS
};

var higIconSets = [{ "title": "Regular", "dirName": "regular", "size": "24", "iconNames": ["AddFolder", "AddMember", "AddPage", "Add", "Alert", "Archive", "AreaPost", "Attach", "Attachment", "Back", "BillStack", "Billing", "Bookmark", "Building", "Calendar", "CaretDown", "CaretLeft", "CaretRight", "CaretUp", "CartEmpty", "CartFull", "Chat", "Checklist", "Checkmark", "Clock", "ClosedCaptioning", "Cloud", "Collaboration", "CollapsePanel", "Comment", "Compare", "Complete", "Copy", "CtaArrowRight", "Dashboard", "DeviceDesktop", "DeviceMobile", "DeviceTablet", "Devices", "DocumentManagement", "Down", "Download", "EditProfile", "Edit", "Education", "Error", "ExpandPanel", "ExportMove", "ExternalLink", "External", "Favorite", "Featured", "Feedback", "Field", "FileAssembly", "FileAudio", "FileDocument", "FileGeneric", "FileImage", "FilePart", "FilePdf", "FilePresentation", "FileSpreadsheet", "FileVideo", "FileZip", "FilterTokens", "Filter", "Flag", "FolderOpen", "Folder", "Forums", "Forward", "Globe", "Graph", "Grid", "Help", "Hidden", "Hierarchy", "Home", "Import", "Inbox", "Info", "Item", "Link", "List", "Location", "Lock", "Mail", "ManageAccess", "Maximize", "Minimize", "MoreVertical", "More", "Mute", "NotEditable", "NotificationOff", "Notification", "OnlineViewers", "Paste", "PermissionGroup", "PermissionIndividual", "Photos", "Pin", "Placeholder", "PlaybackFastForward", "PlaybackGoToEnd", "PlaybackGoToStart", "PlaybackLoop", "PlaybackNext", "PlaybackPause", "PlaybackPlay", "PlaybackPrevious", "PlaybackRecord", "PlaybackRewind", "PlaybackShuffle", "PlaybackStop", "Print", "ProductsAndServices", "Profile", "ProjectManagement", "Properties", "Publish", "Quantities", "Recommend", "Redo", "Report", "SaveAs", "Save", "Search", "Security", "SelectAll", "SelectNone", "Service", "Settings", "Share", "SocialBlog", "SocialFacebook", "SocialInstagram", "SocialLinkedin", "SocialTwitter", "SocialYoutube", "Sort", "Subscription", "Support", "SurveyEquipment", "Sync", "Tag", "Trash", "TreeView", "Unavailable", "Undo", "Unlink", "Unlock", "Unpin", "Up", "Upload", "UserInactive", "Visible", "Volume", "ZoomIn", "ZoomOut"] }, { "title": "Information Dense", "dirName": "information-dense", "size": "16", "iconNames": ["AddFolder", "AddMember", "AddPage", "Add", "Alert", "Archive", "AreaPost", "Attach", "Attachment", "Back16", "Back", "BillStack", "Billing", "Bookmark", "Building", "Calendar", "CaretDown", "CaretLeft", "CaretRight", "CaretUp", "CartEmpty", "CartFull", "Chat", "Checklist", "Checkmark", "Clock", "ClosedCaptioning", "Cloud", "Collaboration", "CollapsePanel", "Comment", "Compare", "Complete", "Copy", "CtaArrowRight", "Dashboard", "DeviceDesktop", "DeviceMobile", "DeviceTablet", "Devices", "DocumentManagement", "Down", "Download", "EditProfile", "Edit", "Education", "Error", "ExpandPanel", "ExportMove", "ExternalLink", "External", "Favorite", "Featured", "Feedback", "Field", "FileAssembly", "FileAudio", "FileDocument", "FileGeneric", "FileImage", "FilePart", "FilePdf", "FilePresentation", "FileSpreadsheet", "FileVideo", "FileZip", "FilterTokens", "Filter", "Flag", "FolderOpen", "Folder", "Forums", "Forward", "Globe", "Graph", "Grid", "Help", "Hidden", "Hierarchy", "Home", "Import", "Inbox", "Info", "Item", "Link", "List", "Location", "Lock", "Mail", "ManageAccess", "Maximize", "Minimize", "MoreVertical", "More", "Mute", "NotEditable", "NotificationOff", "Notification", "OnlineViewers", "Paste", "PermissionGroup", "PermissionIndividual", "Photos", "Pin", "Placeholder", "PlaybackFastForward", "PlaybackGoToEnd", "PlaybackGoToStart", "PlaybackLoop", "PlaybackNext", "PlaybackPause", "PlaybackPlay", "PlaybackPrevious", "PlaybackRecord", "PlaybackRewind", "PlaybackShuffle", "PlaybackStop", "Print", "ProductsAndServices", "Profile", "ProjectManagement", "Properties", "Publish", "Quantities", "Recommend", "Redo", "Report", "SaveAs", "Save", "Search", "Security", "SelectAll", "SelectNone", "Service", "Settings", "Share", "SocialBlog", "SocialFacebook", "SocialInstagram", "SocialLinkedin", "SocialTwitter", "SocialYoutube", "Sort", "Subscription", "Support", "SurveyEquipment", "Sync", "Tag", "Trash", "TreeView", "Unavailable", "Undo", "Unlink", "Unlock", "Unpin", "Up", "Upload", "UserInactive", "Visible", "Volume", "ZoomIn", "ZoomOut"] }, { "title": "UI Controls", "dirName": "ui-controls", "size": "UI", "iconNames": ["CaretDownM", "CaretDownS", "CaretDownXs", "CaretLeftM", "CaretLeftS", "CaretLeftXs", "CaretRightM", "CaretRightS", "CaretRightXs", "CaretUpM", "CaretUpS", "CaretUpXs", "CheckmarkS", "CheckmarkXs", "CloseL", "CloseM", "CloseS", "CloseXs", "HamburgerClose", "HamburgerDefault", "OperatorMinusS", "OperatorMinusXs", "OperatorPlusS", "OperatorPlusXs"] }, { "title": "Size 12", "dirName": "size12", "size": "12", "iconNames": ["Alert", "Complete", "Error"] }];

var sizes = Object.freeze({
  PX_24: "24",
  PX_16: "16",
  PX_UI: "UI"
});

var AVAILABLE_SIZES = Object.freeze(Object.values(sizes));

/* eslint-disable */

var AVAILABLE_NAMES = Object.freeze(Object.values(names));

var AddFolder24 = function AddFolder24(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref) {
      var resolvedRoles = _ref.resolvedRoles;

      var baseProps = {
        width: "24px",
        height: "24px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(AddFolder24SVG, propsClone);
    }
  );
};

var AddMember24 = function AddMember24(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref2) {
      var resolvedRoles = _ref2.resolvedRoles;

      var baseProps = {
        width: "24px",
        height: "24px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(AddMember24SVG, propsClone);
    }
  );
};

var AddPage24 = function AddPage24(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref3) {
      var resolvedRoles = _ref3.resolvedRoles;

      var baseProps = {
        width: "24px",
        height: "24px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(AddPage24SVG, propsClone);
    }
  );
};

var Add24 = function Add24(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref4) {
      var resolvedRoles = _ref4.resolvedRoles;

      var baseProps = {
        width: "24px",
        height: "24px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(Add24SVG, propsClone);
    }
  );
};

var Alert24 = function Alert24(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref5) {
      var resolvedRoles = _ref5.resolvedRoles;

      var baseProps = {
        width: "24px",
        height: "24px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(Alert24SVG, propsClone);
    }
  );
};

var Archive24 = function Archive24(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref6) {
      var resolvedRoles = _ref6.resolvedRoles;

      var baseProps = {
        width: "24px",
        height: "24px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(Archive24SVG, propsClone);
    }
  );
};

var AreaPost24 = function AreaPost24(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref7) {
      var resolvedRoles = _ref7.resolvedRoles;

      var baseProps = {
        width: "24px",
        height: "24px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(AreaPost24SVG, propsClone);
    }
  );
};

var Attach24 = function Attach24(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref8) {
      var resolvedRoles = _ref8.resolvedRoles;

      var baseProps = {
        width: "24px",
        height: "24px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(Attach24SVG, propsClone);
    }
  );
};

var Attachment24 = function Attachment24(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref9) {
      var resolvedRoles = _ref9.resolvedRoles;

      var baseProps = {
        width: "24px",
        height: "24px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(Attachment24SVG, propsClone);
    }
  );
};

var Back24 = function Back24(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref10) {
      var resolvedRoles = _ref10.resolvedRoles;

      var baseProps = {
        width: "24px",
        height: "24px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(Back24SVG, propsClone);
    }
  );
};

var BillStack24 = function BillStack24(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref11) {
      var resolvedRoles = _ref11.resolvedRoles;

      var baseProps = {
        width: "24px",
        height: "24px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(BillStack24SVG, propsClone);
    }
  );
};

var Billing24 = function Billing24(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref12) {
      var resolvedRoles = _ref12.resolvedRoles;

      var baseProps = {
        width: "24px",
        height: "24px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(Billing24SVG, propsClone);
    }
  );
};

var Bookmark24 = function Bookmark24(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref13) {
      var resolvedRoles = _ref13.resolvedRoles;

      var baseProps = {
        width: "24px",
        height: "24px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(Bookmark24SVG, propsClone);
    }
  );
};

var Building24 = function Building24(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref14) {
      var resolvedRoles = _ref14.resolvedRoles;

      var baseProps = {
        width: "24px",
        height: "24px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(Building24SVG, propsClone);
    }
  );
};

var Calendar24 = function Calendar24(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref15) {
      var resolvedRoles = _ref15.resolvedRoles;

      var baseProps = {
        width: "24px",
        height: "24px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(Calendar24SVG, propsClone);
    }
  );
};

var CaretDown24 = function CaretDown24(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref16) {
      var resolvedRoles = _ref16.resolvedRoles;

      var baseProps = {
        width: "24px",
        height: "24px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(CaretDown24SVG, propsClone);
    }
  );
};

var CaretLeft24 = function CaretLeft24(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref17) {
      var resolvedRoles = _ref17.resolvedRoles;

      var baseProps = {
        width: "24px",
        height: "24px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(CaretLeft24SVG, propsClone);
    }
  );
};

var CaretRight24 = function CaretRight24(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref18) {
      var resolvedRoles = _ref18.resolvedRoles;

      var baseProps = {
        width: "24px",
        height: "24px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(CaretRight24SVG, propsClone);
    }
  );
};

var CaretUp24 = function CaretUp24(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref19) {
      var resolvedRoles = _ref19.resolvedRoles;

      var baseProps = {
        width: "24px",
        height: "24px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(CaretUp24SVG, propsClone);
    }
  );
};

var CartEmpty24 = function CartEmpty24(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref20) {
      var resolvedRoles = _ref20.resolvedRoles;

      var baseProps = {
        width: "24px",
        height: "24px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(CartEmpty24SVG, propsClone);
    }
  );
};

var CartFull24 = function CartFull24(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref21) {
      var resolvedRoles = _ref21.resolvedRoles;

      var baseProps = {
        width: "24px",
        height: "24px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(CartFull24SVG, propsClone);
    }
  );
};

var Chat24 = function Chat24(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref22) {
      var resolvedRoles = _ref22.resolvedRoles;

      var baseProps = {
        width: "24px",
        height: "24px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(Chat24SVG, propsClone);
    }
  );
};

var Checklist24 = function Checklist24(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref23) {
      var resolvedRoles = _ref23.resolvedRoles;

      var baseProps = {
        width: "24px",
        height: "24px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(Checklist24SVG, propsClone);
    }
  );
};

var Checkmark24 = function Checkmark24(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref24) {
      var resolvedRoles = _ref24.resolvedRoles;

      var baseProps = {
        width: "24px",
        height: "24px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(Checkmark24SVG, propsClone);
    }
  );
};

var Clock24 = function Clock24(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref25) {
      var resolvedRoles = _ref25.resolvedRoles;

      var baseProps = {
        width: "24px",
        height: "24px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(Clock24SVG, propsClone);
    }
  );
};

var ClosedCaptioning24 = function ClosedCaptioning24(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref26) {
      var resolvedRoles = _ref26.resolvedRoles;

      var baseProps = {
        width: "24px",
        height: "24px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(ClosedCaptioning24SVG, propsClone);
    }
  );
};

var Cloud24 = function Cloud24(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref27) {
      var resolvedRoles = _ref27.resolvedRoles;

      var baseProps = {
        width: "24px",
        height: "24px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(Cloud24SVG, propsClone);
    }
  );
};

var Collaboration24 = function Collaboration24(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref28) {
      var resolvedRoles = _ref28.resolvedRoles;

      var baseProps = {
        width: "24px",
        height: "24px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(Collaboration24SVG, propsClone);
    }
  );
};

var CollapsePanel24 = function CollapsePanel24(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref29) {
      var resolvedRoles = _ref29.resolvedRoles;

      var baseProps = {
        width: "24px",
        height: "24px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(CollapsePanel24SVG, propsClone);
    }
  );
};

var Comment24 = function Comment24(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref30) {
      var resolvedRoles = _ref30.resolvedRoles;

      var baseProps = {
        width: "24px",
        height: "24px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(Comment24SVG, propsClone);
    }
  );
};

var Compare24 = function Compare24(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref31) {
      var resolvedRoles = _ref31.resolvedRoles;

      var baseProps = {
        width: "24px",
        height: "24px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(Compare24SVG, propsClone);
    }
  );
};

var Complete24 = function Complete24(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref32) {
      var resolvedRoles = _ref32.resolvedRoles;

      var baseProps = {
        width: "24px",
        height: "24px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(Complete24SVG, propsClone);
    }
  );
};

var Copy24 = function Copy24(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref33) {
      var resolvedRoles = _ref33.resolvedRoles;

      var baseProps = {
        width: "24px",
        height: "24px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(Copy24SVG, propsClone);
    }
  );
};

var CtaArrowRight24 = function CtaArrowRight24(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref34) {
      var resolvedRoles = _ref34.resolvedRoles;

      var baseProps = {
        width: "24px",
        height: "24px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(CtaArrowRight24SVG, propsClone);
    }
  );
};

var Dashboard24 = function Dashboard24(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref35) {
      var resolvedRoles = _ref35.resolvedRoles;

      var baseProps = {
        width: "24px",
        height: "24px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(Dashboard24SVG, propsClone);
    }
  );
};

var DeviceDesktop24 = function DeviceDesktop24(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref36) {
      var resolvedRoles = _ref36.resolvedRoles;

      var baseProps = {
        width: "24px",
        height: "24px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(DeviceDesktop24SVG, propsClone);
    }
  );
};

var DeviceMobile24 = function DeviceMobile24(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref37) {
      var resolvedRoles = _ref37.resolvedRoles;

      var baseProps = {
        width: "24px",
        height: "24px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(DeviceMobile24SVG, propsClone);
    }
  );
};

var DeviceTablet24 = function DeviceTablet24(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref38) {
      var resolvedRoles = _ref38.resolvedRoles;

      var baseProps = {
        width: "24px",
        height: "24px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(DeviceTablet24SVG, propsClone);
    }
  );
};

var Devices24 = function Devices24(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref39) {
      var resolvedRoles = _ref39.resolvedRoles;

      var baseProps = {
        width: "24px",
        height: "24px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(Devices24SVG, propsClone);
    }
  );
};

var DocumentManagement24 = function DocumentManagement24(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref40) {
      var resolvedRoles = _ref40.resolvedRoles;

      var baseProps = {
        width: "24px",
        height: "24px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(DocumentManagement24SVG, propsClone);
    }
  );
};

var Down24 = function Down24(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref41) {
      var resolvedRoles = _ref41.resolvedRoles;

      var baseProps = {
        width: "24px",
        height: "24px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(Down24SVG, propsClone);
    }
  );
};

var Download24 = function Download24(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref42) {
      var resolvedRoles = _ref42.resolvedRoles;

      var baseProps = {
        width: "24px",
        height: "24px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(Download24SVG, propsClone);
    }
  );
};

var EditProfile24 = function EditProfile24(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref43) {
      var resolvedRoles = _ref43.resolvedRoles;

      var baseProps = {
        width: "24px",
        height: "24px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(EditProfile24SVG, propsClone);
    }
  );
};

var Edit24 = function Edit24(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref44) {
      var resolvedRoles = _ref44.resolvedRoles;

      var baseProps = {
        width: "24px",
        height: "24px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(Edit24SVG, propsClone);
    }
  );
};

var Education24 = function Education24(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref45) {
      var resolvedRoles = _ref45.resolvedRoles;

      var baseProps = {
        width: "24px",
        height: "24px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(Education24SVG, propsClone);
    }
  );
};

var Error24 = function Error24(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref46) {
      var resolvedRoles = _ref46.resolvedRoles;

      var baseProps = {
        width: "24px",
        height: "24px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(Error24SVG, propsClone);
    }
  );
};

var ExpandPanel24 = function ExpandPanel24(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref47) {
      var resolvedRoles = _ref47.resolvedRoles;

      var baseProps = {
        width: "24px",
        height: "24px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(ExpandPanel24SVG, propsClone);
    }
  );
};

var ExportMove24 = function ExportMove24(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref48) {
      var resolvedRoles = _ref48.resolvedRoles;

      var baseProps = {
        width: "24px",
        height: "24px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(ExportMove24SVG, propsClone);
    }
  );
};

var ExternalLink24 = function ExternalLink24(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref49) {
      var resolvedRoles = _ref49.resolvedRoles;

      var baseProps = {
        width: "24px",
        height: "24px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(ExternalLink24SVG, propsClone);
    }
  );
};

var External24 = function External24(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref50) {
      var resolvedRoles = _ref50.resolvedRoles;

      var baseProps = {
        width: "24px",
        height: "24px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(External24SVG, propsClone);
    }
  );
};

var Favorite24 = function Favorite24(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref51) {
      var resolvedRoles = _ref51.resolvedRoles;

      var baseProps = {
        width: "24px",
        height: "24px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(Favorite24SVG, propsClone);
    }
  );
};

var Featured24 = function Featured24(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref52) {
      var resolvedRoles = _ref52.resolvedRoles;

      var baseProps = {
        width: "24px",
        height: "24px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(Featured24SVG, propsClone);
    }
  );
};

var Feedback24 = function Feedback24(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref53) {
      var resolvedRoles = _ref53.resolvedRoles;

      var baseProps = {
        width: "24px",
        height: "24px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(Feedback24SVG, propsClone);
    }
  );
};

var Field24 = function Field24(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref54) {
      var resolvedRoles = _ref54.resolvedRoles;

      var baseProps = {
        width: "24px",
        height: "24px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(Field24SVG, propsClone);
    }
  );
};

var FileAssembly24 = function FileAssembly24(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref55) {
      var resolvedRoles = _ref55.resolvedRoles;

      var baseProps = {
        width: "24px",
        height: "24px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(FileAssembly24SVG, propsClone);
    }
  );
};

var FileAudio24 = function FileAudio24(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref56) {
      var resolvedRoles = _ref56.resolvedRoles;

      var baseProps = {
        width: "24px",
        height: "24px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(FileAudio24SVG, propsClone);
    }
  );
};

var FileDocument24 = function FileDocument24(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref57) {
      var resolvedRoles = _ref57.resolvedRoles;

      var baseProps = {
        width: "24px",
        height: "24px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(FileDocument24SVG, propsClone);
    }
  );
};

var FileGeneric24 = function FileGeneric24(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref58) {
      var resolvedRoles = _ref58.resolvedRoles;

      var baseProps = {
        width: "24px",
        height: "24px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(FileGeneric24SVG, propsClone);
    }
  );
};

var FileImage24 = function FileImage24(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref59) {
      var resolvedRoles = _ref59.resolvedRoles;

      var baseProps = {
        width: "24px",
        height: "24px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(FileImage24SVG, propsClone);
    }
  );
};

var FilePart24 = function FilePart24(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref60) {
      var resolvedRoles = _ref60.resolvedRoles;

      var baseProps = {
        width: "24px",
        height: "24px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(FilePart24SVG, propsClone);
    }
  );
};

var FilePdf24 = function FilePdf24(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref61) {
      var resolvedRoles = _ref61.resolvedRoles;

      var baseProps = {
        width: "24px",
        height: "24px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(FilePdf24SVG, propsClone);
    }
  );
};

var FilePresentation24 = function FilePresentation24(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref62) {
      var resolvedRoles = _ref62.resolvedRoles;

      var baseProps = {
        width: "24px",
        height: "24px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(FilePresentation24SVG, propsClone);
    }
  );
};

var FileSpreadsheet24 = function FileSpreadsheet24(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref63) {
      var resolvedRoles = _ref63.resolvedRoles;

      var baseProps = {
        width: "24px",
        height: "24px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(FileSpreadsheet24SVG, propsClone);
    }
  );
};

var FileVideo24 = function FileVideo24(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref64) {
      var resolvedRoles = _ref64.resolvedRoles;

      var baseProps = {
        width: "24px",
        height: "24px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(FileVideo24SVG, propsClone);
    }
  );
};

var FileZip24 = function FileZip24(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref65) {
      var resolvedRoles = _ref65.resolvedRoles;

      var baseProps = {
        width: "24px",
        height: "24px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(FileZip24SVG, propsClone);
    }
  );
};

var FilterTokens24 = function FilterTokens24(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref66) {
      var resolvedRoles = _ref66.resolvedRoles;

      var baseProps = {
        width: "24px",
        height: "24px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(FilterTokens24SVG, propsClone);
    }
  );
};

var Filter24 = function Filter24(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref67) {
      var resolvedRoles = _ref67.resolvedRoles;

      var baseProps = {
        width: "24px",
        height: "24px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(Filter24SVG, propsClone);
    }
  );
};

var Flag24 = function Flag24(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref68) {
      var resolvedRoles = _ref68.resolvedRoles;

      var baseProps = {
        width: "24px",
        height: "24px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(Flag24SVG, propsClone);
    }
  );
};

var FolderOpen24 = function FolderOpen24(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref69) {
      var resolvedRoles = _ref69.resolvedRoles;

      var baseProps = {
        width: "24px",
        height: "24px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(FolderOpen24SVG, propsClone);
    }
  );
};

var Folder24 = function Folder24(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref70) {
      var resolvedRoles = _ref70.resolvedRoles;

      var baseProps = {
        width: "24px",
        height: "24px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(Folder24SVG, propsClone);
    }
  );
};

var Forums24 = function Forums24(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref71) {
      var resolvedRoles = _ref71.resolvedRoles;

      var baseProps = {
        width: "24px",
        height: "24px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(Forums24SVG, propsClone);
    }
  );
};

var Forward24 = function Forward24(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref72) {
      var resolvedRoles = _ref72.resolvedRoles;

      var baseProps = {
        width: "24px",
        height: "24px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(Forward24SVG, propsClone);
    }
  );
};

var Globe24 = function Globe24(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref73) {
      var resolvedRoles = _ref73.resolvedRoles;

      var baseProps = {
        width: "24px",
        height: "24px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(Globe24SVG, propsClone);
    }
  );
};

var Graph24 = function Graph24(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref74) {
      var resolvedRoles = _ref74.resolvedRoles;

      var baseProps = {
        width: "24px",
        height: "24px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(Graph24SVG, propsClone);
    }
  );
};

var Grid24 = function Grid24(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref75) {
      var resolvedRoles = _ref75.resolvedRoles;

      var baseProps = {
        width: "24px",
        height: "24px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(Grid24SVG, propsClone);
    }
  );
};

var Help24 = function Help24(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref76) {
      var resolvedRoles = _ref76.resolvedRoles;

      var baseProps = {
        width: "24px",
        height: "24px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(Help24SVG, propsClone);
    }
  );
};

var Hidden24 = function Hidden24(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref77) {
      var resolvedRoles = _ref77.resolvedRoles;

      var baseProps = {
        width: "24px",
        height: "24px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(Hidden24SVG, propsClone);
    }
  );
};

var Hierarchy24 = function Hierarchy24(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref78) {
      var resolvedRoles = _ref78.resolvedRoles;

      var baseProps = {
        width: "24px",
        height: "24px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(Hierarchy24SVG, propsClone);
    }
  );
};

var Home24 = function Home24(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref79) {
      var resolvedRoles = _ref79.resolvedRoles;

      var baseProps = {
        width: "24px",
        height: "24px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(Home24SVG, propsClone);
    }
  );
};

var Import24 = function Import24(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref80) {
      var resolvedRoles = _ref80.resolvedRoles;

      var baseProps = {
        width: "24px",
        height: "24px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(Import24SVG, propsClone);
    }
  );
};

var Inbox24 = function Inbox24(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref81) {
      var resolvedRoles = _ref81.resolvedRoles;

      var baseProps = {
        width: "24px",
        height: "24px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(Inbox24SVG, propsClone);
    }
  );
};

var Info24 = function Info24(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref82) {
      var resolvedRoles = _ref82.resolvedRoles;

      var baseProps = {
        width: "24px",
        height: "24px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(Info24SVG, propsClone);
    }
  );
};

var Item24 = function Item24(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref83) {
      var resolvedRoles = _ref83.resolvedRoles;

      var baseProps = {
        width: "24px",
        height: "24px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(Item24SVG, propsClone);
    }
  );
};

var Link24 = function Link24(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref84) {
      var resolvedRoles = _ref84.resolvedRoles;

      var baseProps = {
        width: "24px",
        height: "24px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(Link24SVG, propsClone);
    }
  );
};

var List24 = function List24(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref85) {
      var resolvedRoles = _ref85.resolvedRoles;

      var baseProps = {
        width: "24px",
        height: "24px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(List24SVG, propsClone);
    }
  );
};

var Location24 = function Location24(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref86) {
      var resolvedRoles = _ref86.resolvedRoles;

      var baseProps = {
        width: "24px",
        height: "24px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(Location24SVG, propsClone);
    }
  );
};

var Lock24 = function Lock24(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref87) {
      var resolvedRoles = _ref87.resolvedRoles;

      var baseProps = {
        width: "24px",
        height: "24px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(Lock24SVG, propsClone);
    }
  );
};

var Mail24 = function Mail24(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref88) {
      var resolvedRoles = _ref88.resolvedRoles;

      var baseProps = {
        width: "24px",
        height: "24px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(Mail24SVG, propsClone);
    }
  );
};

var ManageAccess24 = function ManageAccess24(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref89) {
      var resolvedRoles = _ref89.resolvedRoles;

      var baseProps = {
        width: "24px",
        height: "24px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(ManageAccess24SVG, propsClone);
    }
  );
};

var Maximize24 = function Maximize24(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref90) {
      var resolvedRoles = _ref90.resolvedRoles;

      var baseProps = {
        width: "24px",
        height: "24px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(Maximize24SVG, propsClone);
    }
  );
};

var Minimize24 = function Minimize24(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref91) {
      var resolvedRoles = _ref91.resolvedRoles;

      var baseProps = {
        width: "24px",
        height: "24px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(Minimize24SVG, propsClone);
    }
  );
};

var MoreVertical24 = function MoreVertical24(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref92) {
      var resolvedRoles = _ref92.resolvedRoles;

      var baseProps = {
        width: "24px",
        height: "24px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(MoreVertical24SVG, propsClone);
    }
  );
};

var More24 = function More24(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref93) {
      var resolvedRoles = _ref93.resolvedRoles;

      var baseProps = {
        width: "24px",
        height: "24px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(More24SVG, propsClone);
    }
  );
};

var Mute24 = function Mute24(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref94) {
      var resolvedRoles = _ref94.resolvedRoles;

      var baseProps = {
        width: "24px",
        height: "24px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(Mute24SVG, propsClone);
    }
  );
};

var NotEditable24 = function NotEditable24(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref95) {
      var resolvedRoles = _ref95.resolvedRoles;

      var baseProps = {
        width: "24px",
        height: "24px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(NotEditable24SVG, propsClone);
    }
  );
};

var NotificationOff24 = function NotificationOff24(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref96) {
      var resolvedRoles = _ref96.resolvedRoles;

      var baseProps = {
        width: "24px",
        height: "24px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(NotificationOff24SVG, propsClone);
    }
  );
};

var Notification24 = function Notification24(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref97) {
      var resolvedRoles = _ref97.resolvedRoles;

      var baseProps = {
        width: "24px",
        height: "24px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(Notification24SVG, propsClone);
    }
  );
};

var OnlineViewers24 = function OnlineViewers24(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref98) {
      var resolvedRoles = _ref98.resolvedRoles;

      var baseProps = {
        width: "24px",
        height: "24px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(OnlineViewers24SVG, propsClone);
    }
  );
};

var Paste24 = function Paste24(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref99) {
      var resolvedRoles = _ref99.resolvedRoles;

      var baseProps = {
        width: "24px",
        height: "24px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(Paste24SVG, propsClone);
    }
  );
};

var PermissionGroup24 = function PermissionGroup24(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref100) {
      var resolvedRoles = _ref100.resolvedRoles;

      var baseProps = {
        width: "24px",
        height: "24px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(PermissionGroup24SVG, propsClone);
    }
  );
};

var PermissionIndividual24 = function PermissionIndividual24(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref101) {
      var resolvedRoles = _ref101.resolvedRoles;

      var baseProps = {
        width: "24px",
        height: "24px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(PermissionIndividual24SVG, propsClone);
    }
  );
};

var Photos24 = function Photos24(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref102) {
      var resolvedRoles = _ref102.resolvedRoles;

      var baseProps = {
        width: "24px",
        height: "24px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(Photos24SVG, propsClone);
    }
  );
};

var Pin24 = function Pin24(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref103) {
      var resolvedRoles = _ref103.resolvedRoles;

      var baseProps = {
        width: "24px",
        height: "24px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(Pin24SVG, propsClone);
    }
  );
};

var Placeholder24 = function Placeholder24(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref104) {
      var resolvedRoles = _ref104.resolvedRoles;

      var baseProps = {
        width: "24px",
        height: "24px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(Placeholder24SVG, propsClone);
    }
  );
};

var PlaybackFastForward24 = function PlaybackFastForward24(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref105) {
      var resolvedRoles = _ref105.resolvedRoles;

      var baseProps = {
        width: "24px",
        height: "24px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(PlaybackFastForward24SVG, propsClone);
    }
  );
};

var PlaybackGoToEnd24 = function PlaybackGoToEnd24(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref106) {
      var resolvedRoles = _ref106.resolvedRoles;

      var baseProps = {
        width: "24px",
        height: "24px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(PlaybackGoToEnd24SVG, propsClone);
    }
  );
};

var PlaybackGoToStart24 = function PlaybackGoToStart24(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref107) {
      var resolvedRoles = _ref107.resolvedRoles;

      var baseProps = {
        width: "24px",
        height: "24px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(PlaybackGoToStart24SVG, propsClone);
    }
  );
};

var PlaybackLoop24 = function PlaybackLoop24(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref108) {
      var resolvedRoles = _ref108.resolvedRoles;

      var baseProps = {
        width: "24px",
        height: "24px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(PlaybackLoop24SVG, propsClone);
    }
  );
};

var PlaybackNext24 = function PlaybackNext24(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref109) {
      var resolvedRoles = _ref109.resolvedRoles;

      var baseProps = {
        width: "24px",
        height: "24px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(PlaybackNext24SVG, propsClone);
    }
  );
};

var PlaybackPause24 = function PlaybackPause24(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref110) {
      var resolvedRoles = _ref110.resolvedRoles;

      var baseProps = {
        width: "24px",
        height: "24px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(PlaybackPause24SVG, propsClone);
    }
  );
};

var PlaybackPlay24 = function PlaybackPlay24(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref111) {
      var resolvedRoles = _ref111.resolvedRoles;

      var baseProps = {
        width: "24px",
        height: "24px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(PlaybackPlay24SVG, propsClone);
    }
  );
};

var PlaybackPrevious24 = function PlaybackPrevious24(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref112) {
      var resolvedRoles = _ref112.resolvedRoles;

      var baseProps = {
        width: "24px",
        height: "24px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(PlaybackPrevious24SVG, propsClone);
    }
  );
};

var PlaybackRecord24 = function PlaybackRecord24(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref113) {
      var resolvedRoles = _ref113.resolvedRoles;

      var baseProps = {
        width: "24px",
        height: "24px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(PlaybackRecord24SVG, propsClone);
    }
  );
};

var PlaybackRewind24 = function PlaybackRewind24(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref114) {
      var resolvedRoles = _ref114.resolvedRoles;

      var baseProps = {
        width: "24px",
        height: "24px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(PlaybackRewind24SVG, propsClone);
    }
  );
};

var PlaybackShuffle24 = function PlaybackShuffle24(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref115) {
      var resolvedRoles = _ref115.resolvedRoles;

      var baseProps = {
        width: "24px",
        height: "24px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(PlaybackShuffle24SVG, propsClone);
    }
  );
};

var PlaybackStop24 = function PlaybackStop24(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref116) {
      var resolvedRoles = _ref116.resolvedRoles;

      var baseProps = {
        width: "24px",
        height: "24px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(PlaybackStop24SVG, propsClone);
    }
  );
};

var Print24 = function Print24(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref117) {
      var resolvedRoles = _ref117.resolvedRoles;

      var baseProps = {
        width: "24px",
        height: "24px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(Print24SVG, propsClone);
    }
  );
};

var ProductsAndServices24 = function ProductsAndServices24(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref118) {
      var resolvedRoles = _ref118.resolvedRoles;

      var baseProps = {
        width: "24px",
        height: "24px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(ProductsAndServices24SVG, propsClone);
    }
  );
};

var Profile24 = function Profile24(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref119) {
      var resolvedRoles = _ref119.resolvedRoles;

      var baseProps = {
        width: "24px",
        height: "24px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(Profile24SVG, propsClone);
    }
  );
};

var ProjectManagement24 = function ProjectManagement24(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref120) {
      var resolvedRoles = _ref120.resolvedRoles;

      var baseProps = {
        width: "24px",
        height: "24px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(ProjectManagement24SVG, propsClone);
    }
  );
};

var Properties24 = function Properties24(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref121) {
      var resolvedRoles = _ref121.resolvedRoles;

      var baseProps = {
        width: "24px",
        height: "24px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(Properties24SVG, propsClone);
    }
  );
};

var Publish24 = function Publish24(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref122) {
      var resolvedRoles = _ref122.resolvedRoles;

      var baseProps = {
        width: "24px",
        height: "24px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(Publish24SVG, propsClone);
    }
  );
};

var Quantities24 = function Quantities24(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref123) {
      var resolvedRoles = _ref123.resolvedRoles;

      var baseProps = {
        width: "24px",
        height: "24px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(Quantities24SVG, propsClone);
    }
  );
};

var Recommend24 = function Recommend24(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref124) {
      var resolvedRoles = _ref124.resolvedRoles;

      var baseProps = {
        width: "24px",
        height: "24px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(Recommend24SVG, propsClone);
    }
  );
};

var Redo24 = function Redo24(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref125) {
      var resolvedRoles = _ref125.resolvedRoles;

      var baseProps = {
        width: "24px",
        height: "24px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(Redo24SVG, propsClone);
    }
  );
};

var Report24 = function Report24(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref126) {
      var resolvedRoles = _ref126.resolvedRoles;

      var baseProps = {
        width: "24px",
        height: "24px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(Report24SVG, propsClone);
    }
  );
};

var SaveAs24 = function SaveAs24(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref127) {
      var resolvedRoles = _ref127.resolvedRoles;

      var baseProps = {
        width: "24px",
        height: "24px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(SaveAs24SVG, propsClone);
    }
  );
};

var Save24 = function Save24(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref128) {
      var resolvedRoles = _ref128.resolvedRoles;

      var baseProps = {
        width: "24px",
        height: "24px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(Save24SVG, propsClone);
    }
  );
};

var Search24 = function Search24(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref129) {
      var resolvedRoles = _ref129.resolvedRoles;

      var baseProps = {
        width: "24px",
        height: "24px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(Search24SVG, propsClone);
    }
  );
};

var Security24 = function Security24(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref130) {
      var resolvedRoles = _ref130.resolvedRoles;

      var baseProps = {
        width: "24px",
        height: "24px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(Security24SVG, propsClone);
    }
  );
};

var SelectAll24 = function SelectAll24(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref131) {
      var resolvedRoles = _ref131.resolvedRoles;

      var baseProps = {
        width: "24px",
        height: "24px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(SelectAll24SVG, propsClone);
    }
  );
};

var SelectNone24 = function SelectNone24(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref132) {
      var resolvedRoles = _ref132.resolvedRoles;

      var baseProps = {
        width: "24px",
        height: "24px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(SelectNone24SVG, propsClone);
    }
  );
};

var Service24 = function Service24(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref133) {
      var resolvedRoles = _ref133.resolvedRoles;

      var baseProps = {
        width: "24px",
        height: "24px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(Service24SVG, propsClone);
    }
  );
};

var Settings24 = function Settings24(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref134) {
      var resolvedRoles = _ref134.resolvedRoles;

      var baseProps = {
        width: "24px",
        height: "24px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(Settings24SVG, propsClone);
    }
  );
};

var Share24 = function Share24(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref135) {
      var resolvedRoles = _ref135.resolvedRoles;

      var baseProps = {
        width: "24px",
        height: "24px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(Share24SVG, propsClone);
    }
  );
};

var SocialBlog24 = function SocialBlog24(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref136) {
      var resolvedRoles = _ref136.resolvedRoles;

      var baseProps = {
        width: "24px",
        height: "24px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(SocialBlog24SVG, propsClone);
    }
  );
};

var SocialFacebook24 = function SocialFacebook24(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref137) {
      var resolvedRoles = _ref137.resolvedRoles;

      var baseProps = {
        width: "24px",
        height: "24px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(SocialFacebook24SVG, propsClone);
    }
  );
};

var SocialInstagram24 = function SocialInstagram24(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref138) {
      var resolvedRoles = _ref138.resolvedRoles;

      var baseProps = {
        width: "24px",
        height: "24px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(SocialInstagram24SVG, propsClone);
    }
  );
};

var SocialLinkedin24 = function SocialLinkedin24(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref139) {
      var resolvedRoles = _ref139.resolvedRoles;

      var baseProps = {
        width: "24px",
        height: "24px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(SocialLinkedin24SVG, propsClone);
    }
  );
};

var SocialTwitter24 = function SocialTwitter24(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref140) {
      var resolvedRoles = _ref140.resolvedRoles;

      var baseProps = {
        width: "24px",
        height: "24px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(SocialTwitter24SVG, propsClone);
    }
  );
};

var SocialYoutube24 = function SocialYoutube24(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref141) {
      var resolvedRoles = _ref141.resolvedRoles;

      var baseProps = {
        width: "24px",
        height: "24px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(SocialYoutube24SVG, propsClone);
    }
  );
};

var Sort24 = function Sort24(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref142) {
      var resolvedRoles = _ref142.resolvedRoles;

      var baseProps = {
        width: "24px",
        height: "24px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(Sort24SVG, propsClone);
    }
  );
};

var Subscription24 = function Subscription24(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref143) {
      var resolvedRoles = _ref143.resolvedRoles;

      var baseProps = {
        width: "24px",
        height: "24px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(Subscription24SVG, propsClone);
    }
  );
};

var Support24 = function Support24(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref144) {
      var resolvedRoles = _ref144.resolvedRoles;

      var baseProps = {
        width: "24px",
        height: "24px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(Support24SVG, propsClone);
    }
  );
};

var SurveyEquipment24 = function SurveyEquipment24(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref145) {
      var resolvedRoles = _ref145.resolvedRoles;

      var baseProps = {
        width: "24px",
        height: "24px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(SurveyEquipment24SVG, propsClone);
    }
  );
};

var Sync24 = function Sync24(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref146) {
      var resolvedRoles = _ref146.resolvedRoles;

      var baseProps = {
        width: "24px",
        height: "24px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(Sync24SVG, propsClone);
    }
  );
};

var Tag24 = function Tag24(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref147) {
      var resolvedRoles = _ref147.resolvedRoles;

      var baseProps = {
        width: "24px",
        height: "24px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(Tag24SVG, propsClone);
    }
  );
};

var Trash24 = function Trash24(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref148) {
      var resolvedRoles = _ref148.resolvedRoles;

      var baseProps = {
        width: "24px",
        height: "24px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(Trash24SVG, propsClone);
    }
  );
};

var TreeView24 = function TreeView24(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref149) {
      var resolvedRoles = _ref149.resolvedRoles;

      var baseProps = {
        width: "24px",
        height: "24px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      return React.createElement(TreeView24SVG, propsClone);
    }
  );
};

var Unavailable24 = function Unavailable24(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref150) {
      var resolvedRoles = _ref150.resolvedRoles;

      var baseProps = {
        width: "24px",
        height: "24px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(Unavailable24SVG, propsClone);
    }
  );
};

var Undo24 = function Undo24(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref151) {
      var resolvedRoles = _ref151.resolvedRoles;

      var baseProps = {
        width: "24px",
        height: "24px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(Undo24SVG, propsClone);
    }
  );
};

var Unlink24 = function Unlink24(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref152) {
      var resolvedRoles = _ref152.resolvedRoles;

      var baseProps = {
        width: "24px",
        height: "24px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(Unlink24SVG, propsClone);
    }
  );
};

var Unlock24 = function Unlock24(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref153) {
      var resolvedRoles = _ref153.resolvedRoles;

      var baseProps = {
        width: "24px",
        height: "24px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(Unlock24SVG, propsClone);
    }
  );
};

var Unpin24 = function Unpin24(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref154) {
      var resolvedRoles = _ref154.resolvedRoles;

      var baseProps = {
        width: "24px",
        height: "24px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(Unpin24SVG, propsClone);
    }
  );
};

var Up24 = function Up24(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref155) {
      var resolvedRoles = _ref155.resolvedRoles;

      var baseProps = {
        width: "24px",
        height: "24px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(Up24SVG, propsClone);
    }
  );
};

var Upload24 = function Upload24(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref156) {
      var resolvedRoles = _ref156.resolvedRoles;

      var baseProps = {
        width: "24px",
        height: "24px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(Upload24SVG, propsClone);
    }
  );
};

var UserInactive24 = function UserInactive24(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref157) {
      var resolvedRoles = _ref157.resolvedRoles;

      var baseProps = {
        width: "24px",
        height: "24px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(UserInactive24SVG, propsClone);
    }
  );
};

var Visible24 = function Visible24(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref158) {
      var resolvedRoles = _ref158.resolvedRoles;

      var baseProps = {
        width: "24px",
        height: "24px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(Visible24SVG, propsClone);
    }
  );
};

var Volume24 = function Volume24(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref159) {
      var resolvedRoles = _ref159.resolvedRoles;

      var baseProps = {
        width: "24px",
        height: "24px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(Volume24SVG, propsClone);
    }
  );
};

var ZoomIn24 = function ZoomIn24(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref160) {
      var resolvedRoles = _ref160.resolvedRoles;

      var baseProps = {
        width: "24px",
        height: "24px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(ZoomIn24SVG, propsClone);
    }
  );
};

var ZoomOut24 = function ZoomOut24(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref161) {
      var resolvedRoles = _ref161.resolvedRoles;

      var baseProps = {
        width: "24px",
        height: "24px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(ZoomOut24SVG, propsClone);
    }
  );
};

var AddFolder16 = function AddFolder16(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref162) {
      var resolvedRoles = _ref162.resolvedRoles;

      var baseProps = {
        width: "16px",
        height: "16px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(AddFolder16SVG, propsClone);
    }
  );
};

var AddMember16 = function AddMember16(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref163) {
      var resolvedRoles = _ref163.resolvedRoles;

      var baseProps = {
        width: "16px",
        height: "16px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(AddMember16SVG, propsClone);
    }
  );
};

var AddPage16 = function AddPage16(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref164) {
      var resolvedRoles = _ref164.resolvedRoles;

      var baseProps = {
        width: "16px",
        height: "16px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(AddPage16SVG, propsClone);
    }
  );
};

var Add16 = function Add16(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref165) {
      var resolvedRoles = _ref165.resolvedRoles;

      var baseProps = {
        width: "16px",
        height: "16px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(Add16SVG, propsClone);
    }
  );
};

var Alert16 = function Alert16(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref166) {
      var resolvedRoles = _ref166.resolvedRoles;

      var baseProps = {
        width: "16px",
        height: "16px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(Alert16SVG, propsClone);
    }
  );
};

var Archive16 = function Archive16(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref167) {
      var resolvedRoles = _ref167.resolvedRoles;

      var baseProps = {
        width: "16px",
        height: "16px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(Archive16SVG, propsClone);
    }
  );
};

var AreaPost16 = function AreaPost16(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref168) {
      var resolvedRoles = _ref168.resolvedRoles;

      var baseProps = {
        width: "16px",
        height: "16px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(AreaPost16SVG, propsClone);
    }
  );
};

var Attach16 = function Attach16(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref169) {
      var resolvedRoles = _ref169.resolvedRoles;

      var baseProps = {
        width: "16px",
        height: "16px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(Attach16SVG, propsClone);
    }
  );
};

var Attachment16 = function Attachment16(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref170) {
      var resolvedRoles = _ref170.resolvedRoles;

      var baseProps = {
        width: "16px",
        height: "16px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(Attachment16SVG, propsClone);
    }
  );
};

var Back1616 = function Back1616(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref171) {
      var resolvedRoles = _ref171.resolvedRoles;

      var baseProps = {
        width: "16px",
        height: "16px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      return React.createElement(Back1616SVG, propsClone);
    }
  );
};

var Back16 = function Back16(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref172) {
      var resolvedRoles = _ref172.resolvedRoles;

      var baseProps = {
        width: "16px",
        height: "16px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(Back16SVG, propsClone);
    }
  );
};

var BillStack16 = function BillStack16(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref173) {
      var resolvedRoles = _ref173.resolvedRoles;

      var baseProps = {
        width: "16px",
        height: "16px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(BillStack16SVG, propsClone);
    }
  );
};

var Billing16 = function Billing16(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref174) {
      var resolvedRoles = _ref174.resolvedRoles;

      var baseProps = {
        width: "16px",
        height: "16px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(Billing16SVG, propsClone);
    }
  );
};

var Bookmark16 = function Bookmark16(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref175) {
      var resolvedRoles = _ref175.resolvedRoles;

      var baseProps = {
        width: "16px",
        height: "16px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(Bookmark16SVG, propsClone);
    }
  );
};

var Building16 = function Building16(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref176) {
      var resolvedRoles = _ref176.resolvedRoles;

      var baseProps = {
        width: "16px",
        height: "16px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(Building16SVG, propsClone);
    }
  );
};

var Calendar16 = function Calendar16(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref177) {
      var resolvedRoles = _ref177.resolvedRoles;

      var baseProps = {
        width: "16px",
        height: "16px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(Calendar16SVG, propsClone);
    }
  );
};

var CaretDown16 = function CaretDown16(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref178) {
      var resolvedRoles = _ref178.resolvedRoles;

      var baseProps = {
        width: "16px",
        height: "16px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(CaretDown16SVG, propsClone);
    }
  );
};

var CaretLeft16 = function CaretLeft16(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref179) {
      var resolvedRoles = _ref179.resolvedRoles;

      var baseProps = {
        width: "16px",
        height: "16px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(CaretLeft16SVG, propsClone);
    }
  );
};

var CaretRight16 = function CaretRight16(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref180) {
      var resolvedRoles = _ref180.resolvedRoles;

      var baseProps = {
        width: "16px",
        height: "16px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(CaretRight16SVG, propsClone);
    }
  );
};

var CaretUp16 = function CaretUp16(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref181) {
      var resolvedRoles = _ref181.resolvedRoles;

      var baseProps = {
        width: "16px",
        height: "16px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(CaretUp16SVG, propsClone);
    }
  );
};

var CartEmpty16 = function CartEmpty16(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref182) {
      var resolvedRoles = _ref182.resolvedRoles;

      var baseProps = {
        width: "16px",
        height: "16px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(CartEmpty16SVG, propsClone);
    }
  );
};

var CartFull16 = function CartFull16(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref183) {
      var resolvedRoles = _ref183.resolvedRoles;

      var baseProps = {
        width: "16px",
        height: "16px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(CartFull16SVG, propsClone);
    }
  );
};

var Chat16 = function Chat16(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref184) {
      var resolvedRoles = _ref184.resolvedRoles;

      var baseProps = {
        width: "16px",
        height: "16px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(Chat16SVG, propsClone);
    }
  );
};

var Checklist16 = function Checklist16(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref185) {
      var resolvedRoles = _ref185.resolvedRoles;

      var baseProps = {
        width: "16px",
        height: "16px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(Checklist16SVG, propsClone);
    }
  );
};

var Checkmark16 = function Checkmark16(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref186) {
      var resolvedRoles = _ref186.resolvedRoles;

      var baseProps = {
        width: "16px",
        height: "16px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(Checkmark16SVG, propsClone);
    }
  );
};

var Clock16 = function Clock16(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref187) {
      var resolvedRoles = _ref187.resolvedRoles;

      var baseProps = {
        width: "16px",
        height: "16px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(Clock16SVG, propsClone);
    }
  );
};

var ClosedCaptioning16 = function ClosedCaptioning16(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref188) {
      var resolvedRoles = _ref188.resolvedRoles;

      var baseProps = {
        width: "16px",
        height: "16px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(ClosedCaptioning16SVG, propsClone);
    }
  );
};

var Cloud16 = function Cloud16(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref189) {
      var resolvedRoles = _ref189.resolvedRoles;

      var baseProps = {
        width: "16px",
        height: "16px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(Cloud16SVG, propsClone);
    }
  );
};

var Collaboration16 = function Collaboration16(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref190) {
      var resolvedRoles = _ref190.resolvedRoles;

      var baseProps = {
        width: "16px",
        height: "16px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(Collaboration16SVG, propsClone);
    }
  );
};

var CollapsePanel16 = function CollapsePanel16(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref191) {
      var resolvedRoles = _ref191.resolvedRoles;

      var baseProps = {
        width: "16px",
        height: "16px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(CollapsePanel16SVG, propsClone);
    }
  );
};

var Comment16 = function Comment16(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref192) {
      var resolvedRoles = _ref192.resolvedRoles;

      var baseProps = {
        width: "16px",
        height: "16px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(Comment16SVG, propsClone);
    }
  );
};

var Compare16 = function Compare16(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref193) {
      var resolvedRoles = _ref193.resolvedRoles;

      var baseProps = {
        width: "16px",
        height: "16px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(Compare16SVG, propsClone);
    }
  );
};

var Complete16 = function Complete16(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref194) {
      var resolvedRoles = _ref194.resolvedRoles;

      var baseProps = {
        width: "16px",
        height: "16px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(Complete16SVG, propsClone);
    }
  );
};

var Copy16 = function Copy16(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref195) {
      var resolvedRoles = _ref195.resolvedRoles;

      var baseProps = {
        width: "16px",
        height: "16px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(Copy16SVG, propsClone);
    }
  );
};

var CtaArrowRight16 = function CtaArrowRight16(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref196) {
      var resolvedRoles = _ref196.resolvedRoles;

      var baseProps = {
        width: "16px",
        height: "16px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(CtaArrowRight16SVG, propsClone);
    }
  );
};

var Dashboard16 = function Dashboard16(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref197) {
      var resolvedRoles = _ref197.resolvedRoles;

      var baseProps = {
        width: "16px",
        height: "16px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(Dashboard16SVG, propsClone);
    }
  );
};

var DeviceDesktop16 = function DeviceDesktop16(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref198) {
      var resolvedRoles = _ref198.resolvedRoles;

      var baseProps = {
        width: "16px",
        height: "16px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(DeviceDesktop16SVG, propsClone);
    }
  );
};

var DeviceMobile16 = function DeviceMobile16(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref199) {
      var resolvedRoles = _ref199.resolvedRoles;

      var baseProps = {
        width: "16px",
        height: "16px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(DeviceMobile16SVG, propsClone);
    }
  );
};

var DeviceTablet16 = function DeviceTablet16(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref200) {
      var resolvedRoles = _ref200.resolvedRoles;

      var baseProps = {
        width: "16px",
        height: "16px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(DeviceTablet16SVG, propsClone);
    }
  );
};

var Devices16 = function Devices16(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref201) {
      var resolvedRoles = _ref201.resolvedRoles;

      var baseProps = {
        width: "16px",
        height: "16px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(Devices16SVG, propsClone);
    }
  );
};

var DocumentManagement16 = function DocumentManagement16(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref202) {
      var resolvedRoles = _ref202.resolvedRoles;

      var baseProps = {
        width: "16px",
        height: "16px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(DocumentManagement16SVG, propsClone);
    }
  );
};

var Down16 = function Down16(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref203) {
      var resolvedRoles = _ref203.resolvedRoles;

      var baseProps = {
        width: "16px",
        height: "16px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(Down16SVG, propsClone);
    }
  );
};

var Download16 = function Download16(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref204) {
      var resolvedRoles = _ref204.resolvedRoles;

      var baseProps = {
        width: "16px",
        height: "16px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(Download16SVG, propsClone);
    }
  );
};

var EditProfile16 = function EditProfile16(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref205) {
      var resolvedRoles = _ref205.resolvedRoles;

      var baseProps = {
        width: "16px",
        height: "16px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(EditProfile16SVG, propsClone);
    }
  );
};

var Edit16 = function Edit16(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref206) {
      var resolvedRoles = _ref206.resolvedRoles;

      var baseProps = {
        width: "16px",
        height: "16px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(Edit16SVG, propsClone);
    }
  );
};

var Education16 = function Education16(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref207) {
      var resolvedRoles = _ref207.resolvedRoles;

      var baseProps = {
        width: "16px",
        height: "16px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(Education16SVG, propsClone);
    }
  );
};

var Error16 = function Error16(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref208) {
      var resolvedRoles = _ref208.resolvedRoles;

      var baseProps = {
        width: "16px",
        height: "16px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(Error16SVG, propsClone);
    }
  );
};

var ExpandPanel16 = function ExpandPanel16(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref209) {
      var resolvedRoles = _ref209.resolvedRoles;

      var baseProps = {
        width: "16px",
        height: "16px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(ExpandPanel16SVG, propsClone);
    }
  );
};

var ExportMove16 = function ExportMove16(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref210) {
      var resolvedRoles = _ref210.resolvedRoles;

      var baseProps = {
        width: "16px",
        height: "16px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(ExportMove16SVG, propsClone);
    }
  );
};

var ExternalLink16 = function ExternalLink16(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref211) {
      var resolvedRoles = _ref211.resolvedRoles;

      var baseProps = {
        width: "16px",
        height: "16px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(ExternalLink16SVG, propsClone);
    }
  );
};

var External16 = function External16(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref212) {
      var resolvedRoles = _ref212.resolvedRoles;

      var baseProps = {
        width: "16px",
        height: "16px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(External16SVG, propsClone);
    }
  );
};

var Favorite16 = function Favorite16(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref213) {
      var resolvedRoles = _ref213.resolvedRoles;

      var baseProps = {
        width: "16px",
        height: "16px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(Favorite16SVG, propsClone);
    }
  );
};

var Featured16 = function Featured16(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref214) {
      var resolvedRoles = _ref214.resolvedRoles;

      var baseProps = {
        width: "16px",
        height: "16px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(Featured16SVG, propsClone);
    }
  );
};

var Feedback16 = function Feedback16(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref215) {
      var resolvedRoles = _ref215.resolvedRoles;

      var baseProps = {
        width: "16px",
        height: "16px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(Feedback16SVG, propsClone);
    }
  );
};

var Field16 = function Field16(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref216) {
      var resolvedRoles = _ref216.resolvedRoles;

      var baseProps = {
        width: "16px",
        height: "16px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(Field16SVG, propsClone);
    }
  );
};

var FileAssembly16 = function FileAssembly16(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref217) {
      var resolvedRoles = _ref217.resolvedRoles;

      var baseProps = {
        width: "16px",
        height: "16px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(FileAssembly16SVG, propsClone);
    }
  );
};

var FileAudio16 = function FileAudio16(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref218) {
      var resolvedRoles = _ref218.resolvedRoles;

      var baseProps = {
        width: "16px",
        height: "16px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(FileAudio16SVG, propsClone);
    }
  );
};

var FileDocument16 = function FileDocument16(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref219) {
      var resolvedRoles = _ref219.resolvedRoles;

      var baseProps = {
        width: "16px",
        height: "16px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(FileDocument16SVG, propsClone);
    }
  );
};

var FileGeneric16 = function FileGeneric16(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref220) {
      var resolvedRoles = _ref220.resolvedRoles;

      var baseProps = {
        width: "16px",
        height: "16px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(FileGeneric16SVG, propsClone);
    }
  );
};

var FileImage16 = function FileImage16(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref221) {
      var resolvedRoles = _ref221.resolvedRoles;

      var baseProps = {
        width: "16px",
        height: "16px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(FileImage16SVG, propsClone);
    }
  );
};

var FilePart16 = function FilePart16(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref222) {
      var resolvedRoles = _ref222.resolvedRoles;

      var baseProps = {
        width: "16px",
        height: "16px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(FilePart16SVG, propsClone);
    }
  );
};

var FilePdf16 = function FilePdf16(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref223) {
      var resolvedRoles = _ref223.resolvedRoles;

      var baseProps = {
        width: "16px",
        height: "16px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(FilePdf16SVG, propsClone);
    }
  );
};

var FilePresentation16 = function FilePresentation16(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref224) {
      var resolvedRoles = _ref224.resolvedRoles;

      var baseProps = {
        width: "16px",
        height: "16px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(FilePresentation16SVG, propsClone);
    }
  );
};

var FileSpreadsheet16 = function FileSpreadsheet16(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref225) {
      var resolvedRoles = _ref225.resolvedRoles;

      var baseProps = {
        width: "16px",
        height: "16px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(FileSpreadsheet16SVG, propsClone);
    }
  );
};

var FileVideo16 = function FileVideo16(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref226) {
      var resolvedRoles = _ref226.resolvedRoles;

      var baseProps = {
        width: "16px",
        height: "16px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(FileVideo16SVG, propsClone);
    }
  );
};

var FileZip16 = function FileZip16(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref227) {
      var resolvedRoles = _ref227.resolvedRoles;

      var baseProps = {
        width: "16px",
        height: "16px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(FileZip16SVG, propsClone);
    }
  );
};

var FilterTokens16 = function FilterTokens16(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref228) {
      var resolvedRoles = _ref228.resolvedRoles;

      var baseProps = {
        width: "16px",
        height: "16px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(FilterTokens16SVG, propsClone);
    }
  );
};

var Filter16 = function Filter16(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref229) {
      var resolvedRoles = _ref229.resolvedRoles;

      var baseProps = {
        width: "16px",
        height: "16px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(Filter16SVG, propsClone);
    }
  );
};

var Flag16 = function Flag16(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref230) {
      var resolvedRoles = _ref230.resolvedRoles;

      var baseProps = {
        width: "16px",
        height: "16px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(Flag16SVG, propsClone);
    }
  );
};

var FolderOpen16 = function FolderOpen16(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref231) {
      var resolvedRoles = _ref231.resolvedRoles;

      var baseProps = {
        width: "16px",
        height: "16px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(FolderOpen16SVG, propsClone);
    }
  );
};

var Folder16 = function Folder16(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref232) {
      var resolvedRoles = _ref232.resolvedRoles;

      var baseProps = {
        width: "16px",
        height: "16px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(Folder16SVG, propsClone);
    }
  );
};

var Forums16 = function Forums16(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref233) {
      var resolvedRoles = _ref233.resolvedRoles;

      var baseProps = {
        width: "16px",
        height: "16px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(Forums16SVG, propsClone);
    }
  );
};

var Forward16 = function Forward16(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref234) {
      var resolvedRoles = _ref234.resolvedRoles;

      var baseProps = {
        width: "16px",
        height: "16px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(Forward16SVG, propsClone);
    }
  );
};

var Globe16 = function Globe16(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref235) {
      var resolvedRoles = _ref235.resolvedRoles;

      var baseProps = {
        width: "16px",
        height: "16px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(Globe16SVG, propsClone);
    }
  );
};

var Graph16 = function Graph16(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref236) {
      var resolvedRoles = _ref236.resolvedRoles;

      var baseProps = {
        width: "16px",
        height: "16px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(Graph16SVG, propsClone);
    }
  );
};

var Grid16 = function Grid16(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref237) {
      var resolvedRoles = _ref237.resolvedRoles;

      var baseProps = {
        width: "16px",
        height: "16px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(Grid16SVG, propsClone);
    }
  );
};

var Help16 = function Help16(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref238) {
      var resolvedRoles = _ref238.resolvedRoles;

      var baseProps = {
        width: "16px",
        height: "16px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(Help16SVG, propsClone);
    }
  );
};

var Hidden16 = function Hidden16(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref239) {
      var resolvedRoles = _ref239.resolvedRoles;

      var baseProps = {
        width: "16px",
        height: "16px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(Hidden16SVG, propsClone);
    }
  );
};

var Hierarchy16 = function Hierarchy16(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref240) {
      var resolvedRoles = _ref240.resolvedRoles;

      var baseProps = {
        width: "16px",
        height: "16px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(Hierarchy16SVG, propsClone);
    }
  );
};

var Home16 = function Home16(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref241) {
      var resolvedRoles = _ref241.resolvedRoles;

      var baseProps = {
        width: "16px",
        height: "16px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(Home16SVG, propsClone);
    }
  );
};

var Import16 = function Import16(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref242) {
      var resolvedRoles = _ref242.resolvedRoles;

      var baseProps = {
        width: "16px",
        height: "16px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(Import16SVG, propsClone);
    }
  );
};

var Inbox16 = function Inbox16(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref243) {
      var resolvedRoles = _ref243.resolvedRoles;

      var baseProps = {
        width: "16px",
        height: "16px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(Inbox16SVG, propsClone);
    }
  );
};

var Info16 = function Info16(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref244) {
      var resolvedRoles = _ref244.resolvedRoles;

      var baseProps = {
        width: "16px",
        height: "16px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(Info16SVG, propsClone);
    }
  );
};

var Item16 = function Item16(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref245) {
      var resolvedRoles = _ref245.resolvedRoles;

      var baseProps = {
        width: "16px",
        height: "16px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(Item16SVG, propsClone);
    }
  );
};

var Link16 = function Link16(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref246) {
      var resolvedRoles = _ref246.resolvedRoles;

      var baseProps = {
        width: "16px",
        height: "16px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(Link16SVG, propsClone);
    }
  );
};

var List16 = function List16(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref247) {
      var resolvedRoles = _ref247.resolvedRoles;

      var baseProps = {
        width: "16px",
        height: "16px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(List16SVG, propsClone);
    }
  );
};

var Location16 = function Location16(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref248) {
      var resolvedRoles = _ref248.resolvedRoles;

      var baseProps = {
        width: "16px",
        height: "16px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(Location16SVG, propsClone);
    }
  );
};

var Lock16 = function Lock16(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref249) {
      var resolvedRoles = _ref249.resolvedRoles;

      var baseProps = {
        width: "16px",
        height: "16px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(Lock16SVG, propsClone);
    }
  );
};

var Mail16 = function Mail16(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref250) {
      var resolvedRoles = _ref250.resolvedRoles;

      var baseProps = {
        width: "16px",
        height: "16px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(Mail16SVG, propsClone);
    }
  );
};

var ManageAccess16 = function ManageAccess16(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref251) {
      var resolvedRoles = _ref251.resolvedRoles;

      var baseProps = {
        width: "16px",
        height: "16px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(ManageAccess16SVG, propsClone);
    }
  );
};

var Maximize16 = function Maximize16(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref252) {
      var resolvedRoles = _ref252.resolvedRoles;

      var baseProps = {
        width: "16px",
        height: "16px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(Maximize16SVG, propsClone);
    }
  );
};

var Minimize16 = function Minimize16(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref253) {
      var resolvedRoles = _ref253.resolvedRoles;

      var baseProps = {
        width: "16px",
        height: "16px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(Minimize16SVG, propsClone);
    }
  );
};

var MoreVertical16 = function MoreVertical16(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref254) {
      var resolvedRoles = _ref254.resolvedRoles;

      var baseProps = {
        width: "16px",
        height: "16px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(MoreVertical16SVG, propsClone);
    }
  );
};

var More16 = function More16(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref255) {
      var resolvedRoles = _ref255.resolvedRoles;

      var baseProps = {
        width: "16px",
        height: "16px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(More16SVG, propsClone);
    }
  );
};

var Mute16 = function Mute16(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref256) {
      var resolvedRoles = _ref256.resolvedRoles;

      var baseProps = {
        width: "16px",
        height: "16px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(Mute16SVG, propsClone);
    }
  );
};

var NotEditable16 = function NotEditable16(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref257) {
      var resolvedRoles = _ref257.resolvedRoles;

      var baseProps = {
        width: "16px",
        height: "16px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(NotEditable16SVG, propsClone);
    }
  );
};

var NotificationOff16 = function NotificationOff16(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref258) {
      var resolvedRoles = _ref258.resolvedRoles;

      var baseProps = {
        width: "16px",
        height: "16px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(NotificationOff16SVG, propsClone);
    }
  );
};

var Notification16 = function Notification16(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref259) {
      var resolvedRoles = _ref259.resolvedRoles;

      var baseProps = {
        width: "16px",
        height: "16px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(Notification16SVG, propsClone);
    }
  );
};

var OnlineViewers16 = function OnlineViewers16(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref260) {
      var resolvedRoles = _ref260.resolvedRoles;

      var baseProps = {
        width: "16px",
        height: "16px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(OnlineViewers16SVG, propsClone);
    }
  );
};

var Paste16 = function Paste16(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref261) {
      var resolvedRoles = _ref261.resolvedRoles;

      var baseProps = {
        width: "16px",
        height: "16px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(Paste16SVG, propsClone);
    }
  );
};

var PermissionGroup16 = function PermissionGroup16(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref262) {
      var resolvedRoles = _ref262.resolvedRoles;

      var baseProps = {
        width: "16px",
        height: "16px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(PermissionGroup16SVG, propsClone);
    }
  );
};

var PermissionIndividual16 = function PermissionIndividual16(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref263) {
      var resolvedRoles = _ref263.resolvedRoles;

      var baseProps = {
        width: "16px",
        height: "16px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(PermissionIndividual16SVG, propsClone);
    }
  );
};

var Photos16 = function Photos16(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref264) {
      var resolvedRoles = _ref264.resolvedRoles;

      var baseProps = {
        width: "16px",
        height: "16px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(Photos16SVG, propsClone);
    }
  );
};

var Pin16 = function Pin16(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref265) {
      var resolvedRoles = _ref265.resolvedRoles;

      var baseProps = {
        width: "16px",
        height: "16px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(Pin16SVG, propsClone);
    }
  );
};

var Placeholder16 = function Placeholder16(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref266) {
      var resolvedRoles = _ref266.resolvedRoles;

      var baseProps = {
        width: "16px",
        height: "16px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(Placeholder16SVG, propsClone);
    }
  );
};

var PlaybackFastForward16 = function PlaybackFastForward16(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref267) {
      var resolvedRoles = _ref267.resolvedRoles;

      var baseProps = {
        width: "16px",
        height: "16px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(PlaybackFastForward16SVG, propsClone);
    }
  );
};

var PlaybackGoToEnd16 = function PlaybackGoToEnd16(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref268) {
      var resolvedRoles = _ref268.resolvedRoles;

      var baseProps = {
        width: "16px",
        height: "16px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(PlaybackGoToEnd16SVG, propsClone);
    }
  );
};

var PlaybackGoToStart16 = function PlaybackGoToStart16(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref269) {
      var resolvedRoles = _ref269.resolvedRoles;

      var baseProps = {
        width: "16px",
        height: "16px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(PlaybackGoToStart16SVG, propsClone);
    }
  );
};

var PlaybackLoop16 = function PlaybackLoop16(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref270) {
      var resolvedRoles = _ref270.resolvedRoles;

      var baseProps = {
        width: "16px",
        height: "16px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(PlaybackLoop16SVG, propsClone);
    }
  );
};

var PlaybackNext16 = function PlaybackNext16(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref271) {
      var resolvedRoles = _ref271.resolvedRoles;

      var baseProps = {
        width: "16px",
        height: "16px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(PlaybackNext16SVG, propsClone);
    }
  );
};

var PlaybackPause16 = function PlaybackPause16(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref272) {
      var resolvedRoles = _ref272.resolvedRoles;

      var baseProps = {
        width: "16px",
        height: "16px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(PlaybackPause16SVG, propsClone);
    }
  );
};

var PlaybackPlay16 = function PlaybackPlay16(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref273) {
      var resolvedRoles = _ref273.resolvedRoles;

      var baseProps = {
        width: "16px",
        height: "16px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(PlaybackPlay16SVG, propsClone);
    }
  );
};

var PlaybackPrevious16 = function PlaybackPrevious16(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref274) {
      var resolvedRoles = _ref274.resolvedRoles;

      var baseProps = {
        width: "16px",
        height: "16px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(PlaybackPrevious16SVG, propsClone);
    }
  );
};

var PlaybackRecord16 = function PlaybackRecord16(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref275) {
      var resolvedRoles = _ref275.resolvedRoles;

      var baseProps = {
        width: "16px",
        height: "16px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(PlaybackRecord16SVG, propsClone);
    }
  );
};

var PlaybackRewind16 = function PlaybackRewind16(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref276) {
      var resolvedRoles = _ref276.resolvedRoles;

      var baseProps = {
        width: "16px",
        height: "16px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(PlaybackRewind16SVG, propsClone);
    }
  );
};

var PlaybackShuffle16 = function PlaybackShuffle16(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref277) {
      var resolvedRoles = _ref277.resolvedRoles;

      var baseProps = {
        width: "16px",
        height: "16px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(PlaybackShuffle16SVG, propsClone);
    }
  );
};

var PlaybackStop16 = function PlaybackStop16(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref278) {
      var resolvedRoles = _ref278.resolvedRoles;

      var baseProps = {
        width: "16px",
        height: "16px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(PlaybackStop16SVG, propsClone);
    }
  );
};

var Print16 = function Print16(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref279) {
      var resolvedRoles = _ref279.resolvedRoles;

      var baseProps = {
        width: "16px",
        height: "16px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(Print16SVG, propsClone);
    }
  );
};

var ProductsAndServices16 = function ProductsAndServices16(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref280) {
      var resolvedRoles = _ref280.resolvedRoles;

      var baseProps = {
        width: "16px",
        height: "16px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(ProductsAndServices16SVG, propsClone);
    }
  );
};

var Profile16 = function Profile16(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref281) {
      var resolvedRoles = _ref281.resolvedRoles;

      var baseProps = {
        width: "16px",
        height: "16px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(Profile16SVG, propsClone);
    }
  );
};

var ProjectManagement16 = function ProjectManagement16(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref282) {
      var resolvedRoles = _ref282.resolvedRoles;

      var baseProps = {
        width: "16px",
        height: "16px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(ProjectManagement16SVG, propsClone);
    }
  );
};

var Properties16 = function Properties16(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref283) {
      var resolvedRoles = _ref283.resolvedRoles;

      var baseProps = {
        width: "16px",
        height: "16px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(Properties16SVG, propsClone);
    }
  );
};

var Publish16 = function Publish16(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref284) {
      var resolvedRoles = _ref284.resolvedRoles;

      var baseProps = {
        width: "16px",
        height: "16px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(Publish16SVG, propsClone);
    }
  );
};

var Quantities16 = function Quantities16(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref285) {
      var resolvedRoles = _ref285.resolvedRoles;

      var baseProps = {
        width: "16px",
        height: "16px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(Quantities16SVG, propsClone);
    }
  );
};

var Recommend16 = function Recommend16(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref286) {
      var resolvedRoles = _ref286.resolvedRoles;

      var baseProps = {
        width: "16px",
        height: "16px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(Recommend16SVG, propsClone);
    }
  );
};

var Redo16 = function Redo16(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref287) {
      var resolvedRoles = _ref287.resolvedRoles;

      var baseProps = {
        width: "16px",
        height: "16px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(Redo16SVG, propsClone);
    }
  );
};

var Report16 = function Report16(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref288) {
      var resolvedRoles = _ref288.resolvedRoles;

      var baseProps = {
        width: "16px",
        height: "16px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(Report16SVG, propsClone);
    }
  );
};

var SaveAs16 = function SaveAs16(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref289) {
      var resolvedRoles = _ref289.resolvedRoles;

      var baseProps = {
        width: "16px",
        height: "16px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(SaveAs16SVG, propsClone);
    }
  );
};

var Save16 = function Save16(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref290) {
      var resolvedRoles = _ref290.resolvedRoles;

      var baseProps = {
        width: "16px",
        height: "16px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(Save16SVG, propsClone);
    }
  );
};

var Search16 = function Search16(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref291) {
      var resolvedRoles = _ref291.resolvedRoles;

      var baseProps = {
        width: "16px",
        height: "16px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(Search16SVG, propsClone);
    }
  );
};

var Security16 = function Security16(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref292) {
      var resolvedRoles = _ref292.resolvedRoles;

      var baseProps = {
        width: "16px",
        height: "16px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(Security16SVG, propsClone);
    }
  );
};

var SelectAll16 = function SelectAll16(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref293) {
      var resolvedRoles = _ref293.resolvedRoles;

      var baseProps = {
        width: "16px",
        height: "16px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(SelectAll16SVG, propsClone);
    }
  );
};

var SelectNone16 = function SelectNone16(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref294) {
      var resolvedRoles = _ref294.resolvedRoles;

      var baseProps = {
        width: "16px",
        height: "16px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(SelectNone16SVG, propsClone);
    }
  );
};

var Service16 = function Service16(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref295) {
      var resolvedRoles = _ref295.resolvedRoles;

      var baseProps = {
        width: "16px",
        height: "16px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(Service16SVG, propsClone);
    }
  );
};

var Settings16 = function Settings16(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref296) {
      var resolvedRoles = _ref296.resolvedRoles;

      var baseProps = {
        width: "16px",
        height: "16px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(Settings16SVG, propsClone);
    }
  );
};

var Share16 = function Share16(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref297) {
      var resolvedRoles = _ref297.resolvedRoles;

      var baseProps = {
        width: "16px",
        height: "16px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(Share16SVG, propsClone);
    }
  );
};

var SocialBlog16 = function SocialBlog16(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref298) {
      var resolvedRoles = _ref298.resolvedRoles;

      var baseProps = {
        width: "16px",
        height: "16px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(SocialBlog16SVG, propsClone);
    }
  );
};

var SocialFacebook16 = function SocialFacebook16(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref299) {
      var resolvedRoles = _ref299.resolvedRoles;

      var baseProps = {
        width: "16px",
        height: "16px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(SocialFacebook16SVG, propsClone);
    }
  );
};

var SocialInstagram16 = function SocialInstagram16(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref300) {
      var resolvedRoles = _ref300.resolvedRoles;

      var baseProps = {
        width: "16px",
        height: "16px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(SocialInstagram16SVG, propsClone);
    }
  );
};

var SocialLinkedin16 = function SocialLinkedin16(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref301) {
      var resolvedRoles = _ref301.resolvedRoles;

      var baseProps = {
        width: "16px",
        height: "16px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(SocialLinkedin16SVG, propsClone);
    }
  );
};

var SocialTwitter16 = function SocialTwitter16(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref302) {
      var resolvedRoles = _ref302.resolvedRoles;

      var baseProps = {
        width: "16px",
        height: "16px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(SocialTwitter16SVG, propsClone);
    }
  );
};

var SocialYoutube16 = function SocialYoutube16(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref303) {
      var resolvedRoles = _ref303.resolvedRoles;

      var baseProps = {
        width: "16px",
        height: "16px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(SocialYoutube16SVG, propsClone);
    }
  );
};

var Sort16 = function Sort16(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref304) {
      var resolvedRoles = _ref304.resolvedRoles;

      var baseProps = {
        width: "16px",
        height: "16px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(Sort16SVG, propsClone);
    }
  );
};

var Subscription16 = function Subscription16(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref305) {
      var resolvedRoles = _ref305.resolvedRoles;

      var baseProps = {
        width: "16px",
        height: "16px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(Subscription16SVG, propsClone);
    }
  );
};

var Support16 = function Support16(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref306) {
      var resolvedRoles = _ref306.resolvedRoles;

      var baseProps = {
        width: "16px",
        height: "16px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(Support16SVG, propsClone);
    }
  );
};

var SurveyEquipment16 = function SurveyEquipment16(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref307) {
      var resolvedRoles = _ref307.resolvedRoles;

      var baseProps = {
        width: "16px",
        height: "16px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(SurveyEquipment16SVG, propsClone);
    }
  );
};

var Sync16 = function Sync16(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref308) {
      var resolvedRoles = _ref308.resolvedRoles;

      var baseProps = {
        width: "16px",
        height: "16px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(Sync16SVG, propsClone);
    }
  );
};

var Tag16 = function Tag16(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref309) {
      var resolvedRoles = _ref309.resolvedRoles;

      var baseProps = {
        width: "16px",
        height: "16px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(Tag16SVG, propsClone);
    }
  );
};

var Trash16 = function Trash16(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref310) {
      var resolvedRoles = _ref310.resolvedRoles;

      var baseProps = {
        width: "16px",
        height: "16px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(Trash16SVG, propsClone);
    }
  );
};

var TreeView16 = function TreeView16(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref311) {
      var resolvedRoles = _ref311.resolvedRoles;

      var baseProps = {
        width: "16px",
        height: "16px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      return React.createElement(TreeView16SVG, propsClone);
    }
  );
};

var Unavailable16 = function Unavailable16(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref312) {
      var resolvedRoles = _ref312.resolvedRoles;

      var baseProps = {
        width: "16px",
        height: "16px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(Unavailable16SVG, propsClone);
    }
  );
};

var Undo16 = function Undo16(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref313) {
      var resolvedRoles = _ref313.resolvedRoles;

      var baseProps = {
        width: "16px",
        height: "16px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(Undo16SVG, propsClone);
    }
  );
};

var Unlink16 = function Unlink16(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref314) {
      var resolvedRoles = _ref314.resolvedRoles;

      var baseProps = {
        width: "16px",
        height: "16px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(Unlink16SVG, propsClone);
    }
  );
};

var Unlock16 = function Unlock16(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref315) {
      var resolvedRoles = _ref315.resolvedRoles;

      var baseProps = {
        width: "16px",
        height: "16px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(Unlock16SVG, propsClone);
    }
  );
};

var Unpin16 = function Unpin16(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref316) {
      var resolvedRoles = _ref316.resolvedRoles;

      var baseProps = {
        width: "16px",
        height: "16px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(Unpin16SVG, propsClone);
    }
  );
};

var Up16 = function Up16(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref317) {
      var resolvedRoles = _ref317.resolvedRoles;

      var baseProps = {
        width: "16px",
        height: "16px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(Up16SVG, propsClone);
    }
  );
};

var Upload16 = function Upload16(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref318) {
      var resolvedRoles = _ref318.resolvedRoles;

      var baseProps = {
        width: "16px",
        height: "16px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(Upload16SVG, propsClone);
    }
  );
};

var UserInactive16 = function UserInactive16(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref319) {
      var resolvedRoles = _ref319.resolvedRoles;

      var baseProps = {
        width: "16px",
        height: "16px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(UserInactive16SVG, propsClone);
    }
  );
};

var Visible16 = function Visible16(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref320) {
      var resolvedRoles = _ref320.resolvedRoles;

      var baseProps = {
        width: "16px",
        height: "16px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(Visible16SVG, propsClone);
    }
  );
};

var Volume16 = function Volume16(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref321) {
      var resolvedRoles = _ref321.resolvedRoles;

      var baseProps = {
        width: "16px",
        height: "16px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(Volume16SVG, propsClone);
    }
  );
};

var ZoomIn16 = function ZoomIn16(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref322) {
      var resolvedRoles = _ref322.resolvedRoles;

      var baseProps = {
        width: "16px",
        height: "16px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(ZoomIn16SVG, propsClone);
    }
  );
};

var ZoomOut16 = function ZoomOut16(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref323) {
      var resolvedRoles = _ref323.resolvedRoles;

      var baseProps = {
        width: "16px",
        height: "16px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(ZoomOut16SVG, propsClone);
    }
  );
};

var CaretDownMUI = function CaretDownMUI(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref324) {
      var resolvedRoles = _ref324.resolvedRoles;

      var baseProps = {
        width: "10px",
        height: "10px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(CaretDownMUISVG, propsClone);
    }
  );
};

var CaretDownSUI = function CaretDownSUI(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref325) {
      var resolvedRoles = _ref325.resolvedRoles;

      var baseProps = {
        width: "7px",
        height: "4px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(CaretDownSUISVG, propsClone);
    }
  );
};

var CaretDownXsUI = function CaretDownXsUI(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref326) {
      var resolvedRoles = _ref326.resolvedRoles;

      var baseProps = {
        width: "5px",
        height: "3px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(CaretDownXsUISVG, propsClone);
    }
  );
};

var CaretLeftMUI = function CaretLeftMUI(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref327) {
      var resolvedRoles = _ref327.resolvedRoles;

      var baseProps = {
        width: "10px",
        height: "10px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(CaretLeftMUISVG, propsClone);
    }
  );
};

var CaretLeftSUI = function CaretLeftSUI(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref328) {
      var resolvedRoles = _ref328.resolvedRoles;

      var baseProps = {
        width: "4px",
        height: "7px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(CaretLeftSUISVG, propsClone);
    }
  );
};

var CaretLeftXsUI = function CaretLeftXsUI(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref329) {
      var resolvedRoles = _ref329.resolvedRoles;

      var baseProps = {
        width: "3px",
        height: "5px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(CaretLeftXsUISVG, propsClone);
    }
  );
};

var CaretRightMUI = function CaretRightMUI(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref330) {
      var resolvedRoles = _ref330.resolvedRoles;

      var baseProps = {
        width: "10px",
        height: "10px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(CaretRightMUISVG, propsClone);
    }
  );
};

var CaretRightSUI = function CaretRightSUI(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref331) {
      var resolvedRoles = _ref331.resolvedRoles;

      var baseProps = {
        width: "4px",
        height: "7px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(CaretRightSUISVG, propsClone);
    }
  );
};

var CaretRightXsUI = function CaretRightXsUI(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref332) {
      var resolvedRoles = _ref332.resolvedRoles;

      var baseProps = {
        width: "3px",
        height: "5px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(CaretRightXsUISVG, propsClone);
    }
  );
};

var CaretUpMUI = function CaretUpMUI(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref333) {
      var resolvedRoles = _ref333.resolvedRoles;

      var baseProps = {
        width: "10px",
        height: "10px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(CaretUpMUISVG, propsClone);
    }
  );
};

var CaretUpSUI = function CaretUpSUI(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref334) {
      var resolvedRoles = _ref334.resolvedRoles;

      var baseProps = {
        width: "7px",
        height: "4px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(CaretUpSUISVG, propsClone);
    }
  );
};

var CaretUpXsUI = function CaretUpXsUI(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref335) {
      var resolvedRoles = _ref335.resolvedRoles;

      var baseProps = {
        width: "5px",
        height: "3px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(CaretUpXsUISVG, propsClone);
    }
  );
};

var CheckmarkSUI = function CheckmarkSUI(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref336) {
      var resolvedRoles = _ref336.resolvedRoles;

      var baseProps = {
        width: "16px",
        height: "16px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(CheckmarkSUISVG, propsClone);
    }
  );
};

var CheckmarkXsUI = function CheckmarkXsUI(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref337) {
      var resolvedRoles = _ref337.resolvedRoles;

      var baseProps = {
        width: "16px",
        height: "16px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(CheckmarkXsUISVG, propsClone);
    }
  );
};

var CloseLUI = function CloseLUI(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref338) {
      var resolvedRoles = _ref338.resolvedRoles;

      var baseProps = {
        width: "16px",
        height: "16px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(CloseLUISVG, propsClone);
    }
  );
};

var CloseMUI = function CloseMUI(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref339) {
      var resolvedRoles = _ref339.resolvedRoles;

      var baseProps = {
        width: "16px",
        height: "16px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(CloseMUISVG, propsClone);
    }
  );
};

var CloseSUI = function CloseSUI(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref340) {
      var resolvedRoles = _ref340.resolvedRoles;

      var baseProps = {
        width: "16px",
        height: "16px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(CloseSUISVG, propsClone);
    }
  );
};

var CloseXsUI = function CloseXsUI(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref341) {
      var resolvedRoles = _ref341.resolvedRoles;

      var baseProps = {
        width: "16px",
        height: "16px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(CloseXsUISVG, propsClone);
    }
  );
};

var HamburgerCloseUI = function HamburgerCloseUI(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref342) {
      var resolvedRoles = _ref342.resolvedRoles;

      var baseProps = {
        width: "16px",
        height: "16px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(HamburgerCloseUISVG, propsClone);
    }
  );
};

var HamburgerDefaultUI = function HamburgerDefaultUI(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref343) {
      var resolvedRoles = _ref343.resolvedRoles;

      var baseProps = {
        width: "16px",
        height: "16px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(HamburgerDefaultUISVG, propsClone);
    }
  );
};

var OperatorMinusSUI = function OperatorMinusSUI(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref344) {
      var resolvedRoles = _ref344.resolvedRoles;

      var baseProps = {
        width: "16px",
        height: "16px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(OperatorMinusSUISVG, propsClone);
    }
  );
};

var OperatorMinusXsUI = function OperatorMinusXsUI(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref345) {
      var resolvedRoles = _ref345.resolvedRoles;

      var baseProps = {
        width: "16px",
        height: "16px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(OperatorMinusXsUISVG, propsClone);
    }
  );
};

var OperatorPlusSUI = function OperatorPlusSUI(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref346) {
      var resolvedRoles = _ref346.resolvedRoles;

      var baseProps = {
        width: "16px",
        height: "16px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(OperatorPlusSUISVG, propsClone);
    }
  );
};

var OperatorPlusXsUI = function OperatorPlusXsUI(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref347) {
      var resolvedRoles = _ref347.resolvedRoles;

      var baseProps = {
        width: "16px",
        height: "16px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      if (props.stylesheet) delete propsClone.stylesheet;
      return React.createElement(OperatorPlusXsUISVG, propsClone);
    }
  );
};

var Alert12 = function Alert12(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref348) {
      var resolvedRoles = _ref348.resolvedRoles;

      var baseProps = {
        width: "12px",
        height: "12px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      return React.createElement(Alert12SVG, propsClone);
    }
  );
};

var Complete12 = function Complete12(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref349) {
      var resolvedRoles = _ref349.resolvedRoles;

      var baseProps = {
        width: "12px",
        height: "12px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      return React.createElement(Complete12SVG, propsClone);
    }
  );
};

var Error12 = function Error12(props) {
  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref350) {
      var resolvedRoles = _ref350.resolvedRoles;

      var baseProps = {
        width: "12px",
        height: "12px"
      };
      var propsClone = Object.assign(baseProps, props, { className: cx(css(stylesheet(props, resolvedRoles)), props.className) });
      return React.createElement(Error12SVG, propsClone);
    }
  );
};

/* eslint-enable */

export { AVAILABLE_NAMES, names, higIconSets as sets, sizes, AVAILABLE_SIZES, AddFolder24, AddMember24, AddPage24, Add24, Alert24, Archive24, AreaPost24, Attach24, Attachment24, Back24, BillStack24, Billing24, Bookmark24, Building24, Calendar24, CaretDown24, CaretLeft24, CaretRight24, CaretUp24, CartEmpty24, CartFull24, Chat24, Checklist24, Checkmark24, Clock24, ClosedCaptioning24, Cloud24, Collaboration24, CollapsePanel24, Comment24, Compare24, Complete24, Copy24, CtaArrowRight24, Dashboard24, DeviceDesktop24, DeviceMobile24, DeviceTablet24, Devices24, DocumentManagement24, Down24, Download24, EditProfile24, Edit24, Education24, Error24, ExpandPanel24, ExportMove24, ExternalLink24, External24, Favorite24, Featured24, Feedback24, Field24, FileAssembly24, FileAudio24, FileDocument24, FileGeneric24, FileImage24, FilePart24, FilePdf24, FilePresentation24, FileSpreadsheet24, FileVideo24, FileZip24, FilterTokens24, Filter24, Flag24, FolderOpen24, Folder24, Forums24, Forward24, Globe24, Graph24, Grid24, Help24, Hidden24, Hierarchy24, Home24, Import24, Inbox24, Info24, Item24, Link24, List24, Location24, Lock24, Mail24, ManageAccess24, Maximize24, Minimize24, MoreVertical24, More24, Mute24, NotEditable24, NotificationOff24, Notification24, OnlineViewers24, Paste24, PermissionGroup24, PermissionIndividual24, Photos24, Pin24, Placeholder24, PlaybackFastForward24, PlaybackGoToEnd24, PlaybackGoToStart24, PlaybackLoop24, PlaybackNext24, PlaybackPause24, PlaybackPlay24, PlaybackPrevious24, PlaybackRecord24, PlaybackRewind24, PlaybackShuffle24, PlaybackStop24, Print24, ProductsAndServices24, Profile24, ProjectManagement24, Properties24, Publish24, Quantities24, Recommend24, Redo24, Report24, SaveAs24, Save24, Search24, Security24, SelectAll24, SelectNone24, Service24, Settings24, Share24, SocialBlog24, SocialFacebook24, SocialInstagram24, SocialLinkedin24, SocialTwitter24, SocialYoutube24, Sort24, Subscription24, Support24, SurveyEquipment24, Sync24, Tag24, Trash24, TreeView24, Unavailable24, Undo24, Unlink24, Unlock24, Unpin24, Up24, Upload24, UserInactive24, Visible24, Volume24, ZoomIn24, ZoomOut24, AddFolder16, AddMember16, AddPage16, Add16, Alert16, Archive16, AreaPost16, Attach16, Attachment16, Back1616, Back16, BillStack16, Billing16, Bookmark16, Building16, Calendar16, CaretDown16, CaretLeft16, CaretRight16, CaretUp16, CartEmpty16, CartFull16, Chat16, Checklist16, Checkmark16, Clock16, ClosedCaptioning16, Cloud16, Collaboration16, CollapsePanel16, Comment16, Compare16, Complete16, Copy16, CtaArrowRight16, Dashboard16, DeviceDesktop16, DeviceMobile16, DeviceTablet16, Devices16, DocumentManagement16, Down16, Download16, EditProfile16, Edit16, Education16, Error16, ExpandPanel16, ExportMove16, ExternalLink16, External16, Favorite16, Featured16, Feedback16, Field16, FileAssembly16, FileAudio16, FileDocument16, FileGeneric16, FileImage16, FilePart16, FilePdf16, FilePresentation16, FileSpreadsheet16, FileVideo16, FileZip16, FilterTokens16, Filter16, Flag16, FolderOpen16, Folder16, Forums16, Forward16, Globe16, Graph16, Grid16, Help16, Hidden16, Hierarchy16, Home16, Import16, Inbox16, Info16, Item16, Link16, List16, Location16, Lock16, Mail16, ManageAccess16, Maximize16, Minimize16, MoreVertical16, More16, Mute16, NotEditable16, NotificationOff16, Notification16, OnlineViewers16, Paste16, PermissionGroup16, PermissionIndividual16, Photos16, Pin16, Placeholder16, PlaybackFastForward16, PlaybackGoToEnd16, PlaybackGoToStart16, PlaybackLoop16, PlaybackNext16, PlaybackPause16, PlaybackPlay16, PlaybackPrevious16, PlaybackRecord16, PlaybackRewind16, PlaybackShuffle16, PlaybackStop16, Print16, ProductsAndServices16, Profile16, ProjectManagement16, Properties16, Publish16, Quantities16, Recommend16, Redo16, Report16, SaveAs16, Save16, Search16, Security16, SelectAll16, SelectNone16, Service16, Settings16, Share16, SocialBlog16, SocialFacebook16, SocialInstagram16, SocialLinkedin16, SocialTwitter16, SocialYoutube16, Sort16, Subscription16, Support16, SurveyEquipment16, Sync16, Tag16, Trash16, TreeView16, Unavailable16, Undo16, Unlink16, Unlock16, Unpin16, Up16, Upload16, UserInactive16, Visible16, Volume16, ZoomIn16, ZoomOut16, CaretDownMUI, CaretDownSUI, CaretDownXsUI, CaretLeftMUI, CaretLeftSUI, CaretLeftXsUI, CaretRightMUI, CaretRightSUI, CaretRightXsUI, CaretUpMUI, CaretUpSUI, CaretUpXsUI, CheckmarkSUI, CheckmarkXsUI, CloseLUI, CloseMUI, CloseSUI, CloseXsUI, HamburgerCloseUI, HamburgerDefaultUI, OperatorMinusSUI, OperatorMinusXsUI, OperatorPlusSUI, OperatorPlusXsUI, Alert12, Complete12, Error12 };
